/**
 * @fileoverview Arquivo responsável por definir as traduções em espanhol da aplicação.
 */

const messages = {
  es: {
    translations: {
      selectLanguage: "Seleccione un idioma",
      triageNotice: {
        message: "La OS {{number}} llegó para un cliente que usted está atendiendo. El triaje \"{{name}}\" está esperando: entréguelo a la IA cuando quiera.",
        open: "Abrir conversación",
      },
      billingStatusBanner: {
        overdue: "Pago pendiente: paga hasta el {{date}} para que el envío de mensajes no se detenga.",
        overdueInternal: "Pago pendiente: paga hasta el {{date}} para que el Chat Interno no se detenga.",
        overdueNoDeadline: "Pago pendiente: hay una factura vencida sin pagar.",
        suspendedAdmin: "El envío de mensajes y el Chat Interno están suspendidos por un pago pendiente.",
        suspendedMember: "El envío de mensajes y el Chat Interno están suspendidos por un pago pendiente. Habla con el administrador de la empresa.",
        suspendedInternalAdmin: "El Chat Interno está suspendido por un pago pendiente.",
        suspendedInternalMember: "El Chat Interno está suspendido por un pago pendiente. Habla con el administrador de la empresa.",
        pay: "Pagar ahora",
        adequacyDue: "Una condición del plan terminó: elija qué queda hasta el {{date}}, o el acceso quedará restringido hasta la elección.",
        choose: "Elegir qué queda",
        close: "Cerrar hasta mañana",
      },
      messageUsageBanner: {
        commonNear: "Ya se usó el {{percent}}% de los mensajes del mes ({{used}} de {{limit}}). Se renueva el {{date}}.",
        commonFull: "Los mensajes del mes se agotaron. Agentes y automatizaciones vuelven a enviar el {{date}}, o antes con un plan mayor.",
        aiNear: "La IA ya usó el {{percent}}% de sus mensajes del mes ({{used}} de {{limit}}). Se renueva el {{date}}.",
        aiFull: "Los mensajes de la IA se agotaron. Hasta el {{date}}, las conversaciones de la IA van a los agentes. Un paquete mayor de IA las libera antes.",
        close: "Cerrar aviso",
      },
      noResponseAlert: {
        messageOne:
          "Atención: 1 conversación esperando respuesta desde hace más de 10 minutos.",
        messageMany:
          "Atención: {{count}} conversaciones esperando respuesta desde hace más de 10 minutos.",
        action: "Ver Conversaciones Pendientes",
      },
      signup: {
        title: "Regístrate",
        toasts: {
          success: "¡Usuario creado con éxito! ¡Inicia sesión!!!",
          fail: "Error al crear usuario. Verifica los datos ingresados.",
        },
        form: {
          name: "Nombre de la empresa",
          email: "Correo electrónico",
          phone: "Teléfono con (código de área)",
          plan: "Plan",
          password: "Contraseña",
        },
        formErrors: {
          name: {
            required: "El nombre de la empresa es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          password: {
            short: "Contraseña demasiado corta",
            long: "Contraseña demasiado larga",
          },
          email: {
            required: "El correo electrónico es obligatorio",
            invalid: "Correo electrónico inválido",
          },
        },
        buttons: {
          submit: "Registrar",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
        plan: {
          attendant: "Asistente",
          whatsapp: "WhatsApp",
          queues: "Colas",
        },
      },
      login: {
        title: "Iniciar sesión",
        form: {
          email: "Correo electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Iniciar sesión",
          submitting: "Iniciando sesión...",
          register: "¡Regístrate ahora mismo!",
        },
        errors: {
          emailRequired: "El correo es obligatorio",
          emailInvalid: "Correo inválido",
          passwordRequired: "La contraseña es obligatoria",
        },
        capsLockOn: "Bloq Mayús activado",
      },
      mfa: {
        setup: {
          title: "Configurar autenticación en dos pasos",
          scanQr: "Escanea el QR con Google Authenticator, Duo Mobile u otra app compatible.",
          manualSecret: "¿No puedes escanear? Usa este código manualmente:",
          next: "Siguiente",
          back: "Volver",
          confirmOtp: "Introduce el código de 6 dígitos de la app:",
          confirm: "Confirmar",
          backupTitle: "Códigos de recuperación",
          backupHint: "Guárdalos en un lugar seguro. Cada código es de un solo uso y reemplaza la app si pierdes el teléfono.",
          copyAll: "Copiar todo",
          download: "Descargar .txt",
          savedAck: "He guardado mis códigos de forma segura",
          oneTimeWarning: "Estos códigos se mostrarán una sola vez.",
          finish: "Finalizar",
          cancel: "Cancelar",
          copied: "Códigos copiados",
        },
        login: {
          title: "Verificación en dos pasos",
          otpLabel: "Código de la app autenticadora",
          otpHint: "Introduce el código de 6 dígitos de tu app.",
          backupLabel: "Código de recuperación",
          backupHint: "Usa uno de los códigos de recuperación que guardaste.",
          verify: "Verificar",
          useBackup: "Código de recuperación",
          useOtp: "Usar app autenticadora",
          backToPassword: "Volver",
        },
        policy: {
          title: "Autenticación en dos pasos del equipo",
          modeOff: "Desactivado",
          modeOptional: "Opcional",
          modeRequired: "Obligatorio",
          gracePeriod: "Plazo para configurar (días)",
          save: "Guardar",
          saved: "Política actualizada",
        },
        profile: {
          menuItem: "Autenticación en dos pasos",
          statusEnabled: "Activa desde {{date}}",
          statusDisabled: "No configurada",
          enable: "Activar",
          disable: "Desactivar",
          disableConfirm: "Confirma con el código actual para desactivar MFA",
          adminReset: "Resetear MFA del usuario",
          adminResetConfirm: "¿Seguro? El usuario tendrá que reconfigurar la app en el próximo login.",
          adminResetDone: "MFA reseteado",
          enabledDesc: "Tu cuenta está protegida: en cada inicio de sesión necesitas el código de la app autenticadora.",
          disabledDesc: "Activa la autenticación en dos pasos para reforzar la seguridad de tu cuenta. Necesitarás una app como Google Authenticator o Duo Mobile.",
        },
        banner: {
          title: "Tu empresa requiere autenticación en dos pasos.",
          subtitle: "Configúrala en los próximos {{days}} día(s) para seguir accediendo.",
          cta: "Configurar ahora",
        },
        errors: {
          invalidOtp: "Código inválido o expirado",
          ticketExpired: "La sesión de verificación expiró. Vuelve a iniciar sesión.",
          backupUsed: "Código de recuperación ya usado",
        },
      },
      resetPassword: {
        title: "Restablecer Contraseña",
        toasts: {
          emailSent: "¡Correo enviado con éxito!",
          emailNotFound: "¡Correo electrónico no encontrado!",
          passwordUpdated: "¡Contraseña actualizada con éxito!",
        },
        formErrors: {
          email: {
            required: "El correo electrónico es obligatorio",
            invalid: "Correo electrónico inválido",
          },
          newPassword: {
            required: "La nueva contraseña es obligatoria",
            matches:
                "Tu contraseña debe tener al menos 8 caracteres, incluyendo una letra mayúscula, una minúscula y un número.",
          },
          confirmPassword: {
            required: "La confirmación de contraseña es obligatoria",
            matches: "Las contraseñas no coinciden",
          },
        },
        form: {
          email: "Correo electrónico",
          verificationCode: "Código de verificación",
          newPassword: "Nueva contraseña",
          confirmPassword: "Confirmar nueva contraseña",
        },
        buttons: {
          submitEmail: "Enviar correo",
          submitPassword: "Restablecer contraseña",
          back: "¿No tienes una cuenta? ¡Regístrate!",
        },
      },
      dashboard: {
        scope: {
          label: "Números de",
          company: "Esta cuenta",
          allMine: "Todos mis departamentos",
          units: "Mis unidades",
        },
        toasts: {
          selectFilterError: "Parametrice el filtro",
              userChartError: "Error al obtener información de la conversación",
              dateChartError: "Error al obtener información de la conversación",
              messagesPerUserError: "Error al cargar mensajes por usuario",
        },
        filters: {
          initialDate: "Fecha Inicial",
              finalDate: "Fecha Final",
              filterType: {
            title: "Tipo de Filtro",
                options: {
              perDate: "Filtro por Fecha",
                  perPeriod: "Filtro por Período",
            },
            helper: "Seleccione el tipo de filtro deseado",
          },
        },
        periodSelect: {
          title: "Período",
              options: {
            none: "Ninguno seleccionado",
                last3: "Últimos 3 días",
                last7: "Últimos 7 días",
                last15: "Últimos 15 días",
                last30: "Últimos 30 días",
                last60: "Últimos 60 días",
                last90: "Últimos 90 días",
          },
          helper: "Seleccione el período deseado",
        },
        counters: {
          inTalk: "En conversación",
              waiting: "En espera",
              finished: "Finalizados",
              newContacts: "Nuevos contactos",
              averageTalkTime: "T.M. de Conversación",
              averageWaitTime: "T.M. de Espera",
        },
        buttons: {
          filter: "Filtrar",
        },
        onlineTable: {
          ratingLabel: "1 - Insatisfecho, 2 - Satisfecho, 3 - Muy Satisfecho",
              name: "Nombre",
              ratings: "Evaluaciones",
              avgSupportTime: "T.M. de Atención",
              status: "Estado (Actual)",
        },
        charts: {
          user: {
            label: "Gráfico de Conversaciones",
                title: "Total de Conversaciones por Usuarios",
                start: "Inicio",
                end: "Fin",
                filter: "Filtrar",
          },
          date: {
            label: "Gráfico de Conversaciones",
                title: "Total",
                start: "Inicio",
                end: "Fin",
                filter: "Filtrar",
          },
        },
      },
      dashboardGeral: {
        title: "Panel del Grupo",
        subtitle: "Vista consolidada del grupo {{groupName}}",
        accountsCount: "{{count}} cuentas",
        cards: {
          active: "Atenciones Activas",
          pending: "Pendientes",
          noResponse: "Sin Respuesta +10min",
          noResponseRate: "Tasa sin respuesta",
          avgPerAttendant: "Promedio/Agente",
          art: "ART del Grupo",
        },
        table: {
          title: "Rendimiento por Cuenta",
          headers: {
            account: "Cuenta",
            active: "Activos",
            pending: "Pendientes",
            noResponse: "Sin Resp +10min",
            art: "ART",
            attendants: "Agentes",
          },
        },
        states: {
          loading: "Cargando panel del grupo...",
          empty: "No se encontraron cuentas en este grupo",
          error: "Error al cargar el panel. ¿Reintentar?",
        },
      },
      plans: {
        toasts: {
          errorList: "No fue posible cargar la lista de registros",
          errorOperation: "No fue posible realizar la operación",
          error: "No fue posible realizar la operación. Verifique si ya existe un plan con el mismo nombre o si los campos fueron completados correctamente",
          success: "¡Operación realizada con éxito!",
        },
        confirm: {
          title: "Eliminación de Registro",
          message: "¿Realmente desea eliminar el registro?",
        },
        buttons: {
          newCategory: "Nueva Categoría",
          newPlan: "Nuevo Plan",
        },
        modal: {
          editPlan: "Editar Plan",
          newPlan: "Nuevo Plan",
          newCategory: "Nueva Categoría",
          categoryName: "Nombre de la Categoría",
          categoryPlaceholder: "Ej: Premium, Enterprise, Starter",
          basicInfo: "Información Básica",
          emptyCategory: "Esta categoría está vacía. Haga clic en \"Nuevo Plan\" para agregar.",
        },
        labels: {
          plans: "Planes",
          plan: "plan",
          plansPlural: "planes",
        },
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Colas",
          value: "Valor",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "CRM",
          integrations: "Integraciones",
          campaigns: "Campañas",
          schedules: "Programaciones",
          leads: "CRM",
          enabled: "Habilitadas",
          disabled: "Deshabilitadas",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "$",
        },
      },
      boardShare: {
        open: "Compartir tablero",
        title: "Compartir tablero",
        description: "Permite que otras personas vean este tablero mediante un enlace seguro, sin necesidad de entrar a Sttelar Talk.",
        close: "Cerrar",
        back: "Volver",
        cancel: "Cancelar",
        newLink: "Nuevo enlace",
        listTitle: "Enlaces de este tablero ({{count}})",
        loadError: "No se pudieron cargar los enlaces.",
        retry: "Intentar de nuevo",
        empty: "Todavía no hay enlaces.",
        form: {
          name: "Nombre del enlace",
          namePlaceholder: "Ej.: Cliente Midea",
          nameHelp: "Para que sepas con quién lo compartiste.",
          nameRequired: "Ponle un nombre al enlace.",
          validity: "Validez",
          permanent: "Permanente",
          permanentHelp: "Funciona hasta que lo revoques.",
          temporary: "Temporal",
          presets: {
            "1h": "1 hora",
            "24h": "24 horas",
            "7d": "7 días",
            "30d": "30 días",
            custom: "Personalizado",
          },
          customDate: "Fecha y hora",
          expiresOn: "Deja de funcionar el {{date}}.",
          customRequired: "Elige la fecha y la hora.",
          customInvalid: "Elige una fecha entre 5 minutos y 1 año a partir de ahora.",
          protection: "Protección",
          password: "Exigir contraseña para acceder",
          passwordHint: "Recomendado cuando el tablero tiene datos de clientes.",
          passwordLabel: "Contraseña",
          passwordRule: "Mínimo 8 caracteres.",
          passwordTooShort: "La contraseña debe tener al menos 8 caracteres.",
          passwordTooLong: "La contraseña es demasiado larga.",
          generate: "Generar contraseña segura",
          show: "Mostrar contraseña",
          hide: "Ocultar contraseña",
          copyPassword: "Copiar contraseña",
          visibility: "Lo que muestra el enlace",
          visibilityBase: "Siempre: nombre de la tarjeta, etapa, prioridad, plazo, responsable y avance de las subtareas.",
          contactInfo: "Datos de contacto",
          contactInfoHelp: "Teléfono, correo, CPF (parcial) y dirección.",
          cardDetails: "Detalles de la tarjeta",
          cardDetailsHelp: "Campos personalizados, OS, descripción y subtareas.",
          never: "Los comentarios, adjuntos e historial nunca aparecen.",
          create: "Crear enlace",
          creating: "Creando...",
        },
        created: {
          newTitle: "Enlace creado",
          renewedTitle: "Nuevo enlace generado",
          newText: "Copia el enlace y envíalo a quien verá el tablero.",
          copyOnlyTitle: "Enlace compartido",
          copyOnlyText: "No se pudo copiar automáticamente. Selecciona la dirección de abajo y cópiala.",
          renewedText: "El enlace anterior dejó de funcionar. Envía este en su lugar.",
          link: "Enlace",
          copyLink: "Copiar",
          copiedShort: "Copiado",
          copied: "Enlace copiado",
          copyFailed: "No se pudo copiar. Selecciona el texto y cópialo.",
          passwordCopied: "Contraseña copiada",
          passwordNote: "Envía la contraseña por otro canal. No se mostrará de nuevo.",
          done: "Listo",
          seeLinks: "Ver enlaces",
        },
        row: {
          active: "Activo",
          expired: "Vencido",
          revoked: "Revocado",
          permanent: "Permanente",
          until: "Hasta el {{date}}",
          expiredOn: "Venció el {{date}}",
          revokedOn: "Revocado el {{date}}",
          revokedBy: "Revocado el {{date}} por {{name}}",
          withPassword: "Con contraseña",
          withoutPassword: "Sin contraseña",
          showsContact: "Muestra contacto",
          showsDetails: "Muestra detalles",
          createdBy: "Creado el {{date}} por {{name}}",
          createdAt: "Creado el {{date}}",
          lastAccess: "Último acceso el {{date}}",
          neverAccessed: "Todavía no se abrió",
          copyLink: "Copiar enlace",
          more: "Más acciones",
          setPassword: "Definir contraseña",
          changePassword: "Cambiar contraseña",
          changeValidity: "Cambiar validez",
          renew: "Generar nuevo enlace",
          revoke: "Revocar",
        },
        password: {
          title: "Contraseña del enlace",
          text: "Quien ya abrió el tablero tendrá que escribir la nueva contraseña.",
          save: "Guardar contraseña",
          remove: "Quitar contraseña",
          saved: "Contraseña guardada",
          removed: "Contraseña quitada",
        },
        validity: {
          title: "Validez del enlace",
          current: "Hoy es válido hasta el {{date}}.",
          currentPermanent: "Hoy es permanente.",
          text: "La nueva validez cuenta a partir de ahora.",
          save: "Guardar validez",
          saved: "Validez guardada",
        },
        renew: {
          title: "¿Generar un nuevo enlace?",
          text: "El enlace actual deja de funcionar al instante. Quien lo tenga necesitará el nuevo.",
          confirm: "Generar nuevo enlace",
        },
        revoke: {
          title: "¿Revocar el enlace?",
          text: "Quien tenga el enlace pierde el acceso al instante, y no se puede deshacer.",
          confirm: "Revocar",
          done: "Enlace revocado",
        },
        removePassword: {
          title: "¿Quitar la contraseña?",
          text: "Cualquier persona con el enlace podrá ver el tablero sin contraseña.",
          confirm: "Quitar contraseña",
        },
      },
      sharedBoard: {
        pageTitle: "Tablero compartido",
        eyebrow: "Tablero compartido",
        readOnly: "Modo de visualización — Solo lectura",
        readOnlyShort: "Solo lectura",
        updatedAt: "Actualizado a las {{time}}",
        validUntil: "Enlace válido hasta el {{date}}",
        refresh: "Actualizar",
        themeLight: "Tema claro",
        themeDark: "Tema oscuro",
        search: "Buscar tarjeta",
        allAssignees: "Todos los responsables",
        unassigned: "Sin responsable",
        noColumns: "Este tablero todavía no tiene etapas.",
        emptyColumn: "Sin tarjetas en esta etapa",
        truncated: "Mostrando las primeras {{count}} tarjetas.",
        offline: "Sin conexión ahora. Los datos pueden estar desactualizados.",
        loading: "Cargando el tablero",
        password: {
          title: "Tablero protegido",
          text: "Escribe la contraseña que recibiste para ver este tablero.",
          label: "Contraseña",
          submit: "Abrir tablero",
          wrong: "Contraseña incorrecta.",
          tooMany: "Demasiados intentos. Espera unos minutos e inténtalo de nuevo.",
          failed: "No se pudo entrar ahora. Inténtalo de nuevo.",
          cookies: "No se pudo mantener tu acceso en este navegador. Verifica que las cookies estén permitidas e inténtalo de nuevo.",
          sessionEnded: "La contraseña cambió o tu acceso terminó. Escribe la contraseña de nuevo.",
          show: "Mostrar contraseña",
          hide: "Ocultar contraseña",
        },
        status: {
          invalid: {
            title: "Enlace inválido",
            text: "Este enlace no existe o se copió incompleto. Consulta con quien lo compartió.",
          },
          expired: {
            title: "Enlace vencido",
            text: "Este enlace ya no está disponible. Pide uno nuevo a quien lo compartió.",
          },
          revoked: {
            title: "Acceso terminado",
            text: "Quien compartió este enlace lo terminó. Si lo necesitas, pide uno nuevo.",
          },
          unavailable: {
            title: "Tablero no disponible",
            text: "Este tablero no está disponible en este momento.",
          },
          rateLimited: {
            title: "Demasiados accesos",
            text: "Espera un minuto e inténtalo de nuevo.",
          },
          error: {
            title: "No se pudo abrir el tablero",
            text: "Revisa tu conexión e inténtalo de nuevo.",
          },
          retry: "Intentar de nuevo",
        },
        card: {
          priority: "Prioridad",
          dueAt: "Plazo",
          assignee: "Responsable",
          createdAt: "Creado el",
          products: "Producto de interés",
          checklist: "Subtareas",
          checklistProgress: "{{done}} de {{total}} hechas",
          phone: "Teléfono",
          email: "Correo",
          cpf: "CPF",
          address: "Dirección",
          serviceOrder: "OS",
          field: "Campo",
          description: "Descripción",
          nobody: "Nadie",
          loadError: "No se pudo abrir esta tarjeta.",
          close: "Cerrar",
          priorities: {
            low: "Baja",
            normal: "Media",
            high: "Alta",
            urgent: "Máxima",
          },
        },
      },
      externalLeads: {
        title: "CRM",
        refresh: "Actualizar",
        stats: {
          total: "Total de tarjetas",
          unviewed: "Nuevos",
          pending: "Pendiente",
          completed: "Completados",
        },
        filters: {
          searchPlaceholder: "Buscar por nombre, teléfono, ID u orden de servicio...",
          status: "Estado",
          all: "Todos",
          sortBy: "Ordenar por",
          newestFirst: "Más recientes",
          oldestFirst: "Más antiguos",
        },
        card: {
          new: "Nuevo",
          notInformed: "No informado",
          attachments: "anexo(s)",
          serviceOrderPlaceholder: "Orden de Servicio",
          saveServiceOrder: "Guardar O.S.",
          noChanges: "Sin cambios",
          viewDetails: "Ver detalles",
          delete: "Eliminar",
          startConversation: "Iniciar conversación en WhatsApp",
        },
        modal: {
          clientInfo: "Información del Cliente",
          name: "Nombre",
          phone: "Teléfono",
          email: "E-mail",
          cpf: "Número de ID",
          address: "Dirección",
          serviceOrder: "Orden de Servicio",
          attachments: "Anexos",
          customFields: "Campos Adicionales",
          changeStatus: "Cambiar Estado",
          receivedAt: "Recibido en:",
          viewedAt: "Visto en:",
          close: "Cerrar",
        },
        confirmDelete: {
          title: "Eliminar tarjeta",
          message: "¿Está seguro que desea eliminar esta tarjeta? Esta acción no se puede deshacer.",
        },
        empty: {
          title: "Ninguna tarjeta encontrada",
          description: "Las tarjetas creadas en el tablero o recibidas por integración aparecerán aquí",
        },
        loading: "Cargando...",
        toasts: {
          newLead: "Nueva tarjeta:",
          deleted: "Tarjeta eliminada con éxito",
          statusUpdated: "¡Estado actualizado!",
          serviceOrderSaved: "¡Orden de Servicio guardada!",
        },
        defaultStatus: "Pendiente",
      },
      kanban: {
        title: "CRM Kanban",
        toasts: {
          removed: "¡Etiqueta eliminada del ticket!",
          added: "¡Etiqueta agregada con éxito!",
          refreshed: "¡Datos actualizados!",
          errorLoadingTags: "Error al cargar etiquetas",
          errorLoadingTickets: "Error al cargar tickets",
          errorMoving: "Error al mover tarjeta",
        },
        open: "Abierto",
        seeTicket: "Ver Ticket",
        tickets: "tickets",
        columns: "columnas",
        refresh: "Actualizar",
        searchPlaceholder: "Buscar por nombre o número...",
        allQueues: "Todas las colas",
        loading: "Cargando tickets...",
        noMessage: "Sin mensaje",
        unknownContact: "Contacto desconocido",
      },
      companies: {
        title: "Registrar Empresa",
        buttons: {
          newGroup: "Nuevo Grupo",
          newCompany: "Nueva Empresa",
        },
        modal: {
          editCompany: "Editar Empresa",
          newCompany: "Nueva Empresa",
          newGroup: "Nuevo Grupo",
          groupName: "Nombre del Grupo",
          groupPlaceholder: "Ej: Cliente XYZ",
        },
        labels: {
          companies: "Empresas",
          company: "empresa",
          companiesPlural: "empresas",
        },
        tooltips: {
          addUser: "Agregar nuevo usuario",
          editUser: "Editar usuario existente",
          editCompany: "Editar empresa",
          deleteCompany: "Eliminar empresa",
        },
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada con éxito!",
        },
      },
      agentManager: {
        button: "Gestionar Agentes",
        title: "Agentes de IA",
        subtitle: "La IA que atiende en los flujos. Lo que cambies en un agente vale en todos los flujos que lo usan.",
        close: "Cerrar",
        search: "Buscar agente",
        assistant: "Crear con el asistente",
        blank: "Nuevo agente",
        emptyTitle: "Todavía no hay agentes",
        empty: "Créalo con el asistente, que aprende del sitio de tu negocio, o empieza uno en blanco.",
        noResults: "Ningún agente con ese nombre.",
        usedIn: "Usado en {{list}}",
        usedInMore: "Usado en {{list}} y {{count}} más",
        unused: "En ningún flujo",
        flowOff: "apagado",
        noVersion: "sin texto",
        updatedAt: "actualizado el {{date}}",
        edit: "Editar",
        view: "Ver",
        delete: "Eliminar",
        deleteInUse: "Saca el agente de los flujos antes de eliminarlo.",
        confirmDeleteTitle: "¿Eliminar el agente?",
        confirmDelete: "{{name}} se va con su texto, versiones y fuentes. No se puede deshacer.",
        deleted: "Agente eliminado.",
        loadMore: "Cargar más",
        unsaved: "Cambios sin guardar",
        discardConfirm: "Los cambios de este agente se perderán. ¿Salir igual?",
        editor: {
          back: "Volver a la lista",
          newTitle: "Nuevo agente",
          name: "Nombre",
          namePlaceholder: "Ej.: Ana",
          tabs: {
            knowledge: "Conocimiento",
            sources: "Fuentes",
            intelligence: "Inteligencia",
            test: "Probar",
          },
          save: "Guardar",
          discard: "Descartar",
          saved: "Agente guardado.",
          created: "Agente creado.",
          unsavedHint: "Cambios sin guardar.",
          readOnly: "Puedes ver este agente, pero no cambiarlo.",
          nameRequired: "Ponle un nombre al agente.",
          promptRequired: "El texto de la IA no puede quedar vacío.",
          caseNeedsAnswer: "Escribe la respuesta de cada respuesta lista, o quita la tarjeta.",
          loadFailed: "No se pudo abrir este agente.",
          knowledge: {
            title: "Instrucciones y base de conocimiento",
            info: "Lo que la IA sabe y cómo atiende. Cada texto guardado se vuelve una versión nueva, y puedes volver a una anterior.",
            placeholder: "Ej.: Eres Ana, la asistente de Tienda Azul. Responde con amabilidad y solo con la información de abajo.",
            live: "En línea: versión {{number}}, del {{date}}.",
            liveNone: "Todavía sin texto: la IA usa un texto estándar.",
            history: "Versiones",
            historyTitle: "Versiones del texto",
            versionName: "Versión {{number}}",
            current: "En línea",
            useVersion: "Usar esta",
            versionUsed: "Versión {{number}} en línea.",
            by: "por {{name}}",
            closeHistory: "Cerrar versiones",
          },
          sources: {
            siteTitle: "Sitio de origen",
            siteInfo: "De dónde vino la base (el asistente lee el sitio). Solo como referencia.",
            sitePlaceholder: "https://tusitio.com",
            filesTitle: "Archivos",
            filesInfo: "La IA lee los archivos de texto y puede enviar cualquier archivo de aquí al cliente cuando tenga sentido.",
            filesAdd: "Subir archivo",
            filesEmpty: "Ningún archivo.",
            uploading: "Subiendo...",
            remove: "Quitar",
            casesTitle: "Respuestas listas",
            casesInfo: "Cuando pregunten algo parecido, la IA responde con lo que escribiste.",
            casesAdd: "Nueva respuesta",
            casesEmpty: "Ninguna respuesta lista.",
            caseWhen: "Cuando pregunten",
            caseWhenPlaceholder: "Ej.: ¿Cuál es el plazo de garantía?",
            caseAnswer: "Responde",
            caseAnswerPlaceholder: "Ej.: La garantía es de 90 días desde la entrega.",
            webTitle: "Búsqueda en internet",
            webInfo: "La IA busca solo en los sitios que listes.",
            webToggle: "Buscar en internet",
            webDomains: "Sitios permitidos",
            webDomainsPlaceholder: "tusitio.com, otro.com",
            wooTitle: "Catálogo de la tienda",
            wooInfo: "La IA consulta productos, precios y stock en las tiendas de WooCommerce marcadas.",
            wooEmpty: "Ninguna tienda de WooCommerce activa. Conecta una en Integraciones.",
          },
          intelligence: {
            model: "Modelo",
            modelInfo: "Los modelos más grandes entienden más y cuestan más por mensaje.",
            reasoning: "Razonamiento",
            reasoningInfo: "Más razonamiento hace la respuesta más pensada y más cara. Solo vale en los modelos GPT-5.",
            reasoningOff: "Este modelo no usa razonamiento.",
            style: "Largo de las respuestas",
            styles: {
              concise: "Cortas",
              balanced: "Medias",
              detailed: "Detalladas",
            },
            behavior: "Cómo conversa",
            split: "Dividir la respuesta en varios mensajes, como una persona",
            images: "Leer las imágenes que envíe el cliente",
            audio: "Escuchar los audios (transcribe, tiene costo)",
            video: "Ver los videos",
            wait: "Espera antes de responder (segundos)",
            waitInfo: "Tiempo para que el cliente termine de escribir: mensajes seguidos se vuelven una sola respuesta.",
            aiUser: "Quién aparece como agente",
            aiUserInfo: "El usuario IA que queda con la conversación mientras atiende. Sin él, aparece solo el nombre del agente.",
            aiUserNone: "Solo el nombre del agente",
            photo: "Foto",
            photoChange: "Cambiar foto",
            photoSaveFirst: "Guarda el agente para poner una foto.",
          },
          test: {
            title: "Conversa como un cliente",
            info: "La IA responde con lo que está guardado. Nada pasa de verdad: transferir, etiquetar y el CRM solo se simulan.",
            saveFirst: "Hay cambios sin guardar: la prueba usa la versión guardada.",
            newFirst: "Guarda el agente para probarlo.",
            placeholder: "Escribe como un cliente",
            send: "Enviar",
            clear: "Nueva conversación",
            error: "No se pudo probar ahora. Intenta de nuevo.",
            empty: "Envía un mensaje para ver cómo responde.",
            files: "Enviaría: {{files}}",
          },
        },
      },
      invitePage: {
        loading: "Abriendo la invitación...",
        title: "{{name}} te invitó al equipo",
        titleNoInviter: "Recibiste una invitación al equipo",
        company: "Empresa",
        account: "Cuenta",
        accounts: "Cuentas",
        profile: "Perfil",
        email: "Correo",
        expires: "Válida hasta",
        profiles: {
          user: "Agente",
          admin: "Administrador",
        },
        createSubtitle: "Crea tu contraseña para entrar.",
        name: "Tu nombre",
        password: "Crea una contraseña",
        passwordHint: "Al menos 8 caracteres.",
        create: "Crear cuenta y entrar",
        hasAccount: "Este correo ya tiene cuenta en Sttelar Talk. Entra con él para aceptar.",
        login: "Entrar para aceptar",
        acceptSubtitle: "Acepta para entrar al equipo.",
        accept: "Aceptar invitación",
        otherEmail: "Estás conectado como {{current}}. La invitación es para {{email}}.",
        switchUser: "Salir y usar el correo de la invitación",
        joinedTitle: "Invitación aceptada",
        joined: "Ya formas parte de la cuenta {{account}}. Para cambiar de cuenta después, usa el selector del menú.",
        goToAccount: "Entrar en la cuenta {{account}}",
        stay: "Seguir en la cuenta actual",
        notNow: "Ahora no",
        invalidTitle: "Esta invitación ya no es válida",
        invalid: "Puede haber vencido, haberse usado o eliminado. Pide una nueva a quien te invitó.",
        failedTitle: "No se pudo abrir la invitación",
        retry: "Intentar de nuevo",
      },
      setupChecklist: {
        title: "Deja la cuenta lista para atender",
        progress: "{{done}} de {{total}} listos",
        dismiss: "Descartar",
        dismissHint: "Se oculta solo para ti",
        done: "listo",
        items: {
          whatsapp: {
            title: "Conectar WhatsApp",
            text: "Las conversaciones llegan aquí.",
            action: "Conectar",
          },
          team: {
            title: "Llamar al equipo",
            text: "Invita a quien va a atender.",
            action: "Invitar",
          },
          ai: {
            title: "Activar la IA",
            text: "Responde y pasa al equipo.",
            action: "Activar la IA",
          },
          hours: {
            title: "Definir el horario",
            text: "Los días y las horas en que la empresa atiende.",
            action: "Definir",
          },
        },
      },
      accountSwitcher: {
        label: "Cuenta activa",
        reload: "La cuenta se cambió. Recarga la página para seguir en ella.",
      },
      billingProfile: {
        title: "Datos de facturación",
        subtitle: "Quién paga las facturas de Sttelar Talk. Aparece en la factura y se usa en la tarjeta.",
        personType: "Tipo",
        company: "Persona jurídica",
        individual: "Persona física",
        nameCompany: "Razón social",
        nameIndividual: "Nombre completo",
        email: "Correo de facturación",
        phone: "Teléfono",
        zipCode: "Código postal",
        street: "Dirección",
        number: "Número",
        complement: "Complemento",
        optional: "(opcional)",
        required: "Completa este campo.",
        zipLoading: "Buscando la dirección por el código postal",
        neighborhood: "Barrio",
        city: "Ciudad",
        state: "Estado",
        save: "Guardar",
        saved: "Datos de facturación guardados.",
      },
      billingOverview: {
        legacy: {
          title: "Cobro acordado con Sttelar",
          text: "El plan y las facturas de tu Empresa se acuerdan directamente con Sttelar.",
          talk: "Hablar con Sttelar",
          message: "¡Hola! Quiero hablar sobre el plan de la Empresa {{name}}.",
        },
        conditions: {
          title: "Condiciones acordadas",
          list: "Catálogo: {{amount}}",
          price: "Precio acordado {{item}}: {{amount}}",
          discount: "Descuento del {{value}}% {{item}}",
          courtesy: "Cortesía: {{item}}",
          courtesyLicense: "Cortesía: una licencia",
          until: " hasta el {{date}}",
          from: " a partir del {{date}}",
          itemsOf: {
            plan: "de la licencia del plan",
            internal_chat: "de la licencia del Chat Interno",
            ai_pack: "del paquete de IA",
          },
          itemsOn: {
            all: "en la mensualidad",
            plan: "en la licencia del plan",
            internal_chat: "en la licencia del Chat Interno",
            ai_pack: "en el paquete de IA",
          },
          items: {
            all: "la mensualidad",
            plan: "la licencia del plan",
            internal_chat: "la licencia del Chat Interno",
            ai_pack: "el paquete de IA",
          },
        },
        loadError: "No se pudo cargar la facturación.",
        disputes: {
          title: "Contestación en la tarjeta",
          text: "El cobro de {{amount}} fue contestado en la tarjeta el {{date}}. Mientras la operadora lo analiza, la empresa sigue funcionando. Si la contestación es aceptada (el valor vuelve a la tarjeta), el cobro debe pagarse de nuevo en hasta 7 días.",
        },
        overdue: {
          title: "Pago pendiente",
          titleSuspended: "Envío suspendido",
          titleSuspendedInternal: "Chat Interno suspendido",
          deadline: "Paga hasta el {{date}}",
          text: "La factura de {{amount}}, vencida el {{due}}, aún no fue pagada. Paga hasta el {{date}} para que {{what}} no se detenga.",
          whatSending: "el envío de mensajes",
          whatInternal: "el Chat Interno",
          textSuspended: "La factura de {{amount}}, vencida el {{due}}, no fue pagada, y el envío de mensajes (agentes, automatizaciones e IA) y el Chat Interno están detenidos. No se borró nada, y los mensajes de los clientes siguen llegando. Al pagar, todo vuelve al instante.",
          textSuspendedInternal: "La factura de {{amount}}, vencida el {{due}}, no fue pagada, y el Chat Interno está detenido. No se borró nada. Al pagar, vuelve al instante.",
          textNoDeadline: "La factura de {{amount}}, vencida el {{due}}, aún no fue pagada. En Facturación, puedes pagar con Pix o intentar de nuevo con la tarjeta.",
          creatingPix: "Generando el Pix...",
          disputeNote: "Incluye un cobro contestado en la tarjeta: la contestación fue aceptada y el valor volvió a la tarjeta.",
          invoiceDispute: "Contestación aceptada el {{date}}",
          invoice: "Factura vencida el {{date}}",
          payPix: "Pagar con Pix",
          retryCard: "Intentar de nuevo con la tarjeta {{brand}} terminada en {{last4}}",
          retrySavedCard: "Intentar de nuevo con la tarjeta guardada",
          retrying: "Intentando con la tarjeta...",
          retryPaid: "Pago confirmado.",
          refresh: "Actualizar",
          pixExpiredHint: "Genera otro en \"Pagar con Pix\".",
          boletoSettling: "¿Pagaste el boleto? La confirmación tarda hasta 3 días hábiles.",
        },
        status: {
          free: "Gratis",
          active: "Activo",
          courtesy: "Cortesía",
          failed: "Pago pendiente",
          canceling: "Cancelado",
          resumed: "Reanudado",
        },
        free: "Gratis",
        perMonth: "por mes",
        starterSummary: "Hasta {{users}} personas, {{accounts}} cuenta, {{whatsapps}} número de WhatsApp y {{boards}} tablero del CRM. {{common}} mensajes y {{ai}} de la IA por mes.",
        summary: {
          seats: "{{count}} licencia",
          seats_plural: "{{count}} licencias",
          internal: "{{count}} de Chat Interno",
          pack: "el paquete de {{messages}} mensajes de la IA",
          starterInternal: "Chat Interno para {{count}} persona",
          starterInternal_plural: "Chat Interno para {{count}} personas",
          and: "y",
        },
        renewsCard: "Se renueva el {{date}}, con la tarjeta {{brand}} terminada en {{last4}}.",
        renewsBoleto: "Se renueva el {{date}}, con boleto.",
        renewsSavedCard: "Se renueva el {{date}}, con la tarjeta registrada.",
        courtesyNote: "La Empresa está en cortesía y no se le cobra.",
        disabledNote: "La contratación no está disponible en este momento.",
        changeNote: "Para cambiar el plan o las licencias, habla con el soporte de Sttelar.",
        starterChangeNote: "Para pasar al Basic o al Pro, habla con el soporte de Sttelar.",
        paymentPendingNote: "Regulariza la mensualidad pendiente antes de cambiar el plan. Si necesitas ayuda, habla con el soporte de Sttelar.",
        reductionScheduledNote: "Para aumentar ahora, deshaz antes la reducción programada.",
        nothingToReduceNote: "No hay qué reducir: el plan ya está en el mínimo para lo que la empresa usa.",
        cancellationScheduledNote: "Con la cancelación programada, el plan no cambia aquí. Para seguir en él, deshaz la cancelación.",
        resumeNote: "La suscripción reanudada empieza al final del ciclo pagado; hasta entonces, el plan no cambia aquí.",
        paidUntil: "Pagado hasta el {{date}}. Después, Starter.",
        resumeStarts: "La suscripción reanudada empieza el {{date}}, sin cobro hasta entonces.",
        actions: {
          upgrade: "Contratar Basic o Pro",
          addInternal: "Agregar Chat Interno",
          changeInternal: "Cambiar Chat Interno",
          reduce: "Reducir en la renovación",
          change: "Cambiar plan",
          cancel: "Cancelar plan",
          cancelInternal: "Cancelar Chat Interno",
        },
        pending: {
          titleBoleto: "Boleto esperando el pago",
          titlePix: "Pix esperando el pago",
          pixExpiredHint: "Desiste para generar otro.",
          textChange: "{{what}}. A pagar ahora: {{amount}}, la diferencia hasta la renovación. El plan cambia cuando se confirme el pago.",
          verifyingChange: "El pago no se confirmó a tiempo. Estamos verificando si el pedido se creó; no cambies de nuevo antes de eso.",
          titleCard: "Confirmando el pago",
          what: "{{plan}} con {{details}}",
          verifying: "Pagar.me no confirmó a tiempo. Estamos verificando si la suscripción se creó; no contrates de nuevo antes de eso.",
          keepBoleto: "Mantener boleto",
          keep: "Mantener pedido",
          text: "{{what}}, {{amount}} por mes. El plan cambia cuando se confirme el pago.",
          due: "Vence el {{date}}.",
          line: "Línea digitable",
          copy: "Copiar",
          copied: "Línea digitable copiada.",
          open: "Abrir boleto",
          cancel: "Desistir",
          cancelConfirm: "Confirmar",
          cancelHint: "Después de desistir, no pagues este boleto.",
          canceled: "Pedido cancelado.",
          refresh: "Actualizar",
        },
        reduction: {
          title: "Reducción programada para el {{date}}",
          text: "Desde esa fecha, la empresa tendrá {{what}}, por {{amount}} por mes. Hasta entonces, nada cambia.",
          undo: "Deshacer reducción",
          undoConfirm: "Confirmar: deshacer",
          keep: "Mantener reducción",
          undone: "Reducción deshecha.",
          locked: "Ya no se puede deshacer: la reducción vale en la renovación. Después, para aumentar, usa Cambiar plan.",
        },
        cancellation: {
          title: "Plan cancelado: vale hasta el {{date}}",
          titleInternal: "Chat Interno cancelado: vale hasta el {{date}}",
          text: "La suscripción se detuvo en Pagar.me y no se cobra nada más. Hasta esa fecha, la empresa sigue en {{plan}}; después, pasa al Starter, gratis.",
          textInternal: "La suscripción se detuvo en Pagar.me y no se cobra nada más. El Chat Interno vale hasta esa fecha.",
          undo: "Deshacer cancelación",
          undoHint: "Contrata de nuevo {{plan}} a partir del {{date}}, {{paidWith}}, sin cobrar nada ahora.",
          byCard: "con la tarjeta {{brand}} terminada en {{last4}}",
          bySavedCard: "con la tarjeta registrada",
          byBoleto: "con boleto",
          undoConfirm: "Confirmar: seguir en el plan",
          keep: "Mantener cancelación",
          undone: "Cancelación deshecha: el plan sigue después del ciclo pagado.",
          locked: "Ya no se puede deshacer: el plan termina ahora. Después, contrata de nuevo en Facturación.",
        },
        adequacy: {
          needed: "El plan nuevo no admite todo lo que la empresa usa. Elige lo que queda hasta el {{date}}; sin la elección, el acceso queda restringido a Facturación en la renovación.",
          chosen: "La elección de lo que queda está hecha y vale en la renovación.",
          choose: "Elegir lo que queda",
          review: "Ver o cambiar la elección",
          notNeeded: "No hay qué elegir: todo cabe en el plan.",
          saved: "Elección guardada. Vale en la renovación.",
          doneRestricted: "Listo: el acceso volvió a la normalidad.",
          doneDue: "Listo: la empresa cabe en el plan.",
        },
        adequacyDue: {
          title: "Elija qué queda hasta el {{date}}",
          text: "Una condición del plan terminó, y la empresa superó los límites del {{plan}}. Crear más de lo que superó está bloqueado. Hasta el {{date}}, elija qué queda: lo que salga se archiva y se guarda por 12 meses. Sin la elección, el acceso queda restringido hasta ella. No se borra nada.",
          action: "Elegir qué queda",
        },
        restricted: {
          title: "Elige lo que queda para continuar",
          text: "La empresa superó los límites de {{plan}}. Hasta elegir lo que queda, solo esta pantalla funciona para todos en la empresa. Lo que salga se archiva y se guarda durante 12 meses.",
          action: "Elegir lo que queda",
        },
        archived: {
          title: "Elementos archivados ({{count}})",
          info: "Elementos que salieron al adecuarse a un plan menor. Se guardan durante 12 meses y vuelven con Restaurar, si el plan lo permite.",
          show: "Ver archivados",
          hide: "Ocultar",
          loading: "Cargando...",
          empty: "Ningún elemento archivado.",
          restore: "Restaurar",
          restoring: "Restaurando...",
          restored: "{{name}} restaurado.",
          account: "Cuenta {{name}}",
          accountArchived: "archivada",
          dates: "archivado el {{archived}}, guardado hasta el {{until}}",
          types: {
            account: "Cuenta",
            whatsapp: "Número",
            crm_board: "Tablero",
            user: "Persona",
          },
        },
        usage: {
          title: "Uso de este mes",
          period: "Del {{start}} al {{end}}",
          info: "Cuentan los mensajes que salen por la plataforma; los enviados desde el celular no cuentan. El mes empieza el día en que empezó el plan.",
          users: "Personas",
          internalChat: "Chat Interno",
          common: "Mensajes",
          ai: "Mensajes de la IA",
          accounts: "Cuentas",
          whatsapps: "Números de WhatsApp",
          crmBoards: "Tableros del CRM",
          of: "{{used}} de {{limit}}",
          unlimited: "{{used}}, sin límite",
          notContracted: "no contratado",
        },
        invoices: {
          title: "Facturas",
          empty: "Todavía no hay facturas.",
          date: "Fecha",
          amount: "Valor",
          method: "Forma",
          status: "Estado",
          credit_card: "Tarjeta",
          pix: "Pix",
          boleto: "Boleto",
          openBoleto: "Abrir boleto",
          abandoned: "Cancelado: no pagues",
          replaced: "Cambiada por Pix",
          refund: "Pedir reembolso",
          partlyRefunded: "Pagada, {{amount}} reembolsado",
          statuses: {
            paid: "Pagada",
            overpaid: "Pagada",
            underpaid: "Pagada de menos",
            pending: "Pendiente",
            processing: "Procesando",
            failed: "No aprobada",
            canceled: "Cancelada",
            refunded: "Reembolsada",
            chargedback: "Disputada",
          },
        },
        refunds: {
          title: "Pedidos de reembolso",
          item: "Reembolso de {{amount}}, pedido el {{date}}",
          refusedReason: "Motivo del rechazo: {{reason}}",
          canceledReason: "Motivo: {{reason}}",
          statuses: {
            requested: "En análisis",
            refused: "Rechazado",
            approved: "Aprobado: devolución en curso",
            refunding: "Aprobado: devolución en curso",
            refunded: "Reembolsado",
            canceled: "No devuelto",
          },
        },
      },
      refundDialog: {
        title: "Pedir reembolso",
        subtitle: "Sttelar analiza el pedido y responde aquí, en Facturación.",
        close: "Cerrar",
        summary: "Reembolso de {{refundable}}, del cobro de {{amount}} del {{date}}.",
        reason: "Motivo",
        reasonPlaceholder: "Ej.: la mensualidad se cobró dos veces este mes",
        hint: "Al menos 10 caracteres. Aprobado, el valor vuelve por el mismo medio de pago; en el boleto, Sttelar acuerda la devolución.",
        cancel: "Cancelar",
        send: "Pedir reembolso",
        sent: "Pedido de reembolso enviado.",
      },
      plansDialog: {
        stepsLabel: "Etapas de la contratación",
        stepCustomize: "Personalizar suscripción",
        stepPayment: "Revisar y pagar",
        choosePlan: "Elige el plan",
        perSeatMonth: "por licencia, por mes",
        perks: {
          accounts: "{{count}} cuenta",
          accounts_plural: "{{count}} cuentas",
          accountsUnlimited: "Cuentas sin límite",
          whatsapps: "{{count}} número de WhatsApp",
          whatsapps_plural: "{{count}} números de WhatsApp",
          whatsappsUnlimited: "Números de WhatsApp sin límite",
          boards: "{{count}} tablero del CRM",
          boards_plural: "{{count}} tableros del CRM",
          boardsUnlimited: "Tableros del CRM sin límite",
        },
        bothPlans: "En los dos planes: mensajes sin límite y {{ai}} mensajes de la IA por mes.",
        seatsHint: "Una por persona del equipo. Mínimo de {{min}}.",
        addons: "Complementos",
        optional: "Opcional",
        internalHint: "Conversación del equipo dentro de Sttelar Talk.",
        internalPrice: "{{price}} por licencia, por mes",
        howManyInternal: "Cuántas personas lo van a usar",
        aiPackHint: "El plan ya incluye {{ai}} mensajes de la IA por mes.",
        aiPackNoneShort: "Sin paquete",
        aiPackOptionShort: "{{messages}} mensajes por {{price}}",
        lineSeats: "{{count}} licencia de {{price}}",
        lineSeats_plural: "{{count}} licencias de {{price}}",
        linePack: "{{messages}} mensajes de la IA por mes",
        continue: "Continuar al pago",
        continueFree: "Continuar",
        continueNote: "Revisas todo antes de pagar.",
        back: "Volver a la suscripción",
        billingIntro: "Quién paga las facturas. La tarjeta pide también la dirección de facturación.",
        billingSaveFailed: "No se pudo guardar ahora. Revisa la conexión e inténtalo de nuevo.",
        billingLoadFailed: "No se pudieron cargar los datos ahora.",
        freeChangeTitle: "Sin cobro ahora",
        freeChangeText: "El cambio vale de inmediato, y el valor nuevo viene en la próxima factura.",
        billingEdit: "Cambiar",
        billingCancel: "Cancelar",
        billingLoading: "Cargando los datos…",
        billingAddress: "{{street}}, {{number}}, {{city}}, {{state}}",
        saveBilling: "Guardar y continuar",
        cvvHelp: "Los 3 números del reverso de la tarjeta. En American Express, son 4 en el frente.",
        cardErrors: {
          number: "Revisa el número de la tarjeta.",
          holder: "Escribe el nombre como aparece en la tarjeta.",
          expiry: "Fecha inválida o vencida.",
          cvv: "Escribe los 3 o 4 números.",
        },
        boletoDue: "El boleto vence en 3 días.",
        quoteTodayLabel: "Hoy, por mes",
        doneNext: "El próximo cobro es el {{date}}.",
        confirmEmail: {
          title: "Confirma tu correo para contratar",
          cta: "Confirma tu correo para continuar",
          text: "Enviamos un enlace a {{email}}. Después de hacer clic, vuelve aquí: tus opciones siguen guardadas.",
        },
        trust: {
          recurringCard: "Se cobra cada mes en la tarjeta. El próximo cobro es dentro de un mes.",
          recurringBoleto: "Un boleto nuevo cada mes. El próximo es dentro de un mes.",
          activationCard: "El plan se libera en cuanto se confirme el pago, por lo general en segundos.",
          activationInternal: "El Chat Interno se libera en cuanto se confirme el pago, por lo general en segundos.",
          activationBoleto: "El plan se libera cuando se confirme el pago, hasta 3 días hábiles después de pagar.",
          cancel: "Cancela en Facturación, con la mensualidad al día. Vale hasta el fin del mes ya pagado.",
          changeCard: "El cambio vale en cuanto se confirme el pago, por lo general en segundos.",
          changePix: "El cambio vale en cuanto se pague el Pix.",
          changeBoleto: "El cambio vale cuando se confirme el pago, hasta 3 días hábiles después de pagar.",
        },
        title: "Contratar plan",
        titleInternal: "Agregar Chat Interno",
        titleChange: "Cambiar plan",
        subtitleChange: "Pagas ahora solo la diferencia hasta la renovación.",
        savedCard: "Tarjeta terminada en {{last4}}",
        quoteNowHint_plural: "Por los {{count}} días hasta la renovación",
        savedCardBrand: "{{brand}} terminada en {{last4}}",
        savedCardShort: "terminada en {{last4}}",
        submitDisabled: "Pagar",
        failedBoletoChange: "No se pudo generar el boleto ahora. Intenta de nuevo en unos minutos o paga de otra forma.",
        pixVerifyingText: "Estamos verificando si el Pix se creó. No cambies de nuevo antes de eso.",
        pixVerifyingSlow: "Está tardando. Puedes cerrar: el Pix aparece en Facturación cuando esté listo.",
        pixExpiredAt: "Este Pix venció a las {{time}}.",
        quoteNowInfo: "La diferencia de la mensualidad por los días que faltan. La fecha de renovación no cambia.",
        summaryTitleChange: "Cómo queda",
        quoteFreeValue: "Sin cobro",
        quoteRetry: "Intentar de nuevo",
        quoteFailed: "No se pudo calcular el valor ahora.",
        quoting: "Calculando…",
        quoteChanged: "El valor cambió desde el cálculo. Revisa el valor nuevo y paga de nuevo.",
        chargeCard: "Se cobra ahora en la tarjeta {{card}}.",
        chargePix: "Paga ahora con Pix.",
        chargeBoleto: "Paga con boleto, con vencimiento en 3 días.",
        boletoMinChange: "Boleto solo para valores desde {{min}}.",
        boletoRenewal: "Boleto solo con 10 días o más hasta la renovación.",
        planCurrent: "Actual",
        packCurrent: "(actual)",
        planChangeInfo: "Aquí solo se puede aumentar. Para disminuir o pasar al Basic, usa Reducir en la renovación.",
        seatsHelpChange: "Una licencia por persona del equipo (la IA no ocupa licencia). Como mínimo las {{min}} licencias que la empresa ya tiene.",
        pixValidUntil: "Válido hasta las {{time}}",
        pixGenerating: "Generando el código Pix",
        pixCode: "Código Pix",
        pixCopyManual: "No se pudo copiar. Selecciona el código y cópialo.",
        pixCloseHint: "Puedes cerrar: el Pix sigue en Facturación hasta vencer.",
        pixExpiredTitle: "El Pix venció",
        pixExpiredText: "El código no se pagó en 30 minutos. Genera otro para pagar.",
        pixAgain: "Generar otro Pix",
        failedPixTitle: "No se pudo generar el Pix",
        failedSavedCard: "La tarjeta {{card}} no fue aceptada. Paga con Pix o boleto.",
        payOtherWay: "Pagar de otra forma",
        reviewTitle: "Pago en revisión",
        reviewText: "Recibimos el pago. El equipo de Sttelar revisará el pedido y hablará contigo.",
        doneChangeTitle: "Cambio hecho",
        verifyingChange: "El pago no se confirmó a tiempo. Estamos verificando si el pedido se creó; no cambies de nuevo antes de eso.",
        pix: "Pix",
        savedCardNote: "Se cobra en la tarjeta de la suscripción.",
        pixNote: "El código Pix vale por 30 minutos.",
        quoteMonthly: "Por mes, desde el {{date}}",
        quoteNothing: "Elige qué aumentar",
        quoteNow: "A pagar ahora",
        quoteNowHint: "Por el día que falta hasta la renovación",
        quoteFree: "El valor nuevo viene en la próxima factura.",
        submitFree: "Cambiar ahora",
        submitPix: "Generar Pix de {{amount}}",
        pixTitle: "Paga con Pix",
        pixText: "Abre la app del banco y lee el código QR, o copia el código y pégalo en la app.",
        pixQrAlt: "Código QR del Pix",
        pixCopy: "Copiar código Pix",
        pixCopied: "Código Pix copiado.",
        pixWaiting: "Esperando el pago…",
        doneChange: "La empresa ahora tiene {{what}}.",
        failedPix: "Intenta de nuevo en unos instantes o paga de otra forma.",
        plan: "Plan",
        quoteToday: "Hoy: {{amount}} por mes",
        perSeat: "{{price}} por licencia",
        seats: "Licencias",
        seatsHelp: "Una licencia por persona del equipo (la IA no ocupa licencia). Como mínimo {{min}}: el plan cobra al menos {{billed}}, y no se pueden contratar menos que las personas que la Empresa ya tiene.",
        internal: "Chat Interno",
        internalHelp: "La conversación del equipo dentro de Sttelar Talk, para quien tenga licencia. Hasta el número de licencias del plan.",
        internalStarterHelp: "La conversación del equipo dentro de Sttelar Talk. El Starter tiene hasta {{max}} personas.",
        aiPack: "Paquete de IA",
        aiPackHelp: "El paquete reemplaza los mensajes de la IA del plan: el de 10 mil da 10 mil por mes.",
        aiPackNone: "Sin paquete ({{ai}} mensajes de la IA por mes)",
        aiPackOption: "{{messages}} mensajes por mes, {{price}}",
        decrease: "Disminuir",
        increase: "Aumentar",
        summaryTitle: "Resumen de la suscripción",
        items: {
          plan: "{{plan}}, {{count}} licencia",
          plan_plural: "{{plan}}, {{count}} licencias",
          internal: "Chat Interno, {{count}} licencia",
          internal_plural: "Chat Interno, {{count}} licencias",
          pack: "Paquete de IA, {{messages}} mensajes",
        },
        total: "Total por mes",
        payment: "Forma de pago",
        card: "Tarjeta de crédito",
        boleto: "Boleto",
        boletoMin: "Boleto solo desde {{min}} por mes.",
        cardNumber: "Número de la tarjeta",
        cardHolder: "Nombre impreso en la tarjeta",
        cardExpiry: "Vencimiento",
        cardCvv: "CVV",
        cardSecure: "Los datos de la tarjeta van directo a Pagar.me. Sttelar Talk no los recibe ni los guarda.",
        cardInvalid: "Revisa los datos de la tarjeta.",
        cardServiceDown: "No se pudo hablar con la operadora de la tarjeta. No se cobró nada; intenta de nuevo en un momento.",
        cardExpiryPlaceholder: "MM/AA",
        verifying: "Verificando con Pagar.me",
        verifyingText: "Pagar.me no confirmó a tiempo. Estamos verificando si la suscripción se creó; no contrates de nuevo antes de eso.",
        failedBoletoTitle: "No se pudo generar el boleto",
        boletoGenerating: "Generando el boleto",
        boletoTextNoDate: "El plan cambia cuando se confirme el pago.",
        submitCard: "Pagar {{amount}}",
        submitBoleto: "Generar boleto de {{amount}}",
        cancel: "Cancelar",
        close: "Cerrar",
        paying: "Confirmando el pago",
        payingText: "Esto suele tardar unos segundos.",
        payingSlow: "La confirmación está tardando. Puedes cerrar: el plan cambia apenas se confirme el pago.",
        doneTitle: "Pago confirmado",
        donePlan: "La Empresa está en {{plan}}.",
        doneInternal: "El Chat Interno está habilitado para {{count}} persona.",
        doneInternal_plural: "El Chat Interno está habilitado para {{count}} personas.",
        failedTitle: "Pago rechazado",
        failedCard: "La tarjeta no fue aceptada. Revisa los datos o usa otra tarjeta.",
        failedBoleto: "No se pudo generar el boleto ahora. Intenta de nuevo en unos minutos o paga con tarjeta.",
        retry: "Intentar de nuevo",
        boletoTitle: "Boleto generado",
        boletoText: "Paga hasta el {{date}}. El plan cambia cuando se confirme el pago.",
        openRequest: "Ya hay un pedido esperando el pago. Aparece en Facturación.",
      },
      reductionDialog: {
        title: "Reducir en la renovación",
        subtitle: "Vale a partir de la renovación. Hasta entonces, la empresa mantiene lo que tiene hoy.",
        planInfo: "En el Basic, las cuentas, los números de WhatsApp y los tableros del CRM tienen límite.",
        seatsHelp: "Como mínimo {{min}}: las personas que la empresa ya tiene, y nunca menos que el mínimo cobrado del plan.",
        internalHelp: "Como mínimo {{min}}: quienes ya usan el Chat Interno.",
        internalHelpStarter: "En el Starter, el Chat Interno mantiene al menos 1 licencia: para quitar la última, usa Cancelar Chat Interno.",
        from: "Por mes, desde el {{date}}",
        nothing: "Elige qué reducir",
        note: "No se cobra nada ahora, y no se devuelve nada del mes ya pagado.",
        submit: "Programar reducción",
        blockersHint: "Después de confirmar, eliges lo que queda, hasta la renovación. El resto se archiva, sin borrar nada.",
        doneTitle: "Reducción programada",
        doneText: "Desde el {{date}}, la empresa tendrá {{what}}, por {{amount}} por mes. Hasta entonces, nada cambia.",
        blockers: {
          users: "Personas: la empresa tiene {{used}}, y el plan menor permite {{limit}}.",
          internalChatUsers: "Chat Interno: lo usan {{used}} personas, y el plan menor permite {{limit}}.",
          accounts: "Cuentas: la empresa tiene {{used}}, y el plan menor permite {{limit}}.",
          whatsapps: "Números de WhatsApp: la empresa tiene {{used}}, y el plan menor permite {{limit}}.",
          crmBoards: "Tableros del CRM: la empresa tiene {{used}}, y el plan menor permite {{limit}}.",
        },
        blockersTitle: "El plan nuevo no admite todo lo que la empresa usa:",
        chooseNow: "Elige lo que queda hasta el {{date}}. Sin la elección, el acceso queda restringido a Facturación en la renovación.",
        chooseAction: "Elegir lo que queda",
        chooseLater: "Elegir después",
        cancel: {
          title: "Cancelar {{plan}}",
          titleInternal: "Cancelar el Chat Interno",
          subtitle: "La suscripción se detiene ahora en Pagar.me. No se devuelve ni se vuelve a cobrar nada.",
          whatHappens: "Qué pasa",
          text: "{{plan}} vale hasta el final del ciclo ya pagado. Después, la empresa pasa al Starter, gratis, y el paquete de IA termina.",
          textInternal: "El Chat Interno vale hasta el final del ciclo ya pagado y después termina.",
          starterLimits: "En el Starter: hasta {{users}} personas, {{accounts}} cuenta, {{whatsapps}} número de WhatsApp, {{boards}} tablero del CRM, {{common}} mensajes y {{ai}} de la IA por mes.",
          keepInternal: "Mantener el Chat Interno en el Starter",
          keepInternalHint: "{{price}} por persona, por mes. La suscripción sigue solo con él.",
          keepHelp: "Hasta {{max}} personas, el máximo del Starter.",
          until: "Por mes, después del {{date}}",
          note: "Deshacer es contratar de nuevo: el mismo plan, desde el día siguiente al final del ciclo, sin cobrar nada ahora.",
          submit: "Confirmar cancelación",
          doneTitle: "Plan cancelado",
          doneText: "La suscripción se detuvo en Pagar.me. {{plan}} vale hasta el {{date}}; después, la empresa pasa al Starter.",
          doneTitleInternal: "Chat Interno cancelado",
          doneTextInternal: "La suscripción se detuvo en Pagar.me. El Chat Interno vale hasta el {{date}} y después termina.",
        },
      },
      restrictedAccess: {
        title: "Acceso restringido",
        textAdmin: "La empresa superó los límites del plan. Para volver a usar Sttelar Talk, elige en Facturación lo que queda en el plan. No se borra nada: lo que salga se guarda durante 12 meses.",
        textMember: "La empresa superó los límites del plan, y el administrador debe elegir lo que queda, en Facturación. Hasta entonces, Sttelar Talk queda en pausa para el equipo. Habla con el administrador de tu empresa.",
        action: "Ir a Facturación",
      },
      adequacyDialog: {
        title: "Elige lo que queda en {{plan}}",
        subtitle: "Hasta el {{date}}. Lo que salga se archiva en la renovación y se guarda durante 12 meses.",
        subtitleRestricted: "Para volver a usar Sttelar Talk, elige lo que queda en el plan. Lo que salga se archiva ahora y se guarda durante 12 meses.",
        subtitleDue: "Una condición del plan terminó. Elija qué queda hasta el {{date}}: lo que salga se archiva ahora y se guarda por 12 meses.",
        close: "Cerrar",
        accounts: "Cuentas",
        whatsapps: "Números de WhatsApp",
        crmBoards: "Tableros del CRM",
        users: "Personas",
        internalChat: "Quién mantiene el Chat Interno",
        count: "{{used}} de {{limit}}",
        countFree: "{{used}}, sin límite",
        accountGoesWith: "Sus números y tableros salen con ella.",
        goesWithAccount: "Sale con la cuenta",
        noWhatsapps: "Ningún número de WhatsApp.",
        noBoards: "Sin tablero: el Principal se crea solo.",
        defaultBoard: "Predeterminado",
        boardsNote: "La cuenta que quede sin tablero recibe el Principal sola, y cuenta en el límite.",
        you: "Tú",
        admin: "Administrador",
        userWithoutAccount: "Sin cuenta que queda: sale también",
        needAdmin: "Al menos un administrador debe quedar.",
        internalOnly: "Solo usa el Chat Interno: para quitarlo, la persona sale.",
        sharedPerson: "También está en otra empresa: su Chat Interno no cambia aquí.",
        summaryTitle: "En {{plan}}",
        limits: {
          users: "Personas",
          internalChatUsers: "Chat Interno",
          accounts: "Cuentas",
          whatsapps: "Números",
          crmBoards: "Tableros",
        },
        leavingTitle: "Sale en la renovación",
        leavingNow: "Sale ahora",
        leaving: {
          accounts: "{{count}} cuenta",
          accounts_plural: "{{count}} cuentas",
          whatsapps: "{{count}} número",
          whatsapps_plural: "{{count}} números",
          crmBoards: "{{count}} tablero",
          crmBoards_plural: "{{count}} tableros",
          users: "{{count}} persona",
          users_plural: "{{count}} personas",
          internalChatOff: "{{count}} sin el Chat Interno",
          nothing: "Nada",
        },
        keepNote: "No se borra nada: lo que sale se guarda durante 12 meses y vuelve con Restaurar, si el plan lo permite.",
        overHint: "Desmarca hasta que todo quepa en los límites del plan.",
        save: "Guardar elección",
        saveRestricted: "Terminar y liberar el acceso",
        saveDue: "Concluir la elección",
      },
      planLimit: {
        title: "El plan llegó al límite",
        used: {
          users: "La Empresa usa {{used}} de {{limit}} personas del plan.",
          internalChat: "La Empresa usa {{used}} de {{limit}} licencias de Chat Interno.",
          accounts: "La Empresa usa {{used}} de {{limit}} cuentas del plan.",
          whatsapps: "La Empresa usa {{used}} de {{limit}} números de WhatsApp del plan.",
          crmBoards: "La Empresa usa {{used}} de {{limit}} tableros del CRM del plan.",
        },
        generic: "La Empresa llegó al límite del plan.",
        starterOffer: "En Basic o Pro eliges cuántas licencias quieres y tienes más cuentas, números y tableros.",
        internalOffer: "El Chat Interno cuesta {{price}} por persona, por mes.",
        otherPlan: "Para tener más, habla con el soporte de Sttelar.",
        askAdmin: "Pide al administrador de la Empresa que cambie el plan.",
        changeOffer: "Agrega licencias: pagas ahora solo la diferencia hasta la renovación.",
        changeOfferPro: "En el Pro, cuentas, números y tableros no tienen límite. Pagas ahora solo la diferencia hasta la renovación.",
        paymentPending: "Hay una mensualidad pendiente. Regularízala en Facturación (o habla con el soporte) antes de cambiar el plan.",
        reductionScheduled: "Hay una reducción programada para la renovación. Para aumentar ahora, deshazla en Facturación.",
        cancellationScheduled: "Hay una cancelación programada: hasta el final del ciclo pagado, crear sigue los límites del Starter. Para seguir en el plan, deshaz la cancelación en Facturación.",
        seeOptions: "Ver opciones",
        pendingRequest: "Hay un pedido esperando el pago. Está en Facturación.",
        openBilling: "Ver en Facturación",
        seePlans: "Ver planes",
        addInternal: "Agregar Chat Interno",
        notNow: "Ahora no",
        ok: "Entendido",
      },
      companySetup: {
        steps: {
          company: "Empresa",
          account: "Cuenta",
          ai: "IA",
          whatsapp: "WhatsApp",
          team: "Equipo",
        },
        progressLabel: "Etapas de la configuración",
        leave: "Salir",
        company: {
          title: "¿Cómo se llama tu empresa?",
          subtitle: "Es el nombre que tu equipo verá en Sttelar Talk.",
          label: "Nombre de la empresa",
          placeholder: "Ej.: Tienda Azul Celulares",
          submit: "Continuar",
        },
        account: {
          title: "¿Y el nombre de la primera cuenta?",
          subtitle: "La cuenta reúne los números de WhatsApp, el equipo y las atenciones de una tienda o sucursal. Si tienes una sola, puedes usar su nombre.",
          label: "Nombre de la cuenta",
          placeholder: "Ej.: Matriz",
          info: "Después puedes crear otras cuentas, una para cada tienda o sucursal.",
          submit: "Crear cuenta",
          back: "Cambiar el nombre de la empresa",
        },
        whatsapp: {
          title: "Conecta el WhatsApp de la empresa",
          subtitle: "Con el número conectado, las conversaciones llegan aquí y la IA ya puede responder.",
          connect: "Conectar ahora",
          connectAnother: "Conectar otro número",
          later: "Hacerlo después",
          next: "Continuar",
          showQr: "Mostrar el código QR",
          info: "En el celular de la empresa, abre WhatsApp, ve a Dispositivos vinculados y escanea el código QR.",
          noPermission: "Quien gestiona las conexiones conectará el número después.",
          verifyFirst: "Confirma tu correo para conectar WhatsApp. El enlace fue a {{email}}.",
          resend: "Reenviar el correo",
          alreadyConfirmed: "Ya confirmé",
          status: {
            CONNECTED: "Conectado",
            qrcode: "Falta escanear el código QR",
            OPENING: "Conectando…",
            PAIRING: "Conectando…",
            TIMEOUT: "Desconectado",
            DISCONNECTED: "Desconectado",
          },
        },
        team: {
          pending: "Invitación enviada",
          title: "Invita a quien va a atender contigo",
          subtitle: "La persona recibe un correo, crea la contraseña y entra en tu cuenta.",
          email: "Correo",
          emailPlaceholder: "nombre@tuempresa.com",
          profile: "Perfil",
          profileInfo: "El administrador también configura la cuenta: equipo, conexiones e IA.",
          profiles: {
            user: "Agente",
            admin: "Administrador",
          },
          send: "Invitar",
          sent: "Invitación enviada a {{email}}.",
          invited: "Invitaciones enviadas",
          verifyFirst: "Confirma tu correo para enviar invitaciones. El enlace fue a {{email}}.",
          resend: "Reenviar el correo",
          resent: "Lo enviamos de nuevo. Revisa tu bandeja de entrada.",
          emailInvalid: "Escribe un correo válido.",
          later: "Hacerlo después",
          next: "Continuar",
          noPermission: "Quien gestiona el equipo enviará las invitaciones después.",
        },
        done: {
          teamJoined: "El equipo ya entró",
          title: "Todo listo",
          subtitle: "Tu empresa ya está en Sttelar Talk. Lo que dejaste para después aparece en el panel.",
          aiOn: "Encendida",
          aiOff: "Todavía no encendida",
          whatsappOn: "Conectado",
          whatsappOff: "Todavía no conectado",
          teamNone: "Nadie invitado todavía",
          teamOne: "1 invitación enviada",
          teamMany: "{{count}} invitaciones enviadas",
          submit: "Ir al panel",
          submitContract: "Contratar {{plan}}",
        },
      },
      aiSetup: {
        confirmEmail: {
          title: "Primero, confirma tu correo",
          text: "Enviamos un enlace a {{email}}. La IA se libera en cuanto hagas clic en él.",
          check: "Ya confirmé",
          notYet: "Todavía no recibimos la confirmación. Haz clic en el enlace del correo e inténtalo de nuevo.",
          resend: "Reenviar el correo",
          resent: "Lo enviamos de nuevo. Revisa la bandeja de entrada y el correo no deseado.",
        },
        step: "Paso {{current}} de {{total}}",
        reviewNote: "Revisas todo antes de activar la IA.",
        skip: "Omitir por ahora",
        close: "Cerrar",
        source: {
          title: "Enseña a tu IA sobre tu negocio",
          subtitle: "Pega el sitio de la empresa y la IA arma la base de conocimiento sola.",
          subtitleDescription: "Cuenta cómo funciona el negocio y la IA organiza la base de conocimiento.",
          siteTitle: "Sitio de la empresa",
          siteText: "La IA lee las páginas del sitio y separa lo que importa para atender.",
          siteLabel: "Dirección del sitio",
          siteHint: "Solo lee las páginas de este sitio.",
          siteRequired: "Escribe la dirección del sitio.",
          siteSubmit: "Armar con el sitio",
          or: "o",
          noSite: "No tengo sitio, voy a describir el negocio",
          haveSite: "Tengo sitio",
          descriptionTitle: "Cuéntanos sobre el negocio",
          descriptionText: "Escríbelo como se lo explicarías a un agente nuevo.",
          descriptionLabel: "Sobre el negocio",
          descriptionPlaceholder: "Qué venden o hacen, dónde atienden, horarios, formas de pago, entrega, cambios...",
          descriptionCountShort: "{{count}} de al menos {{min}} caracteres",
          descriptionCount: "{{count}} caracteres",
          descriptionSubmit: "Armar con la descripción",
          learnTitle: "Lo que la IA va a aprender",
        },
        learn: {
          about: { name: "Sobre la empresa", text: "Qué hacen y cómo atienden." },
          offerings: { name: "Productos y servicios", text: "Lo que el cliente puede comprar o pedir." },
          hours: { name: "Horarios", text: "Cuándo atiende la empresa." },
          faq: { name: "Preguntas frecuentes", text: "Las dudas más comunes, con respuesta." },
          contact: { name: "Contacto y direcciones", text: "Teléfonos, correos y tiendas." },
          policies: { name: "Políticas", text: "Cambios, garantía, entrega y pago." },
        },
        preparing: {
          title: "Preparando tu IA",
          failedTitle: "No se pudo armar la base",
          subtitle: {
            site: "Leyendo el sitio y organizando todo para que responda a tus clientes.",
            description: "Organizando lo que contaste para que responda a tus clientes.",
          },
          stages: {
            readSite: "Leyendo el sitio",
            readDescription: "Leyendo la descripción",
            offerings: "Separando productos y servicios",
            faq: "Armando las preguntas frecuentes",
            review: "Revisando la base",
          },
          status: { done: "Listo", active: "En curso", queued: "En espera" },
          eta: { site: "Suele tardar menos de 1 minuto.", description: "Suele tardar unos segundos." },
          retry: "Intentar de nuevo",
          describeInstead: "Describir el negocio",
        },
        learned: {
          cardTitle: "Lo que aprendió",
          viewBase: "Ver y editar la base",
          nameLabel: "Nombre de la IA",
          defaultName: "Asistente",
          stepDone: "Aprendizaje completo",
          heroTitle: "¡Listo! Tu IA acaba de aprender sobre {{name}} 🎉",
          heroText: "Mira lo que descubrió y conversa con ella antes de ponerla a atender a tus clientes.",
          yourBusiness: "tu empresa",
          findings: { about: "Sobre la empresa", services: "Servicios y productos", brands: "Marcas atendidas", highlights: "Información útil" },
          nothingFound: "No encontró un resumen del negocio. Mira y completa la base.",
          missing: { site: "El sitio no trajo {{items}}. Completa la base para que responda mejor.", description: "La descripción no trajo {{items}}. Completa la base para que responda mejor." },
          missingItems: { hours: "el horario de atención", contact: "los contactos y direcciones", policies: "las políticas (cambios, garantía y pago)" },
          and: "y",
          complete: "Completar la base",
        },
        meet: {
          title: "¡Tu asistente quiere presentarse!",
          hello: "¡Hola! Soy {{name}}, asistente virtual de {{business}}.",
          helloDefault: "¡Hola! Soy la asistente virtual de {{business}}.",
          helpFallback: "Puedo responder las dudas de tus clientes sobre lo que aprendí.",
          ask: "Pregunta como si fueras un cliente:",
          free: "Escribir mi propia pregunta",
          preparing: "Preparando tu asistente...",
        },
        activate: {
          title: "¿Todo listo para que {{name}} atienda?",
          titleDefault: "¿Todo listo para que tu asistente atienda?",
          what: "Al activarla, responde al instante las conversaciones nuevas de WhatsApp y llama a tu equipo cuando hace falta.",
          whenConnected: "WhatsApp aún no está conectado: al activarla, empieza a responder en cuanto lo conectes.",
          undo: "Queda en Flujos, en \"Atendimento com IA\", donde puedes desactivarla cuando quieras.",
          cta: "Activar mi IA",
          skip: "Continuar sin activar",
          saved: "Todo queda guardado. Puedes activarla después.",
          savedAskEditor: "Todo queda guardado. Quien puede editar los Flujos activa la IA.",
        },
        knowledge: {
          title: "Base de conocimiento",
          subtitle: "Es lo que la IA usa para responder. Ajusta lo que quieras.",
          count: "{{count}} caracteres",
          pages: "Páginas leídas",
          cancel: "Cancelar",
          save: "Guardar",
        },
        test: {
          title: "Conversa con {{name}}",
          subtitle: "Escribe como si fueras un cliente. Nada de aquí le llega a nadie.",
          emptyTitle: "Haz una pregunta",
          emptyText: "Empieza con una de estas o escribe la tuya.",
          suggestions: {
            howItWorks: "¿Cómo funciona la atención?",
            services: "¿Qué servicios ofrecen?",
            hours: "¿Cuál es el horario de atención?",
          },
          placeholder: "Escribe un mensaje",
          send: "Enviar",
          thinking: "{{name}} está escribiendo...",
          titleDefault: "Conversa con tu asistente",
          thinkingDefault: "Tu asistente está escribiendo...",
          restart: "Empezar de nuevo",
          error: "No se pudo responder ahora. Intenta de nuevo.",
          praise: "¡Así puede atender tu IA a tus clientes!",
          wrong: "¿Viste algo mal en la respuesta?",
          fix: "Ajustar la base",
        },
        errors: { generic: "No se pudo terminar ahora. Intenta de nuevo." },
      },
      auth: {
        language: "Idioma",
        showPassword: "Mostrar contraseña",
        hidePassword: "Ocultar contraseña",
        backToLogin: "Volver al inicio de sesión",
        version: "Versión {{version}}",
        checkEmailTitle: "Revisa tu correo",
        invalidLinkTitle: "Este enlace ya no es válido",
        notArrived: "¿No llegó? Revisa la carpeta de spam o pídelo de nuevo.",
        resend: "Reenviar correo",
        resent: "Lo enviamos de nuevo. Revisa tu bandeja de entrada.",
        passwordHint: "Usa al menos 8 caracteres.",
        fields: {
          name: "Nombre completo",
          email: "Correo electrónico",
          password: "Contraseña"
        },
        errors: {
          generic: "No funcionó. Inténtalo de nuevo en un momento."
        },
        showcase: {
          label: "Sobre Sttelar Talk",
          headline: "Convierte tu WhatsApp en una central de atención inteligente.",
          lead: "Reúne tus números, tu equipo y una IA que responde a tus clientes automáticamente. Todo en un solo lugar.",
          preview: {
            customer: "¡Hola! Mi aire acondicionado dejó de enfriar. ¿Ustedes hacen esa reparación?",
            aiName: "Asistente",
            aiTag: "IA",
            ai: "¡Sí, la hacemos! 😊 ¿Tu equipo todavía está en garantía o ya está fuera de ella?",
            customer2: "Está fuera de garantía. ¿Puedo agendar una visita?",
            handoff: "La IA transfirió a Ana, de Soporte",
            humanName: "Ana",
            human: "¡Hola, Carla! 😊 Puedo revisar los horarios disponibles para agendar tu visita.",
            statusAi: "IA atendiendo",
            statusHuman: "Con Ana",
            otherLast1: "¡Gracias, funcionó!",
            otherLast2: "¿Puedes confirmar el horario de la visita?"
          },
          benefits: {
            together: { title: "Todas las conversaciones. Una sola pantalla.", text: "Organiza tus números de WhatsApp, agentes y clientes en un solo lugar." },
            ai: { title: "Tu IA y tu equipo trabajando juntos.", text: "La IA responde automáticamente y pasa las conversaciones a los agentes cuando hace falta." },
            free: { title: "Empieza gratis. Crece a tu ritmo.", text: "Prueba Sttelar Talk con el plan Starter y evoluciona a medida que tu negocio crece." }
          }
        },
        login: {
          title: "Inicia sesión en tu cuenta",
          subtitle: "Usa el correo y la contraseña de tu registro.",
          remember: "Mantener la sesión",
          forgot: "¿Olvidaste tu contraseña?",
          noAccount: "¿Nuevo en Sttelar Talk?",
          createAccount: "Empieza gratis",
          plans: "Conoce los planes"
        },
        signup: {
          title: "Crea tu cuenta",
          subtitle: "Empieza gratis en Starter, sin tarjeta.",
          planChosen: "Elegiste {{plan}}. La contratación se abre después del registro.",
          planLater: "Elegiste {{plan}}. La cuenta empieza gratis en Starter, y la contratación de {{plan}} es con Sttelar.",
          planMessage: "¡Hola! Quiero contratar {{plan}} de Sttelar Talk.",
          talkToSales: "Hablar con Sttelar",
          closedMessage: "¡Hola! Quiero empezar a usar Sttelar Talk.",
          submit: "Crear cuenta",
          haveAccount: "¿Ya tienes una cuenta?",
          login: "Iniciar sesión",
          sent: "Enviamos un enlace a {{email}}. Ábrelo para confirmar tu correo.",
          closedTitle: "Registro cerrado",
          closedText: "El registro de nuevas cuentas está cerrado por ahora. Habla con Sttelar para empezar.",
          limited: "Demasiados intentos desde aquí ahora. Inténtalo de nuevo en {{minutes}} min.",
          fixEmail: "Corregir correo",
          legalPrefix: "Leí y acepto los",
          legalTerms: "Términos de uso",
          legalAnd: "y la",
          legalPrivacy: "Política de privacidad",
          errors: {
            name: "Escribe tu nombre completo."
          }
        },
        forgot: {
          title: "¿Olvidaste tu contraseña?",
          subtitle: "Escribe el correo de tu cuenta. Te enviamos un enlace para crear una nueva contraseña.",
          submit: "Enviar enlace",
          sent: "Si existe una cuenta con {{email}}, el enlace llegará en unos instantes. Vale por 1 hora."
        },
        reset: {
          title: "Crea una nueva contraseña",
          password: "Nueva contraseña",
          confirm: "Repite la nueva contraseña",
          submit: "Guardar nueva contraseña",
          mismatch: "Las dos contraseñas no coinciden.",
          invalid: "Ya se usó o venció. Pide uno nuevo para crear tu contraseña.",
          newLink: "Pedir un nuevo enlace",
          doneTitle: "Contraseña cambiada",
          done: "Listo. Usa la nueva contraseña para entrar. Por seguridad, cerramos tus otras sesiones."
        },
        verify: {
          failedTitle: "No se pudo confirmar ahora",
          retry: "Intentar de nuevo",
          checking: "Confirmando tu correo...",
          okTitle: "Correo confirmado",
          ok: "Tu correo está confirmado. Escribe tu contraseña para entrar. ¿No la recuerdas o no creaste esta cuenta? Usa \"¿Olvidaste tu contraseña?\".",
          otherAccount: "El correo {{email}} está confirmado. Sigues conectado como {{current}}.",
          goToApp: "Ir al sistema",
          invalid: "Ya se usó, venció o fue reemplazado por uno más nuevo. Pide otro abajo.",
          resend: "Enviar un nuevo enlace",
          resent: "Si el correo todavía necesita confirmación, enviamos un enlace nuevo."
        },
        banner: {
          text: "Confirma tu correo para conectar WhatsApp, activar la IA, invitar personas, contratar y crear enlaces. Enviamos el enlace a {{email}}.",
          sent: "Enviamos un nuevo enlace a {{email}}.",
          close: "Cerrar aviso"
        },
        toasts: {
          success: "¡Inicio de sesión realizado con éxito!",
        },
        token: "Token",
      },
      connections: {
        status: {
          connected: "Conectado",
          disconnected: "Desconectado",
          opening: "Conectando",
          starting: "Iniciando…",
          qrcode: "Código QR",
          scanQr: "Escanea el código QR",
          timeout: "Tiempo agotado",
          failed: "Falla en la conexión",
          stopped: "Conexión detenida",
          pairing: "Emparejando",
          pending: "Pendiente",
        },
        adminTools: {
          tooltip: "Herramientas de Super Admin",
          eyebrow: "Super Admin · Herramientas de la conexión",
          close: "Cerrar",
          provider: {
            waha: "WhatsApp Web",
            "meta-api": "WhatsApp Business API",
            livechat: "LiveChat",
          },
          nav: {
            tickets: "Eliminar conversaciones",
            contacts: "Eliminar contactos",
            resolve: "Resolver conversaciones",
            history: "Historial",
            note: "Las eliminaciones no tienen vuelta atrás. Todo queda registrado en el historial con tu usuario.",
          },
          status: {
            open: "En atención",
            pending: "En espera",
            closed: "Resueltas",
          },
          period: {
            today: "Hoy",
            "7d": "Últimos 7 días",
            "30d": "Últimos 30 días",
            custom: "Personalizado",
            all: "Todo el período",
            from: "Desde",
            to: "Hasta",
            customRange: "{{from}} a {{to}}",
          },
          summary: {
            withGroups: "con grupos",
            withoutGroups: "sin grupos",
          },
          cleanup: {
            tickets: {
              intro: "Elimina las conversaciones de esta conexión con sus mensajes y archivos. Los contactos se mantienen.",
              statusTitle: "Estado de las conversaciones",
              periodTitle: "Inicio de la conversación",
              periodHint: "Cuenta la fecha en que comenzó la conversación.",
              includeGroups: "Incluir conversaciones de grupo",
              pickStatus: "marca al menos un estado",
              note: "Se ejecuta en segundo plano, por lotes. Las conversaciones que cambien después de la confirmación (mensaje nuevo, reapertura, transferencia) se conservan. No se puede deshacer.",
              submit: "Eliminar {{n}} conversación",
              submit_plural: "Eliminar {{n}} conversaciones",
            },
            contacts: {
              intro: "Elimina los contactos que tienen conversación en esta conexión, con todas sus conversaciones, mensajes y archivos — incluidas las conversaciones en otras conexiones.",
              periodTitle: "Registro del contacto",
              periodHint: "Cuenta la fecha en que se registró el contacto.",
              includeGroups: "Incluir contactos de grupo",
              note: "Se ejecuta en segundo plano, por lotes. Los contactos con una conversación nueva o modificada después de la confirmación se conservan. No se puede deshacer.",
              submit: "Eliminar {{n}} contacto",
              submit_plural: "Eliminar {{n}} contactos",
            },
            resolve: {
              intro: "Resuelve las conversaciones de esta conexión que están en atención o en espera, sin mensaje de cierre ni pedido de evaluación: el cliente no recibe aviso.",
              periodTitle: "Inicio de la conversación",
              periodHint: "Cuenta la fecha en que comenzó la conversación.",
              includeGroups: "Incluir conversaciones de grupo",
              note: "Se ejecuta en segundo plano, por lotes. Las conversaciones que cambien después de la confirmación (mensaje nuevo, aceptación, transferencia) se conservan. Si el cliente vuelve a escribir, la conversación vuelve como siempre.",
              submit: "Resolver {{n}} conversación",
              submit_plural: "Resolver {{n}} conversaciones",
            },
            groupsFound: "{{n}} con estos filtros",
            previewTitle: "Vista previa",
            calculating: "Calculando…",
            computedAt: "Calculada a las {{time}}",
            refresh: "Recalcular",
            range: "Período considerado: {{from}} a {{to}}",
            rangeAll: "Período considerado: todo el historial",
            invalidDates: "Elige las fechas de inicio y fin (la final no puede ser posterior a hoy).",
            recalculated: "La vista previa se recalculó — revisa las cifras y confirma de nuevo.",
          },
          stats: {
            tickets: "Conversaciones",
            messages: "Mensajes",
            media: "Archivos multimedia",
            contacts: "Contactos",
            contactsSplit: "solo de esta conexión: {{exclusive}} · compartidos: {{shared}}",
            ticketsHere: "en esta conexión: {{n}}",
            messagesInGroups: "enviados por ellos en grupos: {{n}}",
          },
          warnings: {
            liveTickets: "Las conversaciones en atención o en espera desaparecen de la pantalla de los agentes en cuanto la eliminación llega a ellas.",
            sharedContacts: "Contactos que también conversan por otras conexiones: {{shared}}. Sus conversaciones allí también se eliminarán ({{tickets}} en total):",
            otherConnection: "{{name}} — conversaciones: {{tickets}}, en atención o en espera: {{openOrPending}}",
            noConnection: "Sin conexión",
            liveTicketsHere: "Conversaciones en atención o en espera de esta conexión que se eliminarán: {{n}}.",
          },
          confirm: {
            eyebrow: "Acción irreversible",
            createTitle: "Confirmar eliminación",
            resumeTitle: "Reanudar operación",
            intro: "Esto eliminará de forma definitiva:",
            resumeIntro: "La operación continúa donde se detuvo, con los mismos filtros:",
            password: "Tu contraseña",
            phraseBefore: "Escribe",
            phraseAfter: "para confirmar",
            cancel: "Cancelar",
            submit: "Eliminar definitivamente",
            resumeSubmit: "Reanudar",
            resolve: {
              eyebrow: "Acción masiva",
              createTitle: "Confirmar resolución",
              intro: "Esto resolverá, sin avisar a los clientes:",
              submit: "Resolver conversaciones",
            },
            summary: {
              tickets: "Conversaciones: {{n}} ({{filters}})",
              contacts: "Contactos: {{n}}, {{shared}} compartidos con otras conexiones ({{filters}})",
              contactTickets: "Conversaciones: {{n}}, {{other}} de ellas en otras conexiones",
              messages: "Mensajes: {{messages}} · archivos multimedia: {{media}}",
              resumeProgress: "Ya procesados: {{processed}} de {{total}}",
              previewAt: "Cifras de la vista previa de las {{time}}",
            },
          },
          progress: {
            heading: {
              delete_tickets: "Eliminación de conversaciones",
              delete_contacts: "Eliminación de contactos",
              resolve_tickets: "Resolución de conversaciones",
            },
            count: "{{done}} de {{total}}",
            barLabel: "Progreso de la eliminación",
            deletedTickets: "Conversaciones eliminadas",
            deletedContacts: "Contactos eliminados",
            skippedTickets: "Conversaciones conservadas",
            skippedContacts: "Contactos conservados",
            messages: "Mensajes eliminados",
            media: "Archivos multimedia",
            queued: "En cola — empieza en cuanto termine la operación anterior del sistema.",
            canceling: "Terminando el lote actual. Lo que ya se eliminó no vuelve.",
            skippedNoteTickets: "Conversaciones conservadas: cambiaron después de la confirmación o dejaron de coincidir con los filtros.",
            skippedNoteContacts: "Contactos conservados: tuvieron una conversación nueva o modificada después de la confirmación.",
            failedHint: "La operación se detuvo por un error. Puedes reanudarla desde donde se detuvo.",
            startedBy: "Iniciada por {{user}} el {{date}}",
            finishedAt: "terminó el {{date}}",
            resumedBy: "reanudada por {{user}} el {{date}}",
            cancelRequestedBy: "cancelación solicitada por {{user}} el {{date}}",
            cancel: "Cancelar operación",
            cancelTitle: "¿Cancelar la eliminación?",
            cancelMessage: "El lote en curso termina y la operación se detiene. Lo que ya se eliminó no vuelve.",
            resume: "Reanudar",
            newCleanup: "Nueva eliminación",
            resolve: {
              barLabel: "Progreso de la resolución",
              processed: "Conversaciones resueltas",
              canceling: "Terminando el lote actual. Las conversaciones ya resueltas siguen resueltas.",
              cancelTitle: "¿Cancelar la resolución?",
              cancelMessage: "El lote en curso termina y la operación se detiene. Las conversaciones ya resueltas siguen resueltas.",
              newCleanup: "Nueva resolución",
            },
            keepRunning: "Volver",
          },
          statusLabel: {
            pending: "En cola",
            running: "En curso",
            cancel_requested: "Cancelando",
            canceled: "Cancelada",
            completed: "Completada",
            failed: "Falló",
            denied: "Denegada",
          },
          history: {
            intro: "Todo lo que se hizo en esta conexión con las herramientas de Super Admin, incluidos los intentos denegados.",
            empty: "Aún no hay operaciones en esta conexión.",
            loadMore: "Cargar más",
            by: "{{user}} · {{date}}",
            countsTickets: "Conversaciones: {{processed}} de {{total}}",
            countsContacts: "Contactos: {{processed}} de {{total}}",
            detailsTickets: "conservadas: {{skipped}} · mensajes: {{messages}}",
            detailsContacts: "conservados: {{skipped}} · mensajes: {{messages}}",
            detailsResolve: "conservadas: {{skipped}}",
            denied: {
              ERR_INVALID_PASSWORD: "Contraseña incorrecta",
              ERR_INVALID_CONFIRMATION_PHRASE: "Frase incorrecta",
            },
            operation: {
              delete_tickets: "Eliminar conversaciones",
              delete_contacts: "Eliminar contactos",
              resolve_tickets: "Resolver conversaciones",
            },
          },
          errors: {
            generic: "No se pudo completar. Inténtalo de nuevo.",
          },
        },
        passkey: {
          pill: "Passkey",
          pillConfirm: "Confirmar passkey",
          finish: "Completar passkey",
        },
        livechat: {
          tooltip: "LiveChat",
          active: "Activo",
          inactive: "Inactivo",
          copyCode: "Copiar código",
          preview: "Vista previa",
          enable: "Activar widget",
          disable: "Desactivar widget",
          codeCopied: "¡Código de instalación copiado!",
          enabled: "Widget activado",
          disabled: "Widget desactivado",
        },
        title: "Conexiones",
        toasts: {
          deleted: "¡Conexión con WhatsApp eliminada con éxito!",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? Esta acción no puede ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "¿Está seguro? Necesitará leer el código QR nuevamente.",
        },
        buttons: {
          add: "Agregar Conexión",
          disconnect: "desconectar",
          tryAgain: "Intentar nuevamente",
          qrcode: "CÓDIGO QR",
          newQr: "Nuevo CÓDIGO QR",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar sesión de WhatsApp",
            content: "Asegúrese de que su teléfono esté conectado a internet e intente nuevamente, o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando lectura del código QR",
            content: "Haga clic en el botón 'CÓDIGO QR' y lea el código QR con su teléfono para iniciar la sesión",
          },
          connected: {
            title: "¡Conexión establecida!",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono",
            content: "Asegúrese de que su teléfono esté conectado a internet y WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última actualización",
          default: "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        schedules: {
          title: "Horario de atención",
          description: "Activado, esta conexión usa un horario propio en lugar del de la empresa.",
          custom: "Horario personalizado",
          save: "Guardar horarios",
          saveFirst: "Guarda la conexión antes de configurar el horario personalizado.",
          saved: "Horarios actualizados.",
          restored: "Horario de la empresa restaurado.",
        },
        title: {
          add: "Agregar WhatsApp",
          edit: "Editar WhatsApp",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          expiresTicket: {
            number: "Ingrese un número válido",
            integer: "Use solo números enteros",
            min: "Mínimo 0 (desactivado)",
            max: "Máximo 43200 minutos (30 días)",
          },
          expiresInactiveMessage: {
            max: "Mensaje demasiado largo (máx 1000 caracteres)",
          },
          greetingAcceptedMessage: {
            max: "Mensaje demasiado largo (máx 1000 caracteres)",
          },
          livechatTitle: {
            required: "El título del widget es obligatorio",
            max: "Título demasiado largo (máx 40 caracteres)",
          },
          livechatColor: {
            invalid: "Color inválido (use el formato #RRGGBB)",
          },
          livechatDefaultCountryCode: {
            invalid: "Use el formato +54",
          },
          livechatAllowedDomains: {
            required: "Ingrese al menos un dominio autorizado",
          },
        },
        livechat: {
          sectionAppearance: "Apariencia del widget",
          sectionBehavior: "Comportamiento",
          installTitle: "Código de instalación",
          installHelp: "Pegue este código antes del cierre de la etiqueta body de su sitio.",
          preview: "Vista previa",
          createdCopyCode: "¡Conexión creada! Copie el código de instalación abajo.",
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario laboral",
        },
        form: {
          livechatTitle: "Título del widget",
          livechatSubtitle: "Subtítulo",
          livechatButtonText: "Texto del botón",
          livechatColor: "Color principal",
          livechatWelcomeMessage: "Mensaje de bienvenida",
          livechatPhoneRequired: "Exigir teléfono",
          livechatDefaultCountryCode: "Código de país por defecto",
          livechatDefaultCountryCodeHelp: "Ej.: +55",
          livechatDefaultQueue: "Cola por defecto",
          livechatNoQueue: "Sin cola",
          livechatAllowedDomains: "Dominios autorizados",
          livechatAllowedDomainsHelp: "Un dominio por línea (ej.: www.susitio.com). El widget solo funciona en los dominios listados.",
          livechatEnabled: "Widget activo",
          name: "Nombre",
          default: "Predeterminado",
          sendIdQueue: "Cola",
          timeSendQueue: "Redirigir a cola en X minutos",
          queueRedirection: "Redirección de Cola",
          outOfHoursMessage: "Mensaje fuera de horario",
          queueRedirectionDesc:
              "Seleccione una cola para redirigir los contactos que no tienen cola asignada",
          prompt: "Prompt",
          queue: "Cola de Transferencia",
          timeToTransfer: "Transferir después de x (minutos)",
          metaInfo: "Ingrese las credenciales de su aplicación de Meta para usar la API oficial de WhatsApp Cloud.",
          metaAccessToken: "Access Token",
          metaPhoneNumberId: "Phone Number ID",
          metaBusinessAccountId: "Business Account ID (opcional)",
          metaAppId: "App ID (opcional)",
          metaAppSecret: "App Secret (clave secreta de la app)",
          metaAppSecretHelp:
            "Facebook Developers → Configuración de la app → Básico → Clave secreta de la aplicación. Valida la firma de los webhooks. En blanco, los webhooks se aceptan sin verificación.",
          metaWebhookToken: "Webhook Verify Token",
          metaApiVersion: "Versión de la Graph API",
          autoCloseTitle: "Cierre automático",
          autoCloseHelp: "Cierra la conversación cuando el cliente no responde al agente tras el tiempo configurado. El mensaje de abajo se envía antes del cierre.",
          expiresTicket: "Tiempo de inactividad",
          expiresTicketUnit: "minutos",
          expiresInactiveMessage: "Mensaje de cierre",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          greetingAcceptedTitle: "Saludo al aceptar ticket",
          greetingAcceptedMessage: "Mensaje al aceptar la atención",
          greetingAcceptedMessagePlaceholder: "Ej.: {{ms}} *{{name}}*, mi nombre es *{{userName}}* y continuaré con tu atención.",
          greetingAcceptedMessageHelp: "Se envía cuando el agente acepta un ticket pendiente. Déjalo vacío para usar el texto predeterminado.",
          sendTransferQueueMessageTitle: "Mensaje al transferir de cola",
          sendTransferUserMessageTitle: "Mensaje al transferir de agente",
          sendTransferQueueAndUserMessageTitle: "Mensaje al transferir cola y agente",
          integration: "Integración"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado con éxito.",
      },
      passkeyModal: {
        title: "Conectar con Passkey",
        subtitle:
          "WhatsApp pidió una passkey para vincular este número. La firma ocurre en tu navegador, en la página de WhatsApp Web — ninguna contraseña o credencial pasa por Sttelar.",
        extChecking: "Buscando la extensión…",
        extPresent: "Extensión detectada",
        extAbsent:
          "Para firmar la passkey necesitas la extensión oficial de WAHA en tu navegador. Abre WhatsApp Web, confirmas con biometría/PIN y listo.",
        installChrome: "Instalar en Chrome",
        installFirefox: "Instalar en Firefox",
        recheck: "Ya la instalé, verificar",
        signButton: "Firmar con passkey",
        signing: "Abriendo WhatsApp Web…",
        submitting: "Enviando firma…",
        signHintTab:
          "Se abrió una pestaña de WhatsApp Web. Haz clic en el botón y confirma con tu biometría/PIN para firmar.",
        fallbackToggle: "¿No puedes instalar la extensión? Usar la consola (DevTools)",
        fallbackTitle: "Firmar desde la consola del navegador",
        fallbackStep1: "Abre web.whatsapp.com (con sesión) y pulsa F12 → pestaña Consola.",
        fallbackStep2: "Pega el script de abajo, pulsa Enter y confirma con tu biometría/PIN.",
        fallbackStep3: "La firma se copia automáticamente. Pégala en el campo de abajo y envíala.",
        copyScript: "Copiar script",
        copied: "¡Copiado!",
        pasteLabel: "Pega aquí la firma",
        pastePlaceholder: '{"id":"...","rawId":"...","type":"public-key","response":{...}}',
        submitAssertion: "Enviar firma",
        confirmTitle: "Confirma el código en tu teléfono",
        confirmSubtitle:
          "WhatsApp muestra un código en el dispositivo principal. Verifica que coincida con el número de abajo y confirma.",
        confirmCodeLabel: "Código",
        confirmLoadingCode: "Obteniendo el código…",
        confirmButton: "Ya confirmé en el teléfono",
        confirming: "Confirmando…",
        doneTitle: "¡Conectado!",
        doneSubtitle: "La conexión se vinculó correctamente mediante passkey.",
        close: "Cerrar",
        errors: {
          sign: "No se pudo firmar la passkey. Inténtalo de nuevo.",
          confirm: "No se pudo confirmar. Inténtalo de nuevo.",
          failed: "WhatsApp rechazó el emparejamiento. Genera un nuevo QR e inténtalo de nuevo.",
          assertionParse: "La firma pegada no es válida. Copia el JSON completo de la consola.",
        },
      },
      qrCodeModal: {
        title: "Utilice su WhatsApp:",
        steps: {
          one: "1 - Abra WhatsApp en su teléfono",
          two: {
            partOne: "2 - Toque en Más opciones en Android",
            partTwo: "o en Configuración",
            partThree: "en iPhone",
          },
          three:
              "3 - Toque en Dispositivos vinculados y luego en Vincular un dispositivo",
          four: "4 - Apunte su teléfono a esta pantalla para capturar el código QR",
        },
        waiting: "Esperando lectura del código QR",
        tabs: {
          qr: "Código QR",
          pairing: "Código de vinculación",
        },
        pairing: {
          title: "Vincular con número",
          phoneLabel: "Número con código de país y área",
          phonePlaceholder: "Ej: 5491155551234",
          generate: "Generar código",
          generating: "Generando...",
          instructions: "En WhatsApp del teléfono: Dispositivos vinculados → Vincular con número → ingrese el código abajo.",
          copy: "Copiar",
          copied: "¡Copiado!",
          invalidPhone: "Ingrese un número válido con código de país.",
        },
      },
      qrCode: {
        message: "Lea el código QR para iniciar la sesión",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto eliminado con éxito!",
          deletedAll: "¡Todos los contactos eliminados con éxito!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar ",
          deleteAllTitle: "Eliminar Todos",
          importTitle: "Importar contactos",
          deleteMessage:
              "¿Está seguro que desea eliminar este contacto? Todos los tickets relacionados se perderán.",
          deleteAllMessage:
              "¿Está seguro que desea eliminar todos los contactos? Todos los tickets relacionados se perderán.",
          importMessage: "¿Desea importar todos los contactos del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contactos",
          delete: "Eliminar Todos los Contactos",
          startConversation: "Iniciar conversación en WhatsApp",
          edit: "Editar contacto",
          deleteSingle: "Eliminar contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Acciones",
        },
      },
      contactImportModal: {
        title: "Planilla de contactos",
        labels: {
          import: "Importar contactos",
          result: "resultados",
          added: "Agregados",
          savedContact: "Contacto guardado",
          errors: "Errores",
        },
        buttons: {
          download: "Descargar planilla modelo",
          import: "Importar contactos",
          background: "Continuar en segundo plano",
          close: "Cerrar",
        },
        progress: {
          importing: "Importando {{processed}} de {{total}} contactos...",
          success: "{{count}} importados con éxito",
          errors: "{{count}} con errores",
          complete: "Importación completada",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Lenguaje",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar el ticket",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración probada con éxito!",
          addSuccess: "Integración agregada con éxito.",
          editSuccess: "Integración editada con éxito.",
        },
      },
      sideMenu: {
        name: "Menú Lateral Inicial",
        note: "Si está habilitado, el menú lateral iniciará cerrado",
        options: {
          enabled: "Abierto",
          disabled: "Cerrado",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          model: "Modelo",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes en el Historial",
        },
        formErrors: {
          name: {
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
            required: "El nombre es obligatorio",
          },
          prompt: {
            short: "Prompt demasiado corto",
            required: "Describa el entrenamiento para la Inteligencia Artificial",
          },
          modal: {
            required: "Informe el modelo deseado para el Prompt",
          },
          maxTokens: {
            required: "Informe el número máximo de tokens en la respuesta",
          },
          temperature: {
            required: "Informe la temperatura",
          },
          apikey: {
            required: "Informe la API Key",
          },
          queueId: {
            required: "Informe la cola",
          },
          maxMessages: {
            required: "Informe el número máximo de mensajes en el historial",
          },
        },
        success: "¡Prompt guardado con éxito!",
        setor: "Informe el sector",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Cola",
          max_tokens: "Máximo Tokens Respuesta",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no puede ser revertida!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Datos del contacto",
          basicInfo: "Información básica",
          complementaryInfo: "Datos complementarios",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de WhatsApp",
          email: "Email",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          whatsapp: "Conexión Origen: ",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          phone: {
            short: "Número demasiado corto",
            long: "Número demasiado largo",
          },
          email: {
            invalid: "Email inválido",
          },
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado con éxito.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          nameShort: "Nombre corto",
          nameLong: "Nombre largo",
          nameRequired: "El nombre es obligatorio",
          color: "Color",
          colorShort: "Color corto",
          colorLong: "Color largo",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          outOfHoursMessage: "Mensaje fuera de horario",
          ratingMessage: "Mensaje de evaluación",
          token: "Token",
          orderQueue: "Orden de la cola (Bot)",
          integrationId: "Integración",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        toasts: {
          success: "Cola guardada con éxito.",
          info: "Haga clic en guardar para registrar los cambios",
        },
        tabs: {
          queueData: "Datos de la cola",
          attendanceTime: "Horarios de Atención",
        },
      },
      userModal: {
        loading: "Cargando datos del usuario...",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        tabs: {
          personal: "Datos personales",
          access: "Acceso",
          service: "Atención",
        },
        form: {
          name: "Nombre",
          email: "Email",
          cpf: "CPF",
          password: "Contraseña",
          optionalSuffix: "· opcional",
          passwordKeepHint: "Déjala en blanco para no cambiarla",
          allTicketSwitchTitle: "Avisos de conversaciones sin sector",
          allTicketSwitchDescription:
            "Recibe también los avisos de las conversaciones que llegan sin sector. Quién ve cada conversación se define en Configuración → Conversaciones.",
          typingSwitchTitle: "Mostrar “escribiendo…” al cliente",
          typingSwitchDescription: "Mientras escribes, el cliente ve “escribiendo…” en WhatsApp.",
          addQueue: "Agregar cola",
          addAllQueues: "Agregar todas las colas",
          noQueuesSelected: "Sin colas seleccionadas",
          noQueueAvailable: "Sin colas disponibles",
          noConnectionAvailable: "Sin conexiones disponibles",
          maxCompanies: "Máx. empresas",
          maxCompaniesHelper: "Cuántas empresas puede atender este usuario",
          groupCompanies: "Empresas del grupo",
          changePhoto: "Cambiar foto",
          profile: "Perfil",
          jobRole: "Cargo",
          noJobRole: "Sin cargo",
          operationalType: "Tipo operativo",
          customizePermissions: "Personalizar permisos",
          countsInIndicators: "Cuenta en los indicadores de atención",
          countsInIndicatorsHelp: "Desactivado, la persona queda fuera de los números de atención.",
          attendant: "Atendente",
          supervisor: "Supervisor",
          whatsapp: "Conexión Predeterminada",
          noWhatsapp: "Sin conexión",
          queues: "Colas de Usuario",
          profileImage: "Cambiar Foto",
          uploadPhoto: "Cargar Foto",
          allTicket: "Ticket Sin Cola [Invisible]",
          allTicketEnabled: "Habilitado",
          allTicketDesabled: "Deshabilitado",
          accessScope: "Alcance de Acceso *",
          accessScopeFull: "Completo (Atención + Interno)",
          accessScopeAttendance: "Solo Atención (Tickets, WhatsApp)",
          accessScopeInternal: "Solo Interno (Chat, CRM)",
          internalLockedNotice: "El Chat Interno no está incluido en tu plan. Realiza un upgrade en Ajustes → Facturación para habilitarlo.",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          password: {
            short: "Contraseña demasiado corta",
            long: "Contraseña demasiado larga",
          },
          email: {
            required: "El email es obligatorio",
            invalid: "Email inválido",
          },
        },
        labels: {
          liberations: "Liberaciones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          saveChanges: "Guardar cambios",
          cancel: "Cancelar",
        },
        success: "Usuario guardado con éxito.",
      },
      scheduleModal: {
        title: {
          add: "Nueva Programación",
          edit: "Editar Programación",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha de Programación",
          sentAt: "Fecha de Envío",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Programación guardada con éxito.",
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
        },
        form: {
          name: "Nombre",
          color: "Color",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Etiqueta guardada con éxito.",
      },
      chat: {
        toasts: {
          fillTitle: "Por favor, complete el título de la conversación.",
          fillUser: "Por favor, seleccione al menos un usuario.",
        },
        modal: {
          title: "Conversación",
          titleField: "Título",
        },
        confirm: {
          title: "Eliminar Conversación",
          message: "Esta acción no puede ser revertida, ¿confirmar?",
        },
        chats: "Chats",
        messages: "Mensajes",
        noTicketMessage: "Seleccione un ticket para comenzar a chatear.",
        buttons: {
          close: "Cerrar",
          save: "Guardar",
          new: "Nueva",
          newChat: "Nuevo",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTRE Y SUELTE ARCHIVOS EN EL CAMPO DE ABAJO",
          titleFileList: "Lista de archivo(s)",
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        noQueue: "Sin cola",
      },
      tickets: {
        splitter: {
          label: "Cambiar el ancho de la lista de conversaciones",
          hint: "Arrastra para ajustar el ancho. Usa las flechas del teclado o haz doble clic para restaurar.",
        },
        toolbar: {
          menu: "Opciones de conversaciones",
          unread: "No leídas",
          filters: "Filtros",
          search: "Buscar conversaciones",
        },
        handledByAi: "Atendido por IA: {{name}}",
        toasts: {
          deleted: "La atención que estabas atendiendo fue eliminada.",
          unauthorized: "Acceso no permitido",
        },
        filters: {
          user: "Filtrar por usuarios",
          tags: "Filtrar por etiquetas",
          connection: "Filtrar por conexión",
          queues: "Filtrar por colas",
          emptyQueueWarning: "Seleccione al menos una cola (o 'Sin cola') para aplicar el filtro.",
          tagsPlaceholder: "Filtrar por etiquetas",
          tagsPopoverTitle: "Etiquetas",
          tagsSearchPlaceholder: "Buscar",
          noTagsOption: "Sin etiquetas",
          noTagsFound: "Ninguna etiqueta encontrada",
          singleSelected: "seleccionado",
          multipleSelected: "seleccionados",
          showingAll: "Mostrando todos los elementos",
          selectAll: "Aplicar todas",
          queuesPopoverTitle: "Colas",
          queuesSearchPlaceholder: "Buscar",
          noQueuesFound: "Ninguna cola encontrada",
          noQueueSelected: "Ninguna cola seleccionada — elija al menos una",
          clear: "Limpiar",
          loadingTags: "Cargando etiquetas...",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Abiertos" },
          groups: { title: "Grupos" },
          closed: { title: "Resueltos" },
          search: { title: "Búsqueda" },
        },
        search: {
          placeholder: "Buscar atención y mensajes",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldUserLabel: "Agente",
        fieldQueueLabel: "Transferir a cola",
        fieldQueuePlaceholder: "Seleccione una cola",
        userPlaceholder: "Seleccione un agente",
        userPopoverTitle: "Agentes",
        userSearchPlaceholder: "Buscar agentes",
        clearUserOption: "Limpiar selección",
        noUsersFound: "Ningún agente encontrado",
        showingAllUsers: "Mostrando todos los agentes",
        noOptions: "Ningún usuario encontrado con ese nombre",
        noSelection: "Seleccione un agente o una cola para transferir.",
        queuePopoverTitle: "Colas",
        queueSearchPlaceholder: "Buscar colas",
        noQueueOption: "Sin cola",
        noQueuesFound: "Ninguna cola encontrada",
        singleSelected: "elemento seleccionado",
        showingAll: "Mostrando todas las colas",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        empty: {
          openTitle: "¡Todo tranquilo por aquí!",
          openDescription: "No tienes conversaciones en curso en este momento.",
          openAllDescription: "No hay conversaciones en curso en este momento.",
          pendingTitle: "¡Cola vacía. Bien!",
          pendingDescription: "Ninguna conversación esperando atención. ¡Todo al día por aquí!",
          groupsTitle: "No hay conversaciones de grupo",
          groupsDescription: "No hay conversaciones de grupo en curso en este momento.",
          pendingCount: "{{count}} conversación esperando atención",
          pendingCount_plural: "{{count}} conversaciones esperando atención",
          pendingCountMore: "{{count}} o más conversaciones esperando atención",
          viewPending: "Ver pendientes",
          searchTitle: "No se encontraron conversaciones",
          searchDescription: "No encontramos conversaciones para “{{term}}”. Prueba otro nombre, número o término.",
          searchFilteredDescription: "No encontramos conversaciones para “{{term}}” con los filtros actuales. Prueba otro término o ajusta los filtros.",
          filteredTitle: "No se encontraron conversaciones",
          filteredDescription: "Prueba cambiar los filtros para ver más conversaciones.",
          adjustFilters: "Ajustar filtros",
        },
        pendingHeader: "En espera",
        pendingHeaderTab: "Pendiente",
        assignedHeader: "En atención",
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage:
            "Ninguna atención encontrada con ese estado o término buscado",
        buttons: {
          accept: "Aceptar",
          closed: "Finalizar",
          reopen: "Reabrir",
        },
      },
      ticketsListItem: {
        tooltip: {
          chatbot: "Chatbot",
          peek: "Espiar Conversación",
          unreplied: "Sin respuesta hace más de 10 minutos",
        },
        noQueue: "SIN COLA",
        viewLocation: "Ver ubicación en el mapa",
      },
      ticketAdvanced: {
        selectTicket: "Seleccionar Ticket",
        ticketNav: "Ticket",
        attendanceNav: "Atenciones",
      },
      newTicketModal: {
        title: "Elegir un contacto",
        searchPlaceholder: "Buscar por nombre o telefono",
        tagsPlaceholder: "Etiquetas",
        tagsPopoverTitle: "Etiquetas",
        tagsSearchPlaceholder: "Buscar",
        showingAll: "Mostrando todos los elementos",
        singleSelected: "elemento seleccionado",
        multipleSelected: "elementos seleccionados",
        clear: "Limpiar",
        noTagsOption: "Sin etiquetas",
        noTagsFound: "No se encontraron etiquetas",
        ticketTitle: "Elija un ticket",
        createTicket: "Crear ticket",
        existingContactPlaceholder: "Busque un contacto existente",
        contactSearchHint: "Escriba al menos 3 caracteres para buscar un contacto",
        queuePlaceholder: "Seleccione una cola",
        allQueuesOption: "Todas las colas",
        queuePopoverTitle: "Colas",
        queueSearchPlaceholder: "Buscar colas",
        noQueueOption: "Crear sin cola",
        noQueuesFound: "No se encontro ninguna cola",
        connectionPlaceholder: "Seleccione una conexion",
        allConnectionsOption: "Todas las conexiones",
        connectionPopoverTitle: "Conexiones",
        loadingConnections: "Cargando conexiones...",
        noConnectionsAvailable: "No hay conexiones disponibles",
        newContact: "Nuevo contacto",
        emptyState: "No se encontro ningun contacto",
        emptyTicketsState: "No se encontro ningun ticket",
        loadingTags: "Cargando etiquetas...",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      locationPreview: {
        button: "Visualizar",
        openInMaps: "Abrir en Maps",
        showMap: "Ver en el mapa",
        hideMap: "Ocultar mapa",
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          dashboardGeral: "Panel del Grupo",
          connections: "Conexiones",
          tickets: "Atenciones",
          quickMessages: "Respuestas Rápidas",
          tasks: "Tareas",
          contacts: "Contactos",
          queues: "Colas & Chatbot",
          tags: "Etiquetas",
          academy: "Capacitación",
          manageAcademy: "Gestionar Capacitación",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuraciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programaciones",
          campaigns: "Campañas",
          flows: "Flujos",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          files: "Lista de archivos",
          prompts: "IA",
          queueIntegration: "Integraciones",
          metaTemplates: "Plantillas Meta",
          smartApproaches: "Abordajes inteligentes",
          integrations: "Integraciones",
          workOrders: "Órdenes de servicio",
        },
        appBar: {
          refresh: "Recargar página",
          notRegister: "Sin notificaciones",
          language: "Idioma",
          jobRole: "Cargo",
          noJobRole: "Sin cargo",
          appearance: "Apariencia",
          notificationVolume: "Sonido de Notificaciones",
          greeting: {
            hello: "Hola",
            welcome: "Bienvenido a",
            active: "Activo hasta",
          },
          user: {
            profile: "Perfil",
            security: "Seguridad de la cuenta",
            logout: "Salir",
          },
        },
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Lenguaje",
          lastUpdate: "Última actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
              "¿Está seguro? ¡Esta acción no puede ser revertida! y será eliminada de las colas y conexiones vinculadas",
        },
      },
      files: {
        title: "Lista de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "¡Lista eliminada con éxito!",
          deletedAll: "¡Todas las listas fueron eliminadas con éxito!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Eliminar Todos",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          deleteMessage: "¿Está seguro que desea eliminar esta lista?",
          deleteAllMessage: "¿Está seguro que desea eliminar todas las listas?",
        },
      },
      messagesAPI: {
        title: "API",
        labels: {
          doc: "Documentación para envío de mensajes",
          method: "Métodos de Envío",
          textMessage: "Mensaje de Texto",
          mediaMessage: "Mensaje Multimedia",
          instructions: "Instrucciones",
          observations: "Observaciones importantes",
          before1: "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes.",
          before2: "Para realizar el registro acceda al menú 'Conexiones', haga clic en el botón editar de la conexión e inserte el token en el campo correspondiente.",
          numberDescription: "El número para envío no debe tener máscara o caracteres especiales y debe estar compuesto por:",
          countryCode: "Código del País",
          number: "Número",
          textMessage2: "1. Mensajes de Texto",
          textMessageInstructions: "A continuación la lista de información necesaria para enviar mensajes de texto:",
          method2: "Método",
          e: "y",
          tests: "Prueba de Envío",
          mediaMessage2: "2. Mensajes Multimedia",
        },
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        toasts: {
          unauthorized: "¡Esta empresa no tiene permiso para acceder a esta página! Le estamos redirigiendo.",
          success: "¡Mensaje enviado con éxito!",
        },
        buttons: {
          send: "Enviar",
        },
      },
      notifications: {
        noTickets: "Ninguna notificación.",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin adjunto",
        confirmationModal: {
          deleteTitle: "Eliminación",
          deleteMessage: "¡Esta acción es irreversible! ¿Desea continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "¡Atajo agregado con éxito!",
          deleted: "¡Atajo eliminado con éxito!",
        },
        validation: {
          shortcodeRequired: "Ingrese el atajo de la respuesta rápida.",
          messageRequired: "Ingrese el mensaje de la respuesta rápida.",
        },
        dialog: {
          title: "Mensaje Rápido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Estado",
        },
      },
      leadSettings: {
        tabs: {
          apiTokens: "Tokens de API",
          leadStatuses: "Estados de las tarjetas",
        },
        tokens: {
          newToken: "Nuevo Token",
          webhookTitle: "URL del Webhook para N8N",
          webhookHint: "Envía el header:",
          copyUrl: "Copiar URL",
          urlCopied: "¡URL del webhook copiada!",
          emptyTitle: "Ningún token creado",
          emptyDescription: "Crea un token de API para integrar con N8N u otras plataformas",
          createdAt: "Creado en:",
          deleteTitle: "Eliminar Token de API",
          deleteMessage: "¿Estás seguro de que deseas eliminar el token \"{name}\"? Esta acción no se puede deshacer y todas las integraciones que usan este token dejarán de funcionar.",
          deleted: "Token eliminado con éxito",
        },
        statuses: {
          newStatus: "Nuevo Estado",
          emptyTitle: "Ningún estado creado",
          emptyDescription: "Crea estados personalizados para organizar tus tarjetas",
          default: "Predeterminado",
          pending: "Pendiente",
          completed: "Completado",
          order: "Orden",
          deleteTitle: "Eliminar Estado",
          deleteMessage: "¿Estás seguro de que deseas eliminar el estado \"{name}\"? Las tarjetas con este estado serán movidas al estado predeterminado.",
          deleted: "Estado eliminado con éxito",
        },
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          greeting: "Saludo",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
        },
      },
      contactLists: {
        title: "Listas de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lista",
        },
        dialog: {
          name: "Nombre",
          nameShort: "Nombre corto",
          nameLong: "Nombre largo",
          nameRequired: "El nombre es obligatorio",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no puede ser revertida.",
        },
        toasts: {
          deleted: "Registro eliminado",
          success: "Operación realizada con éxito",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Buscar",
        report: {
          title: "Informe de",
          title2: "Campaña",
          of: "de",
          validContacts: "Contactos válidos",
          delivered: "Entregados",
          connection: "Conexión",
          contactList: "Lista de Contactos",
          schedule: "Programación",
          conclusion: "Conclusión",
        },
        config: {
          interval: "Intervalos",
          randomInterval: "Intervalo Aleatorio de Envío",
          biggerInterval: "Intervalo Mayor Después de",
          greaterInterval: "Intervalo de Envío Mayor",
          noInterval: "Sin Intervalo",
          second: "segundo",
          seconds: "segundos",
          notDefined: "No definido",
          addVariable: "Agregar Variable",
          save: "Guardar Configuración",
          shortcut: "Atajo",
          content: "Contenido",
          close: "Cerrar",
          add: "Agregar",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listas de Contactos",
        },
        status: {
          inactive: "Inactiva",
          programmed: "Programada",
          inProgress: "En progreso",
          canceled: "Cancelada",
          finished: "Finalizada",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Lista de Contactos",
          status: "Estado",
          scheduledAt: "Programación",
          completedAt: "Completada",
          confirmation: "Confirmación",
          actions: "Acciones",
          notDefined: "No definida",
          notDefined2: "No definido",
          notScheduled: "Sin programación",
          notConcluded: "No concluida",
          stopCampaign: "Detener Campaña",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Lectura",
          form: {
            name: "Nombre",
            nameShort: "Nombre corto",
            nameLong: "Nombre largo",
            helper: "Utilice variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
            nameRequired: "El nombre es obligatorio",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            messagePlaceholder: "Contenido del mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programación",
            confirmation: "Confirmación",
            contactList: "Lista de Contactos",
            tagList: "Lista de Etiquetas",
            fileList: "Lista de Archivos",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no puede ser revertida.",
        },
        toasts: {
          configSaved: "Configuración guardada",
          success: "Operación realizada con éxito",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro eliminado",
        },
      },
      announcements: {
        active: "Activo",
        inactive: "Inactivo",
        title: "Informativos",
        searchPlaceholder: "Buscar",
        high: "Alta",
        medium: "Media",
        low: "Baja",
        buttons: {
          add: "Nuevo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones",
        },
        dialog: {
          edit: "Edición de Informativo",
          add: "Nuevo Informativo",
          update: "Editar Informativo",
          readonly: "Solo Lectura",
          form: {
            priority: "Prioridad",
            required: "Campo obligatorio",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no puede ser revertida.",
        },
        toasts: {
          success: "Operación realizada con éxito",
          deleted: "Registro eliminado",
          info: "¡Esta empresa no tiene permiso para acceder a esta página! Le estamos redirigiendo.",
        },
      },
      campaignsConfig: {
        title: "Configuración de Campañas",
      },
      queues: {
        title: "Colas & Chatbot",
        table: {
          id: "ID",
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de bienvenida",
          actions: "Acciones",
          orderQueue: "Ordenación de la cola (bot)",
        },
        buttons: {
          add: "Agregar cola",
        },
        emptyState: "No se encontraron colas",
        toasts: {
          success: "Cola eliminada con éxito.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no puede ser revertida! Las atenciones de esta cola seguirán existiendo, pero no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Colas",
      },
      users: {
        title: "Usuarios",
        table: {
          id: "ID",
          name: "Nombre",
          email: "Email",
          profile: "Perfil",
          actions: "Acciones",
          admin: "Admin",
          user: "Usuario",
        },
        buttons: {
          add: "Agregar usuario",
        },
        invites: {
          button: "Invitar por correo",
          title: "Invitar por correo",
          subtitle: "La persona recibe un enlace para crear la contraseña y entrar en esta cuenta. La invitación vale 7 días.",
          email: "Correo",
          emailPlaceholder: "nombre@empresa.com",
          emailInvalid: "Escribe un correo válido.",
          profile: "Perfil",
          license: "Licencia",
          profiles: {
            user: "Agente",
            admin: "Administrador",
          },
          send: "Enviar invitación",
          cancel: "Cancelar",
          sent: "Invitación enviada a {{email}}.",
          pendingTitle: "{{count}} invitación pendiente",
          pendingTitle_plural: "{{count}} invitaciones pendientes",
          expiresIn: "vence en {{count}} día",
          expiresIn_plural: "vence en {{count}} días",
          expired: "vencida",
          invitedBy: "enviada por {{name}}",
          resend: "Reenviar",
          resent: "Invitación reenviada a {{email}}.",
          revoke: "Eliminar",
          revokeTitle: "¿Eliminar la invitación?",
          revokeText: "El enlace enviado a {{email}} deja de valer.",
          revokeConfirm: "Eliminar invitación",
          revoked: "Invitación eliminada.",
        },
        emptyState: "No se encontraron usuarios",
        toasts: {
          created: "Usuario creado con éxito.",
          deleted: "Usuario eliminado con éxito.",
          updated: "Usuario actualizado con éxito.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Todos los datos del usuario se perderán. Las atenciones abiertas de este usuario serán movidas a la cola.",
        },
      },
      todolist: {
        input: "Nueva tarea",
        buttons: {
          add: "Agregar",
          save: "Guardar",
        },
      },
      helps: {
        title: "Centro de Ayuda",
      },
      schedules: {
        title: "Programaciones",
        confirmationModal: {
          deleteTitle: "¿Está seguro que desea eliminar esta Programación?",
          deleteMessage: "Esta acción no puede ser revertida.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha de Programación",
          sentAt: "Fecha de Envío",
          status: "Estado",
          actions: "Acciones",
        },
        messages: {
          date: "Fecha",
          time: "Hora",
          event: "Evento",
          allDay: "Todo el Día",
          week: "Semana",
          work_week: "Programaciones",
          day: "Día",
          month: "Mes",
          previous: "Anterior",
          next: "Siguiente",
          yesterday: "Ayer",
          tomorrow: "Mañana",
          today: "Hoy",
          agenda: "Agenda",
          noEventsInRange: "No hay programaciones en el período.",
          showMore: "más",
        },
        buttons: {
          add: "Nueva Programación",
        },
        toasts: {
          deleted: "Programación eliminada con éxito.",
        },
      },
      tags: {
        title: "Etiquetas",
        confirmationModal: {
          deleteTitle: "¿Está seguro que desea eliminar esta Etiqueta?",
          deleteMessage: "Esta acción no puede ser revertida.",
          deleteAllMessage: "¿Está seguro que desea eliminar todas las Etiquetas?",
          deleteAllTitle: "Eliminar Todas",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Registros Etiquetados",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Etiqueta",
          deleteAll: "Eliminar Todas",
        },
        toasts: {
          deletedAll: "¡Todas las Etiquetas eliminadas con éxito!",
          deleted: "Etiqueta eliminada con éxito.",
        },
      },
      accessControl: {
        tabs: {
          people: "Personas",
          roles: "Perfiles de acceso",
          history: "Historial",
        },
        tabsLabel: "Partes de Equipo y permisos",
        roles: {
          agent: "Agente",
          supervisor: "Supervisor",
          admin: "Administrador",
        },
        roleHelp: {
          agent: "Atiende las conversaciones y cuida los contactos.",
          supervisor: "Atiende y acompaña al equipo: informes, flujos y envíos, solo para ver.",
          admin: "Todo, incluso el equipo, la empresa y los permisos.",
        },
        licenses: {
          full: "Completa",
          attendance: "Solo Atención",
          internal: "Solo Interno",
        },
        scopes: {
          none: "Ninguna",
          own: "Solo las propias",
          queues: "De sus colas",
          company: "De toda la empresa",
        },
        groups: {
          tickets: "Atención",
          contacts: "Contactos y recursos de atención",
          reports: "Informes",
          settings: "Configuración",
          team: "Equipo y acceso",
          company: "Empresa",
          marketing: "Marketing",
          automation: "Automatización e IA",
          crm: "CRM y chat interno",
        },
        origin: {
          default: "Estándar del perfil",
          granted: "Concedida",
          denied: "Denegada",
        },
        locks: {
          plan: "No incluido en el plan",
          module: "Módulo no activado",
          setting: "Desactivado por Sttelar",
          license: "Licencia {{license}}",
          admin_only: "Solo para Administrador",
          actor: "Usted no tiene este permiso",
        },
        readOnly: {
          own: "Usted no puede cambiar su propio acceso.",
          impersonating: "No se pueden cambiar accesos mientras usa \"Acceder como\" un usuario.",
          other_companies: "Esta persona también está en otra empresa que usted no administra.",
          above: "Esta persona tiene más acceso que usted.",
        },
        people: {
          search: "Buscar por nombre o correo",
          allRoles: "Todos los perfiles",
          allLicenses: "Todas las licencias",
          customized: "Con excepciones",
          columns: {
            person: "Persona",
            role: "Perfil",
            customizations: "Excepciones",
            license: "Licencia",
            queues: "Colas",
            lastAccess: "Último acceso",
          },
          grantedOne: "1 concedida",
          grantedMany: "{{count}} concedidas",
          deniedOne: "1 denegada",
          deniedMany: "{{count}} denegadas",
          noQueues: "Sin colas",
          never: "Nunca entró",
          empty: "No se encontró a nadie.",
          open: "Abrir el acceso de {{name}}",
          pageRange: "{{from}}–{{to}} de {{total}}",
          previousPage: "Página anterior",
          nextPage: "Página siguiente",
        },
        panel: {
          back: "Personas",
          role: "Perfil de acceso",
          restore: "Restaurar el estándar del perfil",
          restoreTitle: "¿Restaurar el estándar del perfil?",
          restoreBody: "Las excepciones de {{name}} se quitan y el acceso vuelve al estándar de {{role}}.",
          restoreConfirm: "Restaurar",
          restoreDirty: "Guarde o descarte los cambios antes.",
          restored: "El acceso de {{name}} volvió al estándar del perfil.",
          searchPermissions: "Buscar permiso",
          onlyCustomized: "Solo excepciones",
          onlySensitive: "Solo sensibles",
          summary: "{{on}} de {{total}}",
          sensitive: "Sensible",
          backToDefault: "Volver al estándar",
          dependsOn: "Depende de: {{names}}",
          nothingFound: "No se encontró ningún permiso.",
          discard: "Descartar",
          save: "Guardar",
          confirmTitle: "¿Guardar el acceso de {{name}}?",
          confirmRole: "Perfil: {{from}} → {{to}}",
          confirmScope: "Conversaciones: {{from}} → {{to}}",
          confirmGains: "Pasa a tener",
          confirmLoses: "Deja de tener",
          confirmNothing: "El acceso queda igual: solo cambian las excepciones.",
          saved: "Acceso de {{name}} guardado.",
          reloaded: "Otra persona cambió este acceso. Mostramos el actual.",
          loadError: "No fue posible cargar el acceso de esta persona.",
          previewError: "No fue posible verificar los cambios ahora. Inténtelo de nuevo.",
        },
        rolesTab: {
          intro: "Lo que cada perfil tiene por defecto. Las excepciones de cada persona están en la pestaña Personas.",
          permission: "Permiso",
          included: "Incluido",
          notIncluded: "No incluido",
        },
        history: {
          person: "Persona",
          allPeople: "Todas las personas",
          loadingPeople: "Cargando…",
          noPeople: "Nadie con ese nombre.",
          morePeople: "Mostrando {{shown}} de {{total}}. Escriba para encontrar a otra persona.",
          from: "Desde",
          to: "Hasta",
          actions: {
            conversion: "Perfil definido en el cambio a los permisos",
            user: {
              create: "Registro",
              update: "Perfil o licencia cambiado",
            },
            access: {
              overrides: "Excepciones cambiadas",
              reset: "Estándar del perfil restaurado",
            },
          },
          by: "por {{name}}",
          byAs: "por {{name}}, como {{as}}",
          support: "Soporte Sttelar",
          system: "Sistema",
          removed: "Persona eliminada",
          role: "Perfil: {{from}} → {{to}}",
          license: "Licencia: {{from}} → {{to}}",
          granted: "Concedida: {{name}}",
          denied: "Denegada: {{name}}",
          cleared: "Volvió al estándar: {{name}}",
          empty: "Ningún cambio en el período.",
          loadMore: "Cargar más",
        },
        permissions: {
          tickets: {
            view: {
              title: "Ver y atender conversaciones",
              help: "Lista, abrir, responder, aceptar y reabrir. El nivel define qué conversaciones.",
            },
            view_no_queue: {
              title: "Ver conversaciones sin cola",
              help: "Las que aún no entraron en ninguna cola.",
            },
            view_groups: {
              title: "Ver conversaciones de grupos",
              help: "Los grupos de WhatsApp.",
            },
            create: {
              title: "Iniciar conversación",
              help: "Con un contacto o un número nuevo.",
            },
            take_over: {
              title: "Asumir conversación de un colega",
              help: "Quitar la conversación a otro agente.",
            },
            transfer: {
              title: "Transferir conversación",
              help: "A una cola, agente o IA, o devolver a la cola.",
            },
            close: {
              title: "Cerrar conversación",
              help: "Marcar la conversación como resuelta.",
            },
            manage_connection: {
              title: "Cambiar la conexión de la conversación",
              help: "Y sincronizar el historial.",
            },
            spy: {
              title: "Espiar conversación",
              help: "Ver sin asumir.",
            },
            bulk_actions: {
              title: "Acciones masivas",
              help: "Cerrar y reasignar varias conversaciones a la vez.",
            },
            delete: {
              title: "Eliminar conversación",
              help: "Borra la conversación y los mensajes.",
            },
          },
          messages: {
            manage_others: {
              title: "Borrar o editar mensaje de un colega",
              help: "Mensajes enviados por otra persona.",
            },
          },
          notes: {
            manage_others: {
              title: "Gestionar notas de colegas",
              help: "Editar la de otra persona y borrar cualquiera.",
            },
          },
          contacts: {
            edit: {
              title: "Crear y editar contactos",
              help: "Nombre, número y datos del contacto.",
            },
            import: {
              title: "Importar contactos",
              help: "De una planilla o de WhatsApp.",
            },
            wallet_manage: {
              title: "Definir el responsable del contacto",
              help: "La cartera de clientes.",
            },
            delete: {
              title: "Eliminar contacto",
              help: "Las conversaciones del contacto también se borran.",
            },
          },
          tags: {
            manage: {
              title: "Gestionar etiquetas",
              help: "Crear, editar y eliminar.",
            },
          },
          quick_replies: {
            manage_company: {
              title: "Gestionar respuestas rápidas de la empresa",
              help: "Las que usa todo el equipo.",
            },
          },
          templates: {
            use: {
              title: "Enviar plantillas",
              help: "Plantillas aprobadas por Meta.",
            },
            manage: {
              title: "Gestionar plantillas",
              help: "Crear, editar y eliminar en Meta.",
            },
          },
          ai: {
            assist: {
              title: "Reescribir con IA",
              help: "Mejorar el texto antes de enviar.",
            },
          },
          reports: {
            view: {
              title: "Dashboard e indicadores",
              help: "Los números de la empresa.",
            },
            view_group: {
              title: "Indicadores del grupo",
              help: "Todas las unidades del grupo.",
            },
          },
          departments: {
            manage: {
              title: "Departamentos",
              help: "Crearlos y elegir quién ve los números de cada uno.",
            },
          },
          queues: {
            manage: {
              title: "Colas y chatbot",
              help: "Crear y configurar.",
            },
          },
          connections: {
            manage: {
              title: "Conexiones",
              help: "Configurar, leer el código QR y vincular.",
            },
          },
          files: {
            manage: {
              title: "Listas de archivos",
              help: "Los archivos que envía el chatbot.",
            },
          },
          schedules: {
            manage: {
              title: "Horarios y feriados",
              help: "Cuándo atiende la empresa.",
            },
          },
          settings: {
            manage: {
              title: "Opciones de atención",
              help: "Y los módulos de la empresa.",
            },
          },
          team: {
            view: {
              title: "Ver el equipo",
              help: "Con correo, perfil y verificación en dos pasos.",
            },
            manage: {
              title: "Gestionar el equipo",
              help: "Registrar, editar y eliminar personas; colas, conexión y cargo.",
            },
            manage_access: {
              title: "Gestionar permisos",
              help: "Perfil de acceso, licencia y excepciones de cada persona.",
            },
            reset_credentials: {
              title: "Cambiar contraseña y correo de otra persona",
              help: "Y restablecer la verificación en dos pasos.",
            },
            manage_companies: {
              title: "Vincular a otras empresas del grupo",
              help: "Dar acceso a otras unidades.",
            },
          },
          company: {
            manage: {
              title: "Datos de la empresa",
              help: "Nombre, idioma y guía de configuración.",
            },
            security: {
              manage: {
                title: "Seguridad de la empresa",
                help: "Exigir la verificación en dos pasos.",
              },
            },
          },
          billing: {
            manage: {
              title: "Plan y pago",
              help: "Cobro y forma de pago.",
            },
          },
          api_tokens: {
            manage: {
              title: "Tokens de la API",
              help: "Acceso de sistemas externos.",
            },
          },
          integrations: {
            manage: {
              title: "Integraciones",
              help: "OpenAI, WooCommerce, Contele y SMS.",
            },
          },
          audiences: {
            view: {
              title: "Ver bases de contactos",
              help: "Bases, segmentos y listas.",
            },
            manage: {
              title: "Gestionar bases de contactos",
              help: "Subir bases y crear segmentos y listas.",
            },
          },
          mass_send: {
            view: {
              title: "Seguir envíos masivos",
              help: "Los envíos en masa.",
            },
            manage: {
              title: "Gestionar envíos masivos",
              help: "Crear, pausar y cancelar; bajas.",
            },
          },
          smart_approaches: {
            view: {
              title: "Ver abordajes inteligentes",
              help: "Y los resultados.",
            },
            manage: {
              title: "Gestionar abordajes inteligentes",
              help: "Crear y activar.",
            },
          },
          flows: {
            view: {
              title: "Ver flujos",
              help: "Y los resultados.",
            },
            edit: {
              title: "Editar flujos",
              help: "Crear, editar y subir archivos.",
            },
          },
          ai_agents: {
            view: {
              title: "Ver agentes de IA",
              help: "La lista y los detalles de cada agente.",
            },
            manage: {
              title: "Configurar agentes de IA",
              help: "Archivos, versiones y prueba.",
            },
          },
          work_orders: {
            view: {
              title: "Ver órdenes de servicio",
              help: "Y sus fuentes.",
            },
            start_triage: {
              title: "Iniciar el triaje de una OS",
              help: "Envía un mensaje al cliente.",
            },
          },
          triage: {
            configure: {
              title: "Configurar el triaje",
              help: "Preguntas y reglas del triaje.",
            },
            monitor: {
              title: "Seguir triajes",
              help: "Los que están en curso.",
            },
          },
          crm: {
            use: {
              title: "Usar el CRM",
              help: "Leads y columnas.",
            },
            boards: {
              manage: {
                title: "Gestionar tableros del CRM",
                help: "Crear y eliminar tableros.",
              },
              share: {
                title: "Compartir tableros por enlace",
                help: "Crear enlaces para que personas sin acceso vean un tablero, sin poder cambiar nada.",
              },
            },
          },
          internal_chat: {
            use: {
              title: "Usar el chat interno",
              help: "Conversar con el equipo.",
            },
            moderate: {
              title: "Moderar el chat interno",
              help: "Crear canales; fijar o borrar mensajes de otros.",
            },
            invite: {
              title: "Invitar al chat interno",
              help: "El enlace de invitación crea una cuenta nueva.",
            },
          },
        },
      },
      settings: {
        schedulesUpdated: "Horarios actualizados con éxito.",
        success: "Configuración guardada con éxito.",
        title: "Configuración",
        groups: {
          account: "Tu cuenta",
          service: "Atención",
          system: "Sistema",
          company: "Empresa",
        },
        area: {
          autosave: "Los cambios se guardan automáticamente.",
          saving: "Guardando",
          saved: "Guardado",
          saveError: "No se pudo guardar. Inténtalo de nuevo.",
          loadError: "No se pudo cargar la configuración.",
          retry: "Intentar de nuevo",
          collapseMenu: "Ocultar menú",
          expandMenu: "Mostrar menú",
        },
        search: {
          label: "Buscar en la configuración",
          placeholder: "Buscar configuración",
          clear: "Borrar búsqueda",
          open: "Buscar",
          empty: "No se encontró nada para “{{query}}”.",
          emptyHint: "Prueba otra palabra, como “feriado” o “SMS”.",
          count: "{{count}} resultado(s)",
        },
        sections: {
          security: {
            keywords: "2fa, autenticación, verificación, código, contraseña, login, acceso, dos pasos",
            title: "Seguridad",
            description: "Protege el acceso a tu cuenta con la autenticación en dos pasos.",
          },
          schedules: {
            keywords: "horario, horario de atención, apertura, cierre, fuera de horario, atención",
            title: "Horario de atención",
            description: "Cuándo atiende la empresa y los días en que no atiende.",
            fields: {
              weeklyHours: {
                keywords: "semana, días, hora, abre, cierra, lunes, sábado, domingo",
                title: "Horario semanal",
                description: "Días y horas en que la empresa atiende. Las conexiones con horario propio usan el suyo.",
              },
              exceptions: {
                keywords: "feriado, feriados nacionales, fecha especial, navidad, año nuevo, carnaval, día libre, excepción",
                title: "Feriados y fechas especiales",
                description: "Reemplazan el horario semanal en la fecha elegida, en todas las conexiones.",
              },
            },
          },
          conversations: {
            keywords: "quién ve, visibilidad, privacidad, conversaciones de los colegas, fila, sector",
            title: "Conversaciones",
            description: "Quién ve las conversaciones de los agentes.",
            fields: {
              ticketVisibility: {
                keywords: "solo las propias, filas, sectores, toda la empresa, ver conversaciones",
                title: "Quién ve las conversaciones",
                description:
                  "Solo las propias: las del agente y las que esperan en sus filas. Sus filas: también las de sus colegas. Los administradores ven todas.",
                options: {
                  own: "Solo las propias",
                  queues: "Sus filas",
                  company: "Toda la empresa",
                },
              },
              supervisorTicketVisibility: {
                keywords: "supervisor, supervisores, conversaciones, colas, toda la empresa",
                title: "Lo que ven los Supervisores",
                description: "Nunca menos que los agentes.",
                options: {
                  queues: "De sus colas",
                  company: "De toda la empresa",
                },
              },
            },
          },
          "quick-replies": {
            keywords: "atajo, mensajes listos, respuestas, compartir",
            title: "Respuestas rápidas",
            description: "Quién ve las respuestas rápidas. Se crean en el menú Respuestas rápidas.",
            fields: {
              quickMessagesScope: {
                keywords: "quién ve, compartir, por agente, por empresa",
                title: "Quién ve las respuestas",
                description: "Por agente: cada uno ve solo las suyas. Por empresa: todos ven todas.",
                options: {
                  user: "Cada agente las suyas",
                  company: "Toda la empresa",
                },
              },
            },
          },
          indicators: {
            keywords: "sin respuesta, espera, tiempo de respuesta, colores, alerta, sla, indicador, art",
            title: "Indicadores",
            description: "Avisos de conversaciones sin respuesta y colores del tiempo de respuesta.",
            groups: {
              noResponse: {
                title: "Conversaciones sin respuesta",
                description: "Conversaciones en las que el cliente espera respuesta hace más de 10 minutos.",
              },
              responseTime: {
                title: "Tiempo de respuesta",
                description: "Colores del tiempo medio de respuesta en el panel y en los informes.",
              },
              shortReplies: {
                title: "Respuestas cortas del cliente",
                description: "Mensajes como \"Ok\" y \"👍\" al final de la conversación no cuentan en el tiempo de respuesta ni como \"sin respuesta\".",
              },
            },
            fields: {
              noResponseIndicator: {
                keywords: "aviso, menú, contador, sin respuesta",
                title: "Aviso en el menú",
                description: "Muestra en el menú lateral cuántas conversaciones están sin respuesta.",
              },
              unrepliedClockIcon: {
                keywords: "reloj, lista, rojo, espera",
                title: "Reloj en la lista de conversaciones",
                description: "Muestra un reloj rojo junto al contacto que espera respuesta.",
              },
              noResponseBusinessHours: {
                keywords: "horario comercial, fuera de horario",
                title: "Contar solo en horario de atención",
                description: "Fuera del horario, la espera no cuenta en el gráfico, la lista, el aviso ni las alertas.",
              },
              artThresholds: {
                keywords: "art, verde, amarillo, rojo, minutos, tiempo medio, límite",
                title: "Límites de colores",
                description: "En minutos. Por encima del límite del amarillo, queda rojo.",
                greenUpTo: "Verde hasta",
                yellowUpTo: "Amarillo hasta",
                errors: {
                  integer: "Usa números enteros.",
                  range: "Usa valores de 1 a 1440 minutos.",
                  order: "El límite del verde debe ser menor que el del amarillo.",
                },
              },
              shortReplyFilter: {
                keywords: "ok, emoji, pulgar, gracias, respuesta corta, cierre, comisión",
                title: "Ignorar respuestas cortas en los indicadores",
                description: "Mensaje de 1 carácter, solo con emojis o con las palabras de abajo. Vale para los mensajes que lleguen después de guardar.",
              },
              shortReplyWords: {
                keywords: "palabras, lista, ok, gracias",
                title: "Palabras que cuentan como respuesta corta",
                description: "Una por línea. Valen solas o juntas, con emojis y puntuación, sin importar mayúsculas y acentos. Con \"?\" al final, son una pregunta y piden respuesta.",
                restore: "Restaurar predeterminado",
                errors: {
                  tooMany: "Use hasta 100 palabras.",
                  tooLong: "Cada palabra puede tener hasta 30 caracteres.",
                },
              },
              shortReplyStickers: {
                keywords: "sticker, figurita",
                title: "Un sticker solo cuenta como respuesta corta",
                description: "El sticker de agradecimiento al final de la conversación.",
              },
              shortReplyAutoClose: {
                keywords: "cierre automático, inactividad, cerrar ticket",
                title: "La respuesta corta no mantiene el ticket abierto",
                description: "En el cierre por inactividad de la conexión, el \"Ok\" del cliente no cuenta como respuesta suya.",
              },
            },
          },
          calls: {
            keywords: "llamada, llamadas, teléfono, voz, rechazar",
            title: "Llamadas",
            description: "Qué hacer cuando un cliente llama por WhatsApp.",
            fields: {
              callRejection: {
                keywords: "rechazar, mensaje automático, llamada",
                title: "Rechazar llamadas",
                description: "Rechaza la llamada al instante y envía un mensaje automático al cliente.",
              },
              callRejectionMessage: {
                title: "Mensaje para el cliente",
                description: "Usa {{variable}} para incluir el nombre del cliente.",
                placeholder: "¡Hola {{variable}}! Por ahora no atendemos llamadas por aquí. Escribe tu consulta por mensaje y te responderemos pronto.",
              },
            },
          },
          notifications: {
            keywords: "aviso, notificación, navegador, push, alerta, sms",
            title: "Notificaciones",
            description: "Avisos en el navegador y alertas por SMS para el equipo.",
            groups: {
              browser: {
                title: "En el navegador",
                description: "Aparecen en la pantalla de quien tiene el sistema abierto.",
              },
              sms: {
                title: "Alerta por SMS",
                description: "Avisa por SMS cuando muchas conversaciones quedan sin respuesta.",
              },
            },
            fields: {
              webNotifications: {
                keywords: "navegador, push, mensaje nuevo, escritorio",
                title: "Mensajes nuevos",
                description: "Muestra un aviso del navegador cuando llega un mensaje a una conversación.",
              },
              internalChatNotifications: {
                keywords: "chat interno, mención, mensaje directo",
                title: "Chat interno",
                description: "Muestra un aviso del navegador para mensajes directos y menciones en el chat interno.",
              },
              smsAlert: {
                searchTitle: "Alerta por SMS",
                keywords: "sms, celular, teléfono, alerta, límite, frecuencia, prueba",
                title: "Activar la alerta",
                description: "Envía un SMS cuando la parte de conversaciones sin respuesta supera el límite.",
              },
              smsThreshold: {
                title: "Límite (%)",
                description: "La alerta sale cuando la parte de conversaciones sin respuesta supera este valor.",
              },
              smsInterval: {
                title: "Tiempo entre alertas",
                description: "Tiempo mínimo entre un SMS y otro.",
                unit: "Unidad",
                units: {
                  minutes: "Minutos",
                  hours: "Horas",
                  days: "Días",
                },
              },
              smsPhones: {
                title: "Teléfonos que reciben la alerta",
                description: "Un número por línea, con código de área.",
              },
              smsTest: {
                title: "Probar la alerta",
                description: "Envía un SMS de prueba al primer número de la lista.",
                button: "Enviar SMS de prueba",
                sending: "Enviando...",
                sent: "SMS de prueba enviado a {{phone}}.",
                failed: "No se pudo enviar: {{error}}",
              },
            },
            toasts: {
              unsupported: "Este navegador no muestra notificaciones.",
              permissionDenied: "El navegador no permitió las notificaciones.",
            },
          },
          modules: {
            keywords: "módulos, recursos, activar, desactivar",
            title: "Módulos",
            description: "Recursos que se pueden activar o desactivar para la empresa.",
            groups: {
              features: {
                title: "Recursos",
              },
              sttelar: {
                title: "Habilitados por Sttelar",
                description: "Solo los superadministradores ven estas opciones.",
              },
            },
            fields: {
              enableAcademy: {
                keywords: "academy, capacitación, cursos, clases",
                title: "Capacitación",
                description: "Muestra el área de Capacitación al equipo.",
              },
              triageEnabled: {
                keywords: "triaje, ia, inteligencia artificial, bot",
                title: "Triaje con IA",
                description: "Habilita el registro de triajes y el panel de triaje en las conversaciones de esta empresa.",
              },
              triageRetention: {
                keywords: "triaje, retención, 90 días, borrar, limpieza, datos personales",
                title: "Retención de 90 días: borrar de verdad",
                description: "Apagado, la limpieza diaria solo simula: cuenta lo que borraría de los triajes terminados hace más de 90 días. Encendido, borra sus documentos y datos; queda solo el historial, sin datos personales.",
                never: "Aún no se ejecutó (se ejecuta todos los días a las 03:30).",
                lastSimulation: "Última simulación el {{date}}: se borrarían {{sessions}} triajes, {{files}} archivos, {{notes}} notas de resumen y {{workOrders}} órdenes de servicio.",
                lastDelete: "Última ejecución el {{date}}: {{sessions}} triajes limpiados ({{files}} archivos, {{notes}} notas de resumen, {{workOrders}} órdenes de servicio); {{remaining}} quedaron para la próxima.",
                confirmTitle: "¿Borrar de verdad?",
                confirmBody: "A partir de la próxima limpieza (todos los días a las 03:30), los triajes de esta empresa terminados hace más de 90 días pierden para siempre las fotos, facturas, videos y audios enviados en el triaje, los datos leídos, la nota de resumen y los datos de la orden de servicio. No se puede deshacer.",
              },
              ticketCloseButton: {
                keywords: "resolver, cerrar, finalizar, terminar, botón, agente, conversación, ticket",
                title: "Los agentes pueden resolver conversaciones",
                description: "Desactivado, solo los administradores cierran conversaciones: el botón Resolver desaparece para los agentes. El cierre automático y la IA siguen cerrándolas.",
              },
            },
          },
          company: {
            keywords: "cnpj, razón social, nombre comercial, teléfono, correo, email, datos fiscales, cuenta",
            title: "Datos de la empresa",
            description: "Los datos fiscales y el contacto de cada cuenta.",
          },
          "job-roles": {
            keywords: "cargo, cargos, función, equipo",
            title: "Cargos",
            description: "Cargos que aparecen en el perfil del equipo y en el chat interno.",
          },
          departments: {
            keywords: "departamento, departamentos, cuentas, unidades, dashboard, informes, quién ve",
            title: "Departamentos",
            description: "Grupos de cuentas y quién de esta cuenta ve sus números en el Dashboard.",
          },
          "team-access": {
            keywords: "permisos, perfil de acceso, supervisor, agente, administrador, excepciones, historial, quién puede",
            title: "Equipo y permisos",
            description: "El perfil de acceso de cada persona y las excepciones a él.",
          },
          "company-security": {
            keywords: "2fa, autenticación, obligatorio, política, plazo, equipo, dos pasos",
            title: "Seguridad de la empresa",
            description: "Define si el equipo debe usar la autenticación en dos pasos.",
          },
          billing: {
            keywords: "factura, facturas, plan, pago, tarjeta, cobro, suscripción, upgrade, cancelar",
            title: "Facturación",
            description: "Plan, forma de pago y facturas.",
          },
        },
        companyData: {
          accountLabel: "Cuenta",
          razaoSocial: "Razón Social",
          nomeFantasia: "Nombre Comercial",
          cnpj: "CNPJ",
          phone: "Teléfono",
          email: "Correo electrónico",
          phRazaoSocial: "Ej: Comercio de Ropa S.A.",
          phNomeFantasia: "Ej: Tienda de Juan",
          language: "Idioma de los mensajes automáticos a los clientes",
          phEmail: "contacto@empresa.com",
          save: "Guardar",
          saved: "Datos actualizados con éxito.",
          billingHint: "Las facturas y la nota fiscal usan los Datos de facturación, en Facturación.",
          invalidCnpj: "CNPJ inválido. Verifique los dígitos.",
        },
        jobRoles: {
          title: "Cargos",
          emptyState: "Todavía no hay cargos creados para esta empresa.",
          modal: {
            add: "Nuevo cargo",
            edit: "Editar cargo",
          },
          form: {
            name: "Nombre del cargo",
          },
          buttons: {
            add: "Agregar cargo",
            cancel: "Cancelar",
            save: "Guardar",
          },
          toasts: {
            created: "Cargo creado con éxito.",
            updated: "Cargo actualizado con éxito.",
            deleted: "Cargo eliminado con éxito.",
          },
          confirmationModal: {
            deleteTitle: "Eliminar cargo",
            deleteMessage: "Los usuarios vinculados a este cargo pasarán automáticamente a Sin cargo.",
          },
        },
        departments: {
          emptyState: "Todavía no hay departamentos.",
          columns: {
            name: "Departamento",
            companies: "Cuentas",
            viewers: "Quién ve",
          },
          nobody: "Solo los administradores",
          buttons: {
            add: "Nuevo departamento",
            cancel: "Cancelar",
            save: "Guardar",
            edit: "Editar",
            delete: "Eliminar",
          },
          modal: {
            add: "Nuevo departamento",
            edit: "Editar departamento",
          },
          form: {
            name: "Nombre",
            companies: "Cuentas",
            companiesHelp: "Cada cuenta queda en un solo departamento.",
            viewers: "Quién ve los números",
            viewersHelp: "Personas de esta cuenta. Los administradores ya ven todos.",
            takenBy: "En {{name}}",
            noOptions: "No se encontró nada",
          },
          toasts: {
            created: "Departamento creado.",
            updated: "Departamento actualizado.",
            deleted: "Departamento eliminado.",
          },
          confirmationModal: {
            deleteTitle: "Eliminar departamento",
            deleteMessage: "Las cuentas siguen iguales; solo dejan de estar juntas en este departamento.",
          },
        },
        helps: {
          toasts: {
            errorList: "No fue posible cargar la lista de registros",
            errorOperation: "No fue posible realizar la operación",
            error: "No fue posible realizar la operación. Verifique si ya existe una ayuda con el mismo nombre o si los campos fueron completados correctamente",
            success: "¡Operación realizada con éxito!",
          },
          buttons: {
            clean: "Limpiar",
            delete: "Eliminar",
            save: "Guardar",
          },
          grid: {
            title: "Título",
            description: "Descripción",
            video: "Video",
          },
          confirmModal: {
            title: "Eliminación de Registro",
            confirm: "¿Desea realmente eliminar este registro?",
          },
        },
        company: {
          toasts: {
            errorList: "No fue posible cargar la lista de registros",
            errorOperation: "No fue posible realizar la operación",
            error: "No fue posible realizar la operación. Verifique si ya existe una empresa con el mismo nombre o si los campos fueron completados correctamente",
            success: "¡Operación realizada con éxito!",
          },
          confirmModal: {
            title: "Eliminación de Registro",
            confirm: "¿Desea realmente eliminar este registro?",
          },
          form: {
            name: "Nombre",
            email: "Email",
            phone: "Teléfono",
            plan: "Plan",
            status: "Estado",
            yes: "Sí",
            no: "No",
            campanhas: "Campañas",
            enabled: "Habilitadas",
            disabled: "Deshabilitadas",
            createdAt: "Creada En",
          },
          buttons: {
            clear: "Limpiar",
            delete: "Eliminar",
            user: "Usuario",
            save: "Guardar",
          },
        },
        schedules: {
          form: {
            initialHour: "Hora de inicio",
            finalHour: "Hora de fin",
            save: "Guardar",
            days: {
              monday: "Lun",
              tuesday: "Mar",
              wednesday: "Mié",
              thursday: "Jue",
              friday: "Vie",
              saturday: "Sáb",
              sunday: "Dom",
            },
            workdays: "Días hábiles",
            workdaysHint: "Lunes a viernes",
            allDays: "Todos los días",
            allDaysHint: "Todos los días de la semana",
            closedDay: "Día cerrado",
            closedNote: "Sin atención en estos días",
            remove: "Quitar",
            add: "Agregar horario",
            empty: "No hay horarios configurados. Usa \"Agregar horario\" para empezar.",
            errors: {
              noDays: "Selecciona al menos un día",
              missingTime: "Completa la hora de inicio y la de fin",
              invalidTime: "Usa el formato HH:MM",
              endBeforeStart: "La hora de fin debe ser posterior a la de inicio",
            },
          },
          exceptions: {
            add: "Agregar fecha",
            empty: "No hay feriados ni fechas especiales.",
            loadError: "No se pudieron cargar los feriados.",
            columns: {
              date: "Fecha",
              note: "Nota",
              status: "Atención",
            },
            closed: "Cerrado",
            edit: "Editar",
            remove: "Quitar",
            dialog: {
              newTitle: "Nuevo feriado o fecha especial",
              editTitle: "Editar fecha",
              description: "En esta fecha, lo que definas aquí reemplaza el horario semanal.",
              date: "Fecha",
              closedAllDay: "Cerrado todo el día",
              closedHint: "Sin atención en esta fecha.",
              reducedHint: "Atiende solo en el horario de abajo.",
              hours: "Horario de atención",
              note: "Nota (opcional)",
              notePlaceholder: "Ej.: Navidad, Año Nuevo, medio día",
              cancel: "Cancelar",
              create: "Agregar",
              save: "Guardar",
            },
            errors: {
              date: "Indica la fecha",
            },
            deleteTitle: "¿Quitar esta fecha?",
            deleteBody: "En esta fecha vuelve a valer el horario semanal.",
            deleteConfirm: "Quitar",
            national: {
              button: "Feriados nacionales",
              title: "Importar feriados nacionales",
              description: "Las fechas marcadas se agregan como día cerrado. Las facultativas vienen sin marcar y las ya agregadas quedan fuera.",
              year: "Año",
              empty: "No quedan feriados nacionales este año.",
              registered: "ya agregado",
              optional: "facultativo",
              cancel: "Cancelar",
              import: "Agregar {{count}} fecha",
              import_plural: "Agregar {{count}} fechas",
              imported: "{{count}} fecha agregada.",
              imported_plural: "{{count}} fechas agregadas.",
              names: {
                newYear: "Año Nuevo",
                carnivalMonday: "Carnaval (lunes)",
                carnivalTuesday: "Carnaval (martes)",
                goodFriday: "Viernes Santo",
                easter: "Pascua",
                tiradentes: "Tiradentes",
                labourDay: "Día del Trabajo",
                corpusChristi: "Corpus Christi",
                independence: "Independencia de Brasil",
                aparecida: "Nuestra Señora Aparecida",
                allSouls: "Día de los Difuntos",
                republic: "Proclamación de la República",
                blackConsciousness: "Día de la Conciencia Negra",
                christmas: "Navidad",
              },
            },
            toasts: {
              created: "Fecha agregada.",
              updated: "Fecha actualizada.",
              removed: "Fecha quitada.",
            },
          },
        },
        settings: {
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Activado",
              disabled: "Desactivado",
            },
          },
        },
      },
      startConversationModal: {
        title: "Iniciar conversación",
        subtitle: "Abre una atención con este número.",
        number: "Número",
        connection: "Conexión",
        selectConnection: "Selecciona la conexión",
        noConnection: "Ninguna conexión activa. Conecta un WhatsApp en Conexiones para iniciar la conversación.",
        copy: "Copiar número",
        copied: "Número copiado",
        copyFailed: "No se pudo copiar. Selecciona el número y cópialo manualmente.",
        cancel: "Cancelar",
        start: "Conversar",
        starting: "Iniciando…",
        started: "Conversación iniciada",
        selectRequired: "Selecciona una conexión",
        invalidNumber: "Este número no parece un teléfono válido. Revísalo antes de iniciar la conversación.",
      },
      sendContactModal: {
        menuItem: "Contacto",
        title: "Enviar contacto",
        searchPlaceholder: "Buscar nombre o número",
        thisConnection: "Esta conexión",
        contacts: "Contactos",
        minChars: "Escribe al menos 3 letras o números para buscar.",
        empty: "No se encontraron contactos.",
        cancel: "Cancelar",
        send: "Enviar",
        sending: "Enviando…",
        unconfirmed: "No se pudo confirmar el envío. Revisa el chat antes de intentarlo de nuevo.",
      },
      sharedContactCard: {
        contacts: "{{count}} contactos",
        talk: "Conversar",
        copy: "Copiar",
        copied: "Copiado",
        save: "Guardar",
        saving: "Guardando…",
        saved: "Guardado",
        savedToast: "Contacto guardado",
        copiedToast: "Número copiado",
        copyFailed: "No se pudo copiar. Selecciona el número y cópialo manualmente.",
        noNumber: "Sin número",
        showAll: "Ver todos ({{count}})",
        showLess: "Ver menos",
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Regresar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            download: "Descargar",
          },
        },
        lostCall: "Llamada de voz/video perdida a las",
        deletedMessage: "Este mensaje fue borrado por el contacto",
        aiBadge: "IA",
        aiSentBy: "Mensaje enviado por la IA",
        edited: "Editado",
        audio: "Audio",
        location: "Ubicación",
        saudation: "¡Saluda a tu nuevo contacto!",
      },
      messagesInput: {
        placeholderOpen: "Escribe un mensaje",
        placeholderClosed: "Reabre o acepta este ticket para enviar un mensaje.",
        placeholderAttendedByOther: "Otro agente está atendiendo esta conversación.",
        signMessage: "Firmar",
      },
      contactDrawer: {
        header: "Datos del contacto",
        close: "Cerrar",
        expand: "Expandir panel",
        collapse: "Contraer panel",
        copyNumber: "Copiar número",
        numberCopied: "Número copiado",
        copyFailed: "No se pudo copiar. Selecciona el número y cópialo manualmente.",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      fileModal: {
        title: {
          add: "Agregar lista de archivos",
          edit: "Editar lista de archivos",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre de la lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de la opción",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre muy corto",
          },
          message: {
            required: "El mensaje es obligatorio",
          },
        },
        success: "¡Lista de archivos guardada con éxito!",
      },
      ticketOptionsMenu: {
        schedule: "Programación",
        delete: "Eliminar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Ingrese aquí la información que desea registrar",
        },
        confirmationModal: {
          title: "Eliminar el ticket",
          titleFrom: "del contacto ",
          message: "¡Atención! Todos los mensajes relacionados al ticket se perderán.",
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar",
        },
      },
      unsavedChanges: {
        hint: "Cambios sin guardar",
        title: "¿Descartar cambios?",
        body: "Los cambios aún no se guardaron. Si continúas, se perderán.",
        leaveConfirm: "Los cambios aún no se guardaron. ¿Salir de todos modos?",
        discard: "Descartar",
      },
      confirmationModal: {
        eyebrow: "Confirmación",
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        retry: "Reenviar",
        retrying: "Reenviando...",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      templateModal: {
        title: "Seleccionar Plantilla",
        searchPlaceholder: "Buscar por nombre o contenido...",
        loading: "Cargando plantillas...",
        recents: "Recientes",
        favorites: "Favoritas",
        favorite: "Marcar como favorita",
        unfavorite: "Quitar de favoritas",
        all: "Todas",
        previewEmpty: "Selecciona una plantilla para ver la vista previa",
        sentToast: "¡Plantilla \"{name}\" enviada con éxito!",
        categories: {
          all: "Todas",
          marketing: "Marketing",
          utility: "Utilitario",
          auth: "Autenticación",
          other: "Otro",
        },
        empty: {
          title: "Ninguna plantilla encontrada",
          description: "Configura plantillas aprobadas en tu cuenta Meta for Developers para usar esta función.",
        },
        noResults: {
          title: "Sin resultados",
          description: "Prueba otra búsqueda o quita el filtro de categoría.",
        },
        hints: {
          navigate: "navegar",
          send: "enviar",
          close: "cerrar",
        },
        buttons: {
          cancel: "Cancelar",
          send: "Enviar plantilla",
          sending: "Enviando...",
        },
      },
      academy: {
        title: "Capacitación",
        empty: "No hay cursos disponibles por el momento.",
        lessons: "lecciones",
        progress: "completado",
        courseContent: "Contenido del curso",
        ofLessonsCompleted: "de {{total}} completadas",
        lessonTag: "LECCIÓN",
        back: "Volver",
        videoUnavailable: "Video no disponible",
        continueWatching: "Continuar viendo",
        courseCompleted: "Curso completado",
        markComplete: "Marcar como completada",
        unmarkComplete: "Desmarcar",
        toasts: {
          disabled: "El Área de Capacitación está desactivada.",
          noPermission: "No tienes permiso para acceder a esta área.",
        },
        manage: {
          title: "Gestionar Capacitación",
          draft: "Borrador",
          buttons: {
            cancel: "Cancelar",
            save: "Guardar",
            addCourse: "Nuevo curso",
            addModule: "Nuevo módulo",
          },
          validation: {
            titleRequired: "Ingresa un título (mín. 2 caracteres).",
            videoUrlRequired: "Ingresa la URL del video.",
          },
          toasts: {
            courseSaved: "Curso guardado.",
            moduleSaved: "Módulo guardado.",
            lessonSaved: "Lección guardada.",
            thumbnailRemoved: "Miniatura eliminada.",
          },
          confirm: {
            deleteCourse: "Eliminar curso",
            deleteModule: "Eliminar módulo",
            deleteLesson: "Eliminar lección",
            message: "Esta acción no se puede deshacer.",
          },
          courseModal: {
            addTitle: "Nuevo curso",
            editTitle: "Editar curso",
            title: "Título",
            description: "Descripción",
            published: "Publicado",
            thumbnail: "Miniatura (imagen)",
            removeThumbnail: "Eliminar",
          },
          moduleModal: {
            addTitle: "Nuevo módulo",
            editTitle: "Editar módulo",
            title: "Título",
          },
          lessonModal: {
            addTitle: "Nueva lección",
            editTitle: "Editar lección",
            title: "Título",
            description: "Descripción",
            videoUrl: "URL del video (YouTube o Vimeo)",
            currentVideo: "Video actual",
            keepHint: "deja la URL en blanco para mantener",
          },
        },
      },
      flowResults: {
        back: "Flujos",
        edit: "Editar flujo",
        view: "Ver flujo",
        openEditor: "Abrir el editor",
        active: "Activo",
        inactive: "Inactivo",
        noDescription: "Sin descripción.",
        addDescription: "Agregar",
        editDescription: "Editar",
        descriptionLabel: "Descripción del flujo",
        descriptionPlaceholder: "¿Para qué sirve este flujo?",
        save: "Guardar",
        cancel: "Cancelar",
        close: "Cerrar",
        saved: "Guardado.",
        refresh: "Actualizar",
        refreshing: "Actualizando…",
        trackingSince: "Midiendo desde {{date}}. Antes de esa fecha no hay datos.",
        notTrackedYet: "Aún sin medición: los números aparecen cuando el primer contacto pase por el flujo.",
        disabled: "La medición de los flujos está apagada en este servidor. Los números no se están actualizando.",
        period: {
          label: "Período",
          "7d": "7 días",
          "30d": "30 días",
          "90d": "90 días",
          custom: "Personalizado",
          from: "De",
          to: "a",
          apply: "Aplicar",
          range: "{{from}} a {{to}}",
        },
        metrics: {
          entries: "Entradas",
          sent: "Enviados",
          delivered: "Entregados",
          clicks: "Clics",
          conversions: "Conversiones",
          help: {
            entries: "Contactos que entraron al flujo en el período. Cada conversación cuenta una vez.",
            sent: "Mensajes que el flujo envió y WhatsApp aceptó.",
            delivered: "Mensajes que llegaron al celular del contacto.",
            clicks: "Enlaces enviados por el flujo que el contacto abrió. Cada enlace cuenta una vez.",
            conversions: "Compras de quienes recibieron un mensaje de este flujo antes de comprar.",
          },
          rate: {
            delivery: "{{value}} de los enviados",
            click: "{{value}} de los entregados",
            conversion: "{{value}} de las entradas",
          },
          inPeriod: "en el período",
          messages: "mensajes",
          sendFailed: "{{count}} no se envió",
          sendFailed_plural: "{{count}} no se enviaron",
          notConfigured: "Sin configurar",
          unavailable: "No disponible",
          configure: "Configurar",
          clicksUnavailableHint: "Este flujo solo envía plantillas listas, y su enlace no se puede cambiar.",
          clicksNotConfiguredHint: "Activa el seguimiento de enlaces para contarlos.",
          conversionsNotConfiguredHint: "Conecta tu tienda para contar las compras.",
          conversionValue: "{{value}} en ventas",
        },
        summary: {
          running: "{{count}} en curso",
          completed: "{{count}} completada",
          completed_plural: "{{count}} completadas",
          failed: "{{count}} con fallo",
          cancelled: "{{count}} cancelada",
          cancelled_plural: "{{count}} canceladas",
          read: "{{count}} leído ({{value}} de los entregados)",
          read_plural: "{{count}} leídos ({{value}} de los entregados)",
        },
        chart: {
          title: "Entradas por día",
          hint: "Contactos que entraron al flujo cada día.",
          empty: "Ninguna entrada en el período.",
          entries: "{{count}} entrada",
          entries_plural: "{{count}} entradas",
          day: "Día",
        },
        history: {
          title: "Historial de ejecuciones",
          subtitle: "Cada contacto que entró al flujo en el período.",
          search: "Buscar por nombre o teléfono",
          allStatuses: "Todos los estados",
          allKinds: "Todos los tipos",
          kind: "Tipo",
          columns: {
            contact: "Contacto",
            startedAt: "Entrada",
            status: "Estado",
            step: "Etapa actual",
            duration: "Tiempo",
            messages: "Mensajes",
          },
          empty: {
            title: "Ninguna ejecución en el período",
            description: "Cuando un contacto entre al flujo, aparece aquí.",
            filtered: "Ninguna ejecución con esos filtros.",
          },
          loadMore: "Cargar más",
          loading: "Cargando…",
          removedContact: "Contacto eliminado",
          noContact: "Sin contacto",
          steps: "{{count}} etapa recorrida",
          steps_plural: "{{count}} etapas recorridas",
          sentCount: "{{count}} enviado",
          sentCount_plural: "{{count}} enviados",
          deliveredCount: "{{count}} entregado",
          deliveredCount_plural: "{{count}} entregados",
          failedMessages: "{{count}} con fallo",
          searchWithOrder: "Buscar por nombre, teléfono o número de OS",
          order: "OS {{number}}",
          orderStatus: "OS {{number}} · {{status}}",
        },
        status: {
          running: "En curso",
          completed: "Completado",
          failed: "Falló",
          cancelled: "Cancelado",
        },
        kind: {
          ai_agent: "Agente IA",
          mass_send: "Envío masivo",
          triage: "Triaje IA",
          order_status: "Actualización de OS",
        },
        endReason: {
          resolved: "La IA cerró la atención",
          transferred: "Pasó a una persona",
          ticket_closed: "La conversación fue cerrada",
          human_takeover: "Una persona tomó la conversación",
          flow_deactivated: "El flujo fue desactivado",
          ticket_removed: "La conversación fue eliminada",
          inactivity: "El contacto no escribió más",
          sent: "Mensaje enviado",
          send_failed: "El envío falló",
          triage_completed: "Triaje completado",
          triage_cancelled: "Triaje cancelado",
          triage_failed: "El triaje no pudo continuar",
          opt_out: "El cliente pidió no recibir mensajes",
          invalid_phone: "El aviso no trajo un teléfono válido",
          flow_inactive: "El flujo se desactivó antes del envío",
          flow_invalid: "El disparador no tiene plantilla conectada",
          expired: "La OS cambió de estado hace más de 6 horas",
          event_missing: "Los datos del aviso ya no están guardados",
          connection_invalid: "La conexión del disparador ya no sirve",
          connection_unavailable: "La conexión estaba desconectada",
          template_check: "No se pudieron leer las plantillas de la conexión",
          template_unavailable: "La plantilla no está disponible",
          invalid_variables: "Faltó un dato para la plantilla",
          busy: "Había otro envío al cliente en curso",
          send_uncertain: "No se pudo confirmar si salió",
        },
        detail: {
          title: "Ejecución",
          openConversation: "Abrir conversación",
          summary: {
            startedAt: "Entrada",
            finishedAt: "Fin",
            stillRunning: "En curso",
            duration: "Tiempo de ejecución",
            runs: "Respuestas de la IA",
          },
          messages: "Mensajes enviados",
          noMessages: "Ningún mensaje enviado.",
          media: "Archivo enviado",
          deletedMessage: "Mensaje eliminado de la conversación",
          messageStatus: {
            sent: "Enviado",
            notSent: "No enviado",
            delivered: "Entregado",
            read: "Leído",
            failed: "Falló",
          },
          error: "Error",
          lastError: "Último error (ya recuperado)",
          reason: "Por qué no se envió",
          orderNumber: "OS",
          orderStatus: "Estado de la OS",
          unknownError: "Error sin descripción.",
          triageErrorHint: "El motivo está en el seguimiento del triaje (Flujos > Gestionar Triajes).",
          path: "Recorrido en el flujo",
          version: "Versión {{number}} del flujo",
          versionOld: "El flujo fue editado después. Este es el diseño que valía en esta ejecución.",
          noVersion: "El diseño del flujo de esta ejecución no se guardó.",
          legend: {
            done: "Pasó",
            current: "Etapa actual",
            error: "Falló",
            pending: "No pasó",
          },
          links: "Enlaces rastreados",
          clicks: "abierto {{count}} vez",
          clicks_plural: "abierto {{count}} veces",
          notClicked: "no fue abierto",
          conversions: "Conversiones",
          order: "Pedido {{id}}",
          reverted: "deshecha (reembolso o cancelación)",
          timeline: "Línea de tiempo",
          noEvents: "Nada registrado todavía.",
          tokens: "{{count}} tokens",
          unknownStep: "Etapa eliminada del flujo",
          notFound: "Esta ejecución ya no existe.",
          event: {
            started: "Entró al flujo",
            finished: "Ejecución terminada",
            runFailed: "La IA no pudo responder",
            nodeDone: "completado",
            nodeFailed: "Falló en esta etapa.",
            tool: "Herramienta {{tool}}",
            linkClicked: "Abrió un enlace",
            conversion: "Compra atribuida a este flujo",
          },
          action: {
            send: "La IA respondió",
            escalate: "La IA pasó la conversación a una persona",
            silent: "La IA no respondió",
            none: "Ronda sin respuesta",
          },
        },
        measure: {
          button: "Medición",
          title: "Medición del flujo",
          copy: "Copiar",
          copied: "Copiado.",
          links: {
            title: "Clics en enlaces",
            description: "Cambia los enlaces de los mensajes de la IA por una dirección que cuenta el clic y lleva al mismo lugar.",
            toggle: "Rastrear enlaces",
            hosts: "Sitios rastreados",
            hostsHint: "Solo se cambian los enlaces de estos sitios. Indica el sitio de tu tienda.",
            hostPlaceholder: "mitienda.com",
            addHost: "Agregar",
            removeHost: "Quitar {{host}}",
            note: "El enlace enviado junto con una acción de la IA (etiquetar, transferir) sale sin seguimiento.",
            unavailable: "Este flujo solo envía plantillas listas, y su enlace no se puede cambiar.",
          },
          conversions: {
            title: "Conversiones",
            description: "Cuenta las compras de quienes recibieron un mensaje de este flujo antes de comprar.",
            source: "Tienda",
            none: "No medir conversiones",
            webhookUrl: "Dirección de entrega",
            secret: "Secreto",
            secretOnce: "Copia el secreto ahora. No se muestra de nuevo.",
            secretHidden: "El secreto ya fue mostrado y no aparece de nuevo.",
            rotate: "Generar otro",
            rotateWarning: "La tienda usa el secreto actual. Al generar otro, sus avisos dejan de aceptarse hasta que pegues el nuevo allí.",
            rotateConfirm: "Generar otro secreto",
            howTo: "En la tienda: WooCommerce > Ajustes > Avanzado > Webhooks. Crea un webhook con el tema \"Pedido actualizado\" y pega la dirección y el secreto.",
            sourceError: "Problema en el último aviso de la tienda: {{error}}",
            lastEvent: "Último aviso de la tienda {{when}}.",
            noEvents: "La tienda todavía no envió ningún aviso.",
            window: "Plazo para contar",
            windowHint: "Tiempo máximo entre el mensaje del flujo y la compra.",
            days: "{{count}} día",
            days_plural: "{{count}} días",
            requireClick: "Solo contar si el contacto abrió un enlace del flujo",
            newSource: "Conectar otra tienda",
            firstSource: "Conectar una tienda",
            chooseIntegration: "Elige la tienda",
            create: "Generar dirección",
            noIntegrations: "Registra la tienda en Integraciones para medir las conversiones.",
          },
        },
        errors: {
          forbidden: "Solo los administradores ven los resultados de los flujos.",
          notFound: "Este flujo ya no existe.",
          load: "No se pudieron cargar los resultados.",
          retry: "Intentar de nuevo",
          history: "No se pudo cargar el historial.",
          execution: "No se pudo cargar esta ejecución.",
        },
      },
      workOrders: {
        triage: {
          title: "Triaje",
          disabled: "El triaje por IA no está activado en esta empresa.",
          waiting: "Esperando para empezar (próximo intento: {{when}}).",
          failed: "El triaje automático no empezó:",
          none: "Ningún triaje para esta OS.",
          unnamed: "Triaje",
          openConversation: "Abrir conversación",
          noDefinitions: "Ningún triaje publicado empieza por OS de esta fuente. Actívelo en la pestaña Órdenes de servicio del triaje (Flujos > Administrar triajes).",
          start: "Iniciar triaje",
          noPhones: "La OS no tiene un teléfono que sirva para WhatsApp.",
          dialogTitle: "Iniciar triaje desde la OS",
          definition: "Triaje",
          chooseDefinition: "Elija el triaje",
          phone: "Teléfono del cliente",
          mobile: "celular",
          landline: "fijo",
          connectionNote: "La conversación se abre por la conexión:",
          dialogHint: "Si el cliente ya está con un agente, la IA no toma la conversación: el triaje espera y se avisa al agente.",
          cancel: "Cancelar",
          confirm: "Iniciar",
          started: "Triaje iniciado: la IA contactará al cliente.",
          startedHuman: "El cliente ya está con un agente: el triaje quedó esperando y se le avisó.",
          chips: {
            waitingHuman: "Esperando al agente",
            failed: "No iniciado",
            scheduled: "Programado",
            none: "Sin triaje",
          },
        },
        title: "Órdenes de servicio",
        subtitle: "Órdenes recibidas del sistema del fabricante, enviadas por el colector del servicio técnico.",
        configure: "Configurar en Integraciones",
        search: "Buscar por nº de orden, nombre, teléfono o documento",
        allSources: "Todas las integraciones",
        sourceFilter: "Integración",
        inactiveSource: "{{name}} (inactiva)",
        sourceHealth: {
          online: "En línea",
          offline: "Sin señal",
          needs_login: "Esperando que alguien entre al portal",
          error: "Último ciclo con error",
          never: "El recolector aún no envió señal",
          inactive: "Desactivada",
        },
        allStatuses: "Todos los estados",
        allTypes: "Todos los tipos",
        allWarranties: "Todas las garantías",
        warrantyFilter: {
          in: "En garantía",
          out: "Fuera de garantía",
          unknown: "Garantía no informada",
        },
        triageFilter: {
          label: "Triaje",
          all: "Todas",
        },
        sort: {
          label: "Ordenar",
          options: {
            received_desc: "Más recientes primero",
            received_asc: "Más antiguas primero",
            number_asc: "Nº de orden, de menor a mayor",
            number_desc: "Nº de orden, de mayor a menor",
            customer_asc: "Cliente, de la A a la Z",
            customer_desc: "Cliente, de la Z a la A",
            city_asc: "Ciudad, de la A a la Z",
            city_desc: "Ciudad, de la Z a la A",
            product_asc: "Producto, de la A a la Z",
            product_desc: "Producto, de la Z a la A",
            triage_asc: "Triaje, lo que necesita a alguien primero",
            triage_desc: "Triaje, en orden inverso",
          },
        },
        total: "{{count}} órdenes",
        loadMore: "Cargar más",
        updatesAvailable: "Hay órdenes nuevas o modificadas.",
        refresh: "Actualizar",
        columns: {
          number: "Nº de orden",
          received: "Recibida",
          status: "Estado",
          type: "Tipo",
          warranty: "Garantía",
          customer: "Cliente",
          city: "Ciudad",
          product: "Producto",
          triage: "Triaje",
        },
        empty: {
          title: "Aún no se recibieron órdenes",
          description: "Cuando el colector envíe las órdenes, aparecerán aquí.",
          filtered: "Ninguna orden coincide con estos filtros.",
          noSources: "Esta empresa todavía no recibe órdenes. Sttelar realiza la activación.",
        },
        source: {
          online: "{{name}}: en línea, última señal {{time}}",
          offline: "{{name}}: sin señal ({{time}}). Verifique que la computadora del servicio técnico esté encendida y con internet.",
          needs_login: "{{name}}: el colector espera que alguien inicie sesión en el portal del fabricante, en la ventana del robot.",
          error: "{{name}}: el último ciclo del colector falló: {{error}}",
          never: "{{name}}: el colector todavía no envió señal. Configúrelo en la computadora del servicio técnico con el token de la integración.",
          inactive: "{{name}}: fuente desactivada.",
        },
        detail: {
          title: "Orden {{number}}",
          close: "Cerrar",
          customer: "Cliente",
          name: "Nombre",
          document: "Documento",
          phones: "Teléfonos",
          mentionedWhatsapp: "WhatsApp citado en el texto",
          email: "Correo",
          address: "Dirección",
          product: "Producto",
          brandModel: "Marca y modelo",
          serial: "Número de serie",
          category: "Categoría",
          purchaseDate: "Fecha de compra",
          warrantyEnd: "Fin de la garantía",
          warrantyStatus: "Garantía",
          invoice: "Factura",
          invoiceNumber: "Número de factura",
          reseller: "Revendedor",
          request: "Solicitud del cliente",
          symptom: "Síntoma",
          notes: "Observación del fabricante",
          service: "Atención",
          type: "Tipo",
          urgency: "Urgencia",
          visit: "Visita agendada",
          acceptedAt: "Aceptada por el servicio técnico el",
          openedAt: "Abierta el",
          receipt: "Recepción",
          receivedAt: "Llegó a Sttelar Talk",
          lastChangedAt: "Último cambio",
          lastSeenAt: "Último envío del colector",
          source: "Fuente",
          purged: "Los datos de esta orden fueron borrados por la retención.",
        },
      },
      triage: {
        tab: "Triaje",
        badge: "Triaje {{done}}/{{total}}",
        badgeTooltip: "Abrir el triaje de esta conversación",
        sessionStatus: {
          PENDING: "Sin iniciar",
          IN_PROGRESS: "En curso",
          WAITING_CUSTOMER: "Esperando al cliente",
          COMPLETED: "Concluido",
          CANCELLED: "Cancelado",
          FAILED: "Con falla",
        },
        requirementStatus: {
          NOT_REQUESTED: "No pedido",
          REQUESTED: "Pedido",
          PROCESSING: "En análisis",
          COMPLETED: "Recibido",
          INVALID: "Inválido",
          WAITING_RESEND: "Esperando reenvío",
          WAIVED: "Dispensado",
        },
        inputTypes: {
          text: "Texto",
          image: "Imagen",
          document: "Documento",
          document_or_image: "Documento o imagen",
          video: "Video",
          audio: "Audio",
        },
        fieldTypes: {
          string: "Texto",
          number: "Número",
          date: "Fecha",
          cpf_cnpj: "CPF/CNPJ",
          nfe_key: "Clave de NF-e",
          phone: "Teléfono",
          email: "Correo",
        },
        events: {
          TRIAGE_CREATED: "Triaje iniciado",
          TRIAGE_STARTED: "La IA empezó a conducir",
          TRIAGE_COMPLETED: "Triaje concluido",
          TRIAGE_HANDOFF: "Entregado al equipo",
          TRIAGE_CANCELLED: "Triaje cancelado",
          TRIAGE_FAILED: "Triaje con falla",
          OUTREACH_SENT: "Mensaje de apertura enviado",
          OUTREACH_FAILED: "Falla al enviar la apertura",
          FOLLOWUP_SENT: "Recordatorio enviado",
          FOLLOWUP_SKIPPED: "Recordatorio no enviado",
          REQUIREMENT_REQUESTED: "Ítem pedido",
          REQUIREMENT_RECEIVED: "Ítem recibido para análisis",
          REQUIREMENT_VALIDATED: "Ítem validado",
          REQUIREMENT_REJECTED: "Ítem marcado como inválido",
          ERROR_CODE_DETECTED: "Código de error identificado",
          REQUIREMENT_WAIVED: "Ítem dispensado",
          REQUIREMENT_MANUALLY_COMPLETED: "Ítem marcado como recibido",
          AI_PAUSED: "IA pausada",
          AI_RESUMED: "IA reanudada",
          CRM_MOVED: "Tarjeta movida en el CRM",
          CRM_SKIPPED: "CRM sin cambios",
          NOTE_UPDATED: "Nota actualizada",
          CONTACT_RENAMED: "Nombre del contacto armado por el triaje",
          DATA_PURGED: "Documentos y datos borrados (retención de 90 días)",
          CUSTOMER_EXPORTED: "Local enviado a Contele",
          CUSTOMER_EXPORT_FAILED: "Falla al enviar el local a Contele",
          CUSTOMER_EXPORT_SKIPPED: "Local no enviado a Contele",
          ERROR: "Error",
        },
        noteStages: {
          created: "Nota de resumen creada en las notas",
          final: "Nota de resumen final en las notas",
        },
        crmReasons: {
          moved_by_person: "una persona movió la tarjeta",
          column_missing: "la columna de destino ya no existe",
          card_deleted: "la tarjeta fue eliminada",
        },
        followUpEvents: {
          sent: "Recordatorio {{n}} enviado",
          skipped: "Recordatorio {{n}} no enviado",
          template: "plantilla {{name}}",
        },
        followUpReasons: {
          window_closed: "la ventana de 24 h de la API oficial estaba cerrada y el recordatorio no tiene plantilla",
        },
        customerExport: {
          status: {
            sentCreated: "Local creado en Contele el {{date}}",
            sentUpdated: "Local actualizado en Contele el {{date}}",
            pending: "Enviando el local a Contele…",
            retrying: "Contele no respondió: nuevo intento el {{date}}",
            failed: "Local no enviado a Contele: {{reason}}",
            skipped: "Local no enviado a Contele: {{reason}}",
          },
          reasons: {
            auth: "Contele rechazó las claves de la cuenta",
            rejected: "Contele rechazó los datos",
            unavailable: "Contele no respondió",
            integration_missing: "la cuenta de Contele fue eliminada",
            integration_inactive: "la cuenta de Contele está desactivada",
            keys_missing: "la cuenta de Contele no tiene las claves",
            data_purged: "los datos del triaje ya fueron borrados",
            internal: "error del Talk al enviar",
            no_name: "falta el nombre del cliente",
            no_address: "falta la dirección del cliente",
          },
          outcomes: {
            created: "local nuevo",
            updated: "local actualizado",
          },
          addressChanged: "dirección nueva",
          mediaLink: "con el enlace de los archivos",
          account: "Cuenta: {{name}}",
          retrying: "lo intentará de nuevo",
          retry: "Enviar de nuevo",
          retried: "Enviando el local a Contele de nuevo",
        },
        actors: {
          system: "Sistema",
          ai: "IA",
          customer: "Cliente",
          integration: "Integración",
        },
        attention: {
          customer_requested_human: "el cliente pidió hablar con una persona",
          customer_refused: "el cliente no quiso continuar el triaje",
          cannot_provide: "el cliente dijo que no tiene un ítem obligatorio",
          max_attempts: "se agotaron los intentos de un ítem",
          ai_unavailable: "la IA quedó no disponible (revise la clave y los créditos de OpenAI en Integraciones)",
          ai_limit: "el triaje llegó al límite de llamadas a la IA",
          ai_quota: "los mensajes de la IA del mes se acabaron",
          billing_suspended: "el envío está suspendido por el pago atrasado",
          send_failed: "no fue posible enviar la respuesta al cliente",
          ticket_with_human: "la OS llegó con el cliente en atención: entréguelo a la IA cuando quiera",
          no_response: "el cliente no respondió en el plazo del triaje",
          no_reply_to_reminders: "el cliente no respondió a los recordatorios",
        },
        crm: {
          card: "Triaje {{done}}/{{total}}",
          cardPending: "Triaje esperando inicio",
          cardAttention: "Triaje: llamar a una persona",
          cardCompleted: "Triaje concluido",
          cardCancelled: "Triaje cancelado",
          cardFailed: "Triaje con falla",
          section: "Triaje",
          progress: "{{done}} de {{total}} obligatorios",
          workOrder: "OS {{number}}",
          openConversation: "Abrir conversación",
          loadError: "No fue posible cargar el triaje de esta tarjeta.",
        },
        panel: {
          empty: "No hay triaje en curso en esta conversación.",
          start: "Iniciar triaje",
          chooseDefinition: "Elija el triaje",
          noDefinitions: "No hay triaje publicado. Un administrador lo crea en Flujos > Gestionar Triajes.",
          group: "El triaje no funciona en conversaciones de grupo.",
          closed: "Reabra la conversación para iniciar un triaje.",
          started: "Triaje iniciado.",
          progress: "{{done}} de {{total}} obligatorios",
          version: "versión {{version}}",
          aiActive: "IA activa en esta conversación",
          aiPaused: "Una persona conduce la conversación; la IA no responde",
          attention: "Requiere atención: {{reason}}",
          nextFollowUp: "Próximo recordatorio ({{n}} de {{total}}): {{date}}",
          nextHandoff: "Sin respuesta a los recordatorios, pasa a una persona el {{date}}",
          workOrder: "OS {{number}}",
          pause: "Pausar IA",
          resume: "Entregar a la IA",
          complete: "Concluir",
          cancel: "Cancelar",
          required: "Obligatorio",
          optional: "Opcional",
          attempts: "Intento {{attempts}} de {{max}}",
          reason: "Motivo: {{reason}}",
          routedBy: "Por la regla {{detail}}",
          warrantyList: "Lista: {{list}}",
          purged: "Documentos y datos borrados por la retención el {{date}}.",
          note: "Nota: {{note}}",
          itemActions: "Acciones del ítem",
          actions: {
            complete: "Marcar como recibido",
            invalidate: "Marcar como inválido",
            request: "Marcar como pedido",
            waive: "Dispensar",
            edit: "Corregir datos",
          },
          timeline: "Línea de tiempo",
          history: "Triajes anteriores",
          viewing: "Triaje del {{date}}",
          back: "Volver",
          unverified: "enviado por el cliente, sin verificar",
          workOrderToConfirm: "de la OS, a confirmar con el cliente",
          problem: {
            title: "Problema del cliente",
            code: "Código de error {{code}}",
            from: {
              workOrder: "de la OS, confirmado por el cliente",
              manual: "registrado por una persona",
              video: "visto en el video",
              audio: "dicho por el cliente",
              customer: "informado por el cliente",
              attachment: "enviado por el cliente",
            },
            via: {
              message: "código informado por el cliente",
              photo: "código leído en la foto",
              video: "código visto en el video",
            },
          },
          workOrderConfirmed: "de la OS, confirmado por el cliente",
          evidenceOpen: "Abrir el adjunto",
          evidenceUnread: "La IA no leyó este adjunto: revíselo",
          evidencePhoto: "Foto enviada por el cliente",
          evidenceKinds: {
            pdf: "PDF",
            file: "Archivo",
            video: "Video",
            audio: "Audio",
          },
          answer: "Respuesta",
          confidence: "Confianza de la lectura de la IA",
        },
        dialogs: {
          back: "Volver",
          confirm: "Confirmar",
          reasonLabel: "Motivo",
          reasonRequired: "Indique el motivo.",
          noteLabel: "Nota (opcional)",
          cancelTitle: "Cancelar el triaje",
          cancelText: "El triaje termina aquí y queda en el historial. Si la IA tenía la conversación, pasa a usted.",
          completeTitle: "Concluir el triaje",
          completeText: "Los ítems que faltan quedan como están. Si la IA tenía la conversación, pasa a usted.",
          completePending: "Ítems obligatorios que aún faltan: {{count}}.",
          invalidateTitle: "Marcar \"{{name}}\" como inválido",
          invalidateText: "Los datos de este ítem se descartan.",
          waiveTitle: "Dispensar \"{{name}}\"",
          waiveText: "El ítem deja de pedirse al cliente.",
          completeItemTitle: "Marcar \"{{name}}\" como recibido",
          completeItemText: "Complete lo que verificó (opcional).",
          requestTitle: "Marcar \"{{name}}\" como pedido",
          requestText: "Registra que el ítem se pidió al cliente. No se envía ningún mensaje desde aquí.",
        editItemTitle: "Corregir los datos de \"{{name}}\"",
        },
        manager: {
          button: "Gestionar Triajes",
          title: "Triajes",
          tabs: {
            definitions: "Triajes",
            sessions: "Seguimiento",
          },
          new: "Nuevo triaje",
          empty: "No hay triajes registrados.",
          emptyHint: "Un triaje define lo que la IA pide al cliente (fotos, documentos, datos) y qué hacer cuando todo llega.",
          status: {
            draft: "Borrador",
            active: "Publicado",
            archived: "Archivado",
          },
          publishedVersion: "Versión {{version}} publicada",
          notPublished: "Nunca publicado",
          activeSessions: "{{count}} en curso",
          updatedAt: "Modificado el {{date}}",
          showArchived: "Mostrar archivados",
          actions: {
            edit: "Editar",
            duplicate: "Duplicar",
            archive: "Archivar",
            restore: "Restaurar",
          },
          copyName: "{{name}} (copia)",
          archiveConfirm: "¿Archivar \"{{name}}\"? Sale de las opciones de inicio; los triajes en curso continúan.",
          archived: "Triaje archivado.",
          restored: "Triaje restaurado.",
          duplicated: "Copia creada como borrador.",
          published: "Versión {{version}} publicada.",
          saved: "Borrador guardado.",
          editor: {
            back: "Volver a la lista",
            newTitle: "Nuevo triaje",
            howItWorks: "Cómo funciona",
            tabs: {
              general: "General",
              items: "Ítems",
              messages: "Mensajes",
              outreach: "Contacto activo",
              workOrders: "Órdenes de servicio",
              contact: "Ficha del contacto",
              crm: "CRM",
              followUp: "Recordatorios",
              completion: "Conclusión",
            },
            save: "Guardar borrador",
            publish: "Publicar",
            unpublished: "Hay cambios sin publicar.",
            upToDate: "Versión {{version}} publicada, sin cambios pendientes.",
            neverPublished: "Borrador: todavía no publicado.",
            unsaved: "Cambios sin guardar",
            discardConfirm: "Hay cambios sin guardar. ¿Salir y descartarlos?",
            errors: {
              name: "Póngale un nombre al triaje.",
              noItems: "Agregue al menos un ítem.",
              noRequired: "Marque al menos un ítem como obligatorio.",
              itemName: "Ítem {{n}}: póngale un nombre al ítem.",
              itemRequest: "Ítem {{n}}: escriba el mensaje para pedir.",
              fieldLabel: "Ítem {{n}}: póngale un nombre a cada campo de extracción.",
              noFields: "Ítem {{n}}: agregue al menos un campo o apague la extracción.",
              completion: "Escriba el mensaje de conclusión.",
              outreachVariable: "Contacto activo: elija el valor de la variable {{n}} de la plantilla.",
              outreachFixed: "Contacto activo: escriba el texto fijo de la variable {{n}} de la plantilla.",
              outreachWorkOrder: "Contacto activo: la plantilla usa datos de la OS; active el inicio en la pestaña Órdenes de servicio.",
              workOrderSource: "Órdenes de servicio: elija la fuente de las OS.",
              workOrderStatuses: "Órdenes de servicio: elija al menos un estado.",
              workOrderTypes: "Órdenes de servicio: elija al menos un tipo de OS.",
              workOrderDays: "Órdenes de servicio: elija al menos un día para el envío.",
              workOrderWindow: "Órdenes de servicio: el horario de envío debe terminar después de empezar.",
              workOrderConnection: "Órdenes de servicio: elija, en la pestaña Contacto activo, la conexión que abre la conversación.",
              crmBoard: "CRM: elija el tablero.",
              crmEntry: "CRM: elija la columna de entrada.",
              crmCompleted: "CRM: elija la columna de concluidas.",
              crmSame: "CRM: la entrada y las concluidas deben ser columnas diferentes.",
              crmRule: "CRM, regla {{n}}: elija el ítem y la columna.",
              crmCompletedOnly: "CRM: la columna de concluidas es solo para los triajes concluidos; elija otra para \"en triaje\", atención y reglas.",
              crmOnlyPending: "CRM, regla {{n}}: \"único obligatorio que falta\" solo vale para un ítem obligatorio.",
              routeValues: "Encaminamiento, regla {{n}}: informe al menos un valor.",
              routeTooMany: "Encaminamiento, regla {{n}}: como máximo {{max}} valores.",
              routeLong: "Encaminamiento, regla {{n}}: cada valor puede tener hasta {{max}} caracteres.",
              routeDestination: "Encaminamiento, regla {{n}}: elija la cola o la persona.",
              warrantyRequired: "{{list}}: marque al menos un ítem como obligatorio.",
              routeValuesAt: "Encaminamiento, regla {{n}}, dato {{m}}: informe al menos un valor.",
              routeTooManyAt: "Encaminamiento, regla {{n}}, dato {{m}}: como máximo {{max}} valores.",
              routeLongAt: "Encaminamiento, regla {{n}}, dato {{m}}: cada valor puede tener hasta {{max}} caracteres.",
              routeRepeated: "Encaminamiento, regla {{n}}: use cada dato de la OS una sola vez.",
              customerExportAccount: "Contele: elija la cuenta donde se crea el local.",
              customerExportNeedsWorkOrders: "Contele: el local usa los datos de la orden de servicio; active el inicio en la pestaña Órdenes de servicio.",
              followUpNone: "Recordatorios: agregue al menos un recordatorio o desactive los recordatorios.",
              followUpTime: "Recordatorio {{n}}: el tiempo sin respuesta va de 10 minutos a 30 días.",
              followUpOrder: "Recordatorio {{n}}: necesita más tiempo sin respuesta que el anterior.",
              followUpMessage: "Recordatorio {{n}}: escriba el mensaje.",
              followUpVariable: "Recordatorio {{n}}: elija el valor de la variable {{v}} de la plantilla.",
              followUpFinal: "Recordatorios: pasar a una persona necesita más tiempo sin respuesta que el último recordatorio (hasta 30 días).",
              followUpDays: "Recordatorios: elija al menos un día para el envío.",
              followUpWindow: "Recordatorios: el horario de envío debe terminar después de empezar.",
              followUpExpire: "Recordatorios: el último paso debe venir antes de que el triaje expire ({{days}} días sin respuesta, en la pestaña Conclusión).",
              contactNameEmpty: "Ficha del contacto: escriba cómo queda el nombre o desactive la opción.",
              contactNameTooLong: "Ficha del contacto: el nombre puede tener hasta {{max}} caracteres.",
              contactNameLines: "Ficha del contacto: el nombre va en una sola línea.",
              contactNameBraces: "Ficha del contacto: falta abrir o cerrar una llave { }.",
              contactNameToken: "Ficha del contacto: {{token}} no puede ir en el nombre. Use los botones debajo del campo.",
              contactNameWorkOrder: "Ficha del contacto: {{token}} usa datos de la OS; active el inicio en la pestaña Órdenes de servicio.",
              contactNameNoData: "Ficha del contacto: ponga al menos un dato en el nombre (botones debajo del campo).",
              contactNameTooMany: "Ficha del contacto: use como máximo {{max}} datos en el nombre.",
            },
            general: {
              name: "Nombre",
              namePlaceholder: "Ej.: Garantía Midea",
              description: "Descripción (opcional)",
              model: "Modelo de IA",
              modelHint: "La clave de OpenAI viene de Integraciones.",
              aiUser: "Usuario IA",
              aiUserHint: "Aparece como dueño de la conversación mientras la IA conduce. Debe tener \"IA Activa\" apagado en el registro de usuarios.",
              aiUserNone: "Elija un usuario IA",
              aiUserUnusable: "{{name}} (IA Activa encendida)",
              noAiUsers: "No hay usuario IA en esta empresa. Cree uno en Usuarios, marcado como IA y con \"IA Activa\" apagado.",
              waitTime: "Espera antes de responder (segundos)",
              waitTimeHint: "Junta mensajes seguidos del cliente en una sola respuesta.",
            },
            items: {
              add: "Agregar ítem",
              empty: "No hay ítems. Agregue lo que la IA debe pedir al cliente.",
              untitled: "Ítem sin nombre",
              name: "Nombre del ítem",
              namePlaceholder: "Ej.: Foto de la etiqueta",
              key: "Clave",
              keyHint: "Identificador interno: minúsculas, números y _.",
              description: "Descripción (opcional)",
              inputType: "El cliente envía",
              required: "Obligatorio",
              requestMessage: "Mensaje para pedir",
              requestPlaceholder: "Ej.: Por favor, envíe una foto de la etiqueta del aparato.",
              workOrderField: "Dato de la OS para confirmar",
              workOrderFieldHint: "Con el triaje empezando por la OS, la IA muestra este dato y el cliente lo confirma o corrige, en vez de escribir todo. El CPF y los campos sensibles nunca aparecen en el mensaje.",
              workOrderFieldNone: "Ninguno: pedir al cliente",
              compareWith: "Comparar con la OS",
              compareWithNone: "No comparar",
              compareWithFields: {
                productModel: "Modelo del producto",
                serialNumber: "Número de serie",
                invoiceNumber: "Número de la factura",
                purchaseDate: "Fecha de compra",
                customerDocument: "CPF/CNPJ del cliente",
              },
              workOrderFields: {
                address: "Dirección del cliente",
                buyer: "Nombre y CPF/CNPJ del cliente",
                product: "Marca y modelo del producto",
                purchaseDate: "Fecha de compra",
                problem: "Solicitud del cliente (defecto)",
                invoiceNumber: "Número de la factura",
              },
              retryMessage: "Mensaje para pedir de nuevo (opcional)",
              aiInstruction: "Instrucción para la IA (opcional)",
              aiInstructionPlaceholder: "Ej.: La etiqueta está en el lateral de la unidad interior.",
              maxAttempts: "Intentos",
              onMaxAttempts: "Cuando se acaben los intentos",
              onMax: {
                handoff: "Llamar a una persona",
                waive: "Dispensar el ítem",
                keep_asking: "Seguir pidiendo",
              },
              optionalOnMax: "Ítem opcional: en el límite, se dispensa.",
              extraction: "Extraer datos de lo que envíe el cliente",
              extractionHint: "La IA lee lo que llegó y completa estos campos.",
              minConfidence: "Confianza mínima (%)",
              addField: "Agregar campo",
              fieldLabel: "Nombre del campo",
              fieldKey: "Clave",
              fieldType: "Tipo",
              fieldRequired: "Obligatorio",
              fieldSensitive: "Sensible",
              fieldSensitiveHint: "Enmascarado en logs y en la línea de tiempo.",
              moveUp: "Subir",
              moveDown: "Bajar",
              remove: "Quitar",
              expand: "Editar ítem",
              extractsData: "extrae datos",
              isProblem: "Problema del cliente",
              isProblemHint: "Confirmado, aparece arriba en el panel del agente, con el código de error que el cliente informe en la conversación (escrito, hablado, en la foto del visor o en el video).",
              warranty: {
                split: "Ítems diferentes en garantía y fuera de garantía",
                splitInfo: "La garantía viene de la OS cuando empieza el triaje. Cada ítem vale en garantía, fuera o en las dos situaciones, y la IA pide solo los ítems de la situación de la OS.",
                whenUnknown: "Sin la garantía en la OS, usar la lista",
                noWorkOrders: "Sin el inicio por las OS, todo triaje usa la lista {{list}}.",
                lists: { in: "En garantía", out: "Fuera de garantía" },
                listsAria: "Lista de ítems",
                askIn: "Pedir en",
                askInOptions: { both: "En garantía y fuera", in: "Solo en garantía", out: "Solo fuera de garantía" },
                both: "en garantía y fuera",
                removeFromList: "Quitar de esta lista",
                viewingIn: "Lo que la IA pide cuando la OS está en garantía",
                viewingOut: "Lo que la IA pide cuando la OS está fuera de garantía",
                allBoth: "Por ahora, todos los ítems valen en garantía y fuera. Para separarlos, abra un ítem y elija en “Pedir en”.",
                emptyList: "Ningún ítem en esta lista. Agregue lo que la IA debe pedir.",
                turnOffTitle: "¿Unir las listas?",
                turnOffText: "Las dos listas pasan a ser una: la IA pedirá los {{count}} ítems en toda OS.",
                turnOffConfirm: "Unir",
              },
            },
            messages: {
              replyMode: "Cómo escribe la IA",
              replyModes: {
                humanized: "Con sus propias palabras, usando los mensajes como base",
                configured: "Exactamente los mensajes configurados",
              },
              persona: "Persona (opcional)",
              personaPlaceholder: "Ej.: Asistente del servicio técnico. Tono cordial y objetivo, frases cortas.",
              supportText: "Texto de apoyo (opcional)",
              supportTextHint: "Información que la IA puede usar para aclarar dudas: plazos, horarios, dirección.",
              intro: "Mensaje de apertura (opcional)",
              introHint: "Se envía cuando empieza el triaje.",
              completion: "Mensaje de conclusión",
              completionPlaceholder: "Ej.: ¡Gracias! Ya tenemos todo. Nuestro equipo se comunicará para agendar.",
              byWarranty: {
                supportText: "Texto de apoyo de cada garantía (opcional)",
                completion: "Mensaje de conclusión de cada garantía (opcional)",
                hint: "Vacío: vale el texto de arriba.",
              },
            },
            completion: {
              ticketAction: "Cuando termine el triaje",
              actions: {
                close: "Cerrar la conversación",
                keep_pending: "Pasar al equipo",
              },
              ticketActionInfo: "Antes, la IA envía el mensaje de conclusión al cliente. Si una persona lo concluye en el panel, la conversación queda con ella.",
              handoff: "Cuando la IA llame a una persona",
              handoffInfo: "Pasa cuando el cliente pide un agente, no responde a los recordatorios, se acaban los intentos de un ítem o la IA no puede seguir. Con un agente elegido, la conversación va a él; sin agente, queda en espera en la cola.",
              destination: {
                queue: "Cola",
                queueKeep: "Mantener la cola actual",
                queueNone: "Sin cola",
                user: "Agente",
                userNone: "Nadie: queda en espera",
                removed: "La cola o el agente elegido cambió (fue eliminado o salió de la cola). Elija de nuevo o déjelo en blanco.",
              },
              expireTitle: "El cliente dejó de responder",
              expireBefore: "Terminar el triaje después de",
              expireUnit: "días (0 = nunca)",
              expireInfo: "El triaje expira y la tarjeta del CRM va a la columna de atención. Si la IA conducía la conversación, se cierra sin evaluación y sin mensaje.",
            },
            routes: {
              title: "Excepciones por la OS",
              info: "Según los datos de la OS, llevan la conversación a otra cola o agente en lugar de lo de arriba (incluso con “Cerrar la conversación”). Vale la primera que sirva, de arriba abajo.",
              needsWorkOrders: "Solo vale con el inicio por las OS (pestaña Órdenes de servicio).",
              editRule: "Editar la regla {{n}}",
              noValue: "sin valor",
              goesTo: "Va a {{destination}}",
              noDestination: "Elija a dónde va",
              field: "Dato de la OS",
              match: "Comparación",
              fields: {
                model: "Modelo",
                brand: "Marca",
                category: "Categoría",
                type: "Tipo de OS",
                warranty: "Garantía",
                city: "Ciudad",
                state: "Estado (UF)",
              },
              matches: {
                equals: "es uno de estos",
                startsWith: "empieza con",
                contains: "contiene",
              },
              values: "Valores (uno por línea)",
              valuesHint: "Puede pegar una lista; mayúsculas y acentos no importan.",
              placeholders: {
                model: "UN50TU8000GXZD\nQN50Q60TAGXZD",
                brand: "Samsung",
                category: "LED TV",
                type: "Em domicílio",
                warranty: "Fora da garantia",
                city: "Passo Fundo",
                state: "RS",
              },
              destination: "Va a",
              add: "Agregar regla",
              and: "Y",
              addCondition: "Y también",
              removeCondition: "Quitar este dato",
              joinLast: "y",
              moveUp: "Subir",
              moveDown: "Bajar",
              remove: "Quitar regla",
            },
            customerExport: {
              title: "Contele",
              info: "Al concluir (por la IA o por una persona), crea en Contele el local de la OS con el n.º de la OS y el nombre, el documento, la dirección y el teléfono del cliente. Si la OS se vuelve a triar, se actualiza el mismo local, sin borrar lo que escribió el equipo.",
              enabled: "Crear el local de la OS al concluir",
              account: "Cuenta de Contele",
              accountChoose: "Elija la cuenta",
              inactiveTag: "desactivada",
              inactive: "Esta cuenta está desactivada en Integraciones: los envíos fallan hasta que se active de nuevo.",
              removed: "La cuenta elegida fue eliminada. Elija otra.",
              removedNone: "La cuenta elegida fue eliminada y no hay otra. Sttelar la registra en Integraciones.",
              noAccounts: "No hay ninguna cuenta de Contele registrada. Sttelar la registra en Integraciones.",
              needsWorkOrders: "Requiere el inicio por las OS (pestaña Órdenes de servicio).",
              items: "Llevar junto",
              itemsInfo: "El texto va en las Observaciones del local. Fotos, videos y documentos van por un enlace válido por 60 días: quien tenga el enlace ve los archivos, sin iniciar sesión.",
              byLink: "por el enlace",
            },
            followUp: {
              intro: "Cuando el cliente deja de responder, la IA envía un recordatorio de lo que falta. El tiempo cuenta desde el último pedido de la IA; si el cliente responde, la cuenta empieza de nuevo en el siguiente pedido.",
              enabled: "Recordar al cliente que dejó de responder",
              stageTitle: "Recordatorio {{n}}",
              remove: "Quitar recordatorio",
              removeStage: "Quitar el recordatorio {{n}}",
              after: "Enviar con el cliente sin responder desde hace",
              unit: "Unidad",
              units: {
                minutes: "minutos",
                hours: "horas",
                days: "días",
              },
              message: "Mensaje",
              messagePlaceholder: "Ej.: ¡Hola, {primeiro_nome}! Todavía esperamos {item} para seguir con su atención.",
              messageHint: "La IA escribe el recordatorio con sus propias palabras, a partir de este mensaje. Use {primeiro_nome} e {item} (lo que falta que el cliente envíe).",
              messageHintConfigured: "Se envía exactamente así. Use {primeiro_nome} e {item} (lo que falta que el cliente envíe).",
              template: "Plantilla (ventana de 24 h cerrada)",
              templateHint: "En la API oficial, después de 24 h sin que el cliente escriba, solo se puede enviar una plantilla. Sin plantilla, el recordatorio se omite en ese caso.",
              templateNone: "Ninguna",
              needsTemplate: "Con 24 h o más sin respuesta, la ventana de la API oficial ya cerró: sin plantilla, este recordatorio no se envía.",
              add: "Agregar recordatorio",
              final: "Después del último recordatorio",
              finalWait: "Seguir esperando (el triaje expira con {{days}} días sin respuesta, según la pestaña Conclusión)",
              finalWaitNever: "Seguir esperando (sin plazo: la pestaña Conclusión está en 0)",
              finalHandoff: "Pasar la conversación a una persona",
              finalAfter: "Con el cliente sin responder desde hace",
              finalToUserQueue: "Va a {{user}}, en Atendiendo, en la cola {{queue}}.",
              finalToUser: "Va a {{user}}, en Atendiendo, sin cola.",
              finalToQueue: "Queda en espera, sin dueño, en la cola {{queue}}.",
              finalToKeep: "Queda en espera, sin dueño, en la cola en que está.",
              finalFrom: "Es el destino de \"Cuando la IA pase la conversación a una persona\", en la pestaña Conclusión.",
              finalChange: "Cambiar destino",
              finalRoutesFirst: "Antes, valen las reglas de \"Encaminar por los datos de la OS\".",
              finalCrmNothingSent: "La tarjeta del CRM va a atención. No se envía nada al cliente.",
              finalNothingSent: "No se envía nada al cliente.",
              window: "Horario de envío",
              windowHint: "Días y horario (de Brasilia) en que puede salir un recordatorio. Fuera de él, el recordatorio espera el próximo horario.",
              countNote: "Ejemplo: con recordatorios a las 4 horas y a 1 día, el cliente que no responda al pedido de las 10h recibe uno a las 14h y otro a las 10h del día siguiente.",
              stopNote: "Los recordatorios se detienen cuando el cliente responde, cuando una persona asume o pausa la IA y cuando el triaje termina.",
              metaNote: "API oficial: dentro de la ventana de 24 h el recordatorio sale como mensaje común; fuera de ella, solo con la plantilla elegida en el recordatorio.",
              defaultMessage1: "¡Hola, {primeiro_nome}! Todavía esperamos {item} para seguir con su atención.",
              defaultMessage2: "{primeiro_nome}, solo para recordar: para continuar la atención, necesitamos {item}. Solo envíelo por aquí.",
            },
            crm: {
              intro: "La tarjeta del triaje en un tablero del CRM: nace cuando empieza el triaje y avanza sola por las columnas hasta la de concluidas, donde trabaja el equipo de agendamiento.",
              enabled: "Crear y mover la tarjeta del triaje en el CRM",
              noBoards: "Esta empresa todavía no tiene tablero en el CRM. Cree uno en la pantalla del CRM.",
              board: "Tablero",
              boardNone: "Elija el tablero",
              columnChoose: "Elija la columna",
              columnNone: "Ninguna (la tarjeta se queda donde está)",
              entry: "Entrada",
              entryHint: "Donde nace la tarjeta, cuando empieza el triaje.",
              inProgress: "En triaje",
              inProgressHint: "Mientras la IA conduce. Sin ella, la tarjeta se queda en la entrada.",
              attention: "Atención",
              attentionHint: "Cuando el triaje llama a una persona o vence sin respuesta.",
              completed: "Concluidas",
              completedHint: "Cuando termina el triaje.",
              rules: "Reglas por ítem",
              rulesHint: "Columnas para momentos del triaje (ej.: \"Esperando factura\"). Vale la primera regla que coincida, en el orden de la lista.",
              ruleItem: "Ítem",
              ruleItemChoose: "Elija el ítem",
              ruleWhen: "Cuándo",
              ruleColumn: "Columna",
              ruleRemove: "Quitar regla",
              whenOptions: {
                awaiting: "Esperando al cliente",
                only_pending: "Único obligatorio que falta",
              },
              addRule: "Agregar regla",
              manualNote: "Una tarjeta que alguien mueva a una columna fuera de estas se queda donde la persona la dejó: el triaje ya no la mueve.",
              cancelNote: "Triaje cancelado por una persona: la tarjeta se queda donde está.",
            },
            contact: {
              intro: "Arme el nombre del contacto con datos del triaje, como el número de la OS y el nombre confirmado. Así el equipo encuentra la conversación por la búsqueda.",
              enabled: "Armar el nombre del contacto con los datos del triaje",
              format: "Nombre del contacto",
              formatPlaceholder: "Ej.: {os} {nome}",
              formatHint: "Use los botones de abajo para poner los datos. Puede escribir texto entre ellos.",
              groups: {
                contact: "Del contacto",
                workOrder: "De la OS",
                items: "Confirmados en la conversación",
              },
              tokens: {
                nome: "Nombre del cliente",
                primeiro_nome: "Primer nombre",
                os: "Número de la OS",
              },
              workOrderOff: "Para usar los datos de la OS, active el inicio por las OS.",
              workOrderOpen: "Abrir Órdenes de servicio",
              itemsNone: "Ningún ítem tiene datos que puedan ir en el nombre.",
              itemsExcluded: "CPF/CNPJ, campos sensibles, audio y video no van en el nombre.",
              add: "Poner \"{{label}}\" en el nombre",
              preview: "Cómo queda (ejemplo)",
              and: " y ",
              when: {
                title: "Cuándo cambia:",
                start: "cuando empieza el triaje.",
                items: "cuando la IA concluya {{items}}. Si el triaje termina antes, cambia al concluir, con lo que haya.",
                end: "al concluir el triaje, porque ningún ítem confirma el nombre del cliente.",
                linkHint: "Para cambiarlo cuando la IA confirme el nombre, vincule el ítem del nombre a “Nombre y CPF/CNPJ del cliente”.",
                openItems: "Abrir Ítems",
              },
              notes: {
                customer: "En los mensajes, el cliente sigue siendo llamado solo por su nombre.",
                once: "El nombre cambia una vez por triaje. Si alguien edita el nombre después, la edición se mantiene.",
                missing: "El dato que no llegue queda fuera del nombre.",
              },
            },
            workOrders: {
              intro: "Inicie el triaje desde las órdenes de servicio (OS) que llegan de la fuente, sin que nadie tenga que abrir la conversación.",
              enabled: "Iniciar el triaje desde las órdenes de servicio",
              noSources: "Esta empresa aún no tiene fuente de OS. El super admin la registra en Integraciones.",
              source: "Fuente de las OS",
              sourceNone: "Elija la fuente",
              inactive: "inactiva",
              startMode: "Inicio",
              modes: {
                auto: "Automático: la IA contacta al cliente en cuanto llega la OS",
                manual: "Manual: con el botón en la pantalla Órdenes de servicio",
              },
              autoHint: "La OS que llegue (o cambie) a uno de los estados de abajo inicia el triaje solo, dentro del horario de envío. El botón en la pantalla de OS sigue disponible.",
              manualHint: "Nada se envía solo: un admin elige la OS y hace clic en Iniciar triaje.",
              statuses: "Estados de la OS",
              statusesHint: "El triaje solo empieza con la OS en uno de estos estados.",
              types: "Tipos de OS",
              typesHint: "Los tipos de OS que atiende este triaje.",
              window: "Horario de envío",
              windowHint: "Días y horario (de Brasilia) en que la IA puede contactar al cliente. Fuera de él, la OS espera el próximo horario.",
              contactName: "El número de la OS en el nombre del contacto ahora está en la pestaña Ficha del contacto.",
              contactNameOpen: "Abrir",
              days: "Días de envío",
              dayNames: {
                d0: "Dom",
                d1: "Lun",
                d2: "Mar",
                d3: "Mié",
                d4: "Jue",
                d5: "Vie",
                d6: "Sáb",
              },
              from: "Desde",
              to: "Hasta",
              connectionNote: "La conversación se abre por la conexión elegida en la pestaña Contacto activo.",
              noConnection: "Elija la conexión en la pestaña Contacto activo.",
              metaNeedsTemplate: "En la API oficial, el inicio por OS necesita una plantilla en la pestaña Contacto activo: el cliente nuevo aún no abrió la ventana de 24 h.",
              autoSinceNote: "Al publicar, el automático vale solo para las OS que lleguen a partir de entonces; las que ya están en la lista empiezan con el botón.",
              humanNote: "Si el cliente ya está con un agente, la IA no toma la conversación: el triaje espera y se avisa al agente.",
            },
            outreach: {
              intro: "Cómo el triaje abre la conversación con quien aún no escribió. En la API oficial, fuera de la ventana de 24 h, solo con una plantilla aprobada; en WAHA, con el mensaje de apertura.",
              connection: "Conexión",
              connectionHint: "La conexión de WhatsApp que abre la conversación.",
              connectionNone: "Ninguna (el triaje empieza solo en conversaciones ya abiertas)",
              providers: {
                "meta-api": "API oficial",
                waha: "WAHA",
              },
              disconnected: "Esta conexión está desconectada ahora.",
              template: "Plantilla",
              templateHint: "Las plantillas aprobadas por Meta en esta conexión. Cree la suya en Plantillas Meta; para este uso, la categoría Utilidad es la indicada.",
              loadingTemplates: "Cargando plantillas…",
              noTemplates: "Ninguna plantilla aprobada en esta conexión.",
              templatesError: "No se pudieron cargar las plantillas de esta conexión.",
              chooseTemplate: "Elija una plantilla para que el triaje pueda abrir la conversación fuera de la ventana de 24 h.",
              mediaHeader: "Tiene multimedia en el encabezado, que el triaje aún no envía.",
              headerVariable: "Tiene una variable en el título, que el triaje aún no completa.",
              authTemplate: "Es de autenticación, que el triaje no usa.",
              namedVariable: "Usa una variable con nombre, que el triaje aún no completa.",
              codeButton: "Tiene un botón de código o de flujo, que el triaje no envía.",
              urlVariable: "Tiene un botón de enlace con variable, que el triaje aún no completa.",
              removedConnection: "La conexión elegida antes fue eliminada. Elija otra (o ninguna) y guarde.",
              missingTemplate: "La plantilla elegida ({{name}}) ya no está entre las aprobadas de esta conexión.",
              variables: "Variables de la plantilla",
              variablesHint: "De dónde viene el valor de cada variable del texto.",
              variableLabel: "Valor de la variable {{n}}",
              sourceNone: "Elija",
              sources: {
                contactFirstName: "Nombre de pila del contacto",
                contactName: "Nombre del contacto",
                companyName: "Nombre de la empresa",
                woCustomerFirstName: "Nombre de pila del cliente (OS)",
                woCustomerName: "Nombre del cliente (OS)",
                woNumber: "Número de la OS",
                woProductBrand: "Marca del producto (OS)",
                woProductModel: "Modelo del producto (OS)",
                fixed: "Texto fijo",
              },
              fixedPlaceholder: "Texto en lugar de la variable",
              fixedLabel: "Texto fijo de la variable {{n}}",
              preview: "Vista previa (con datos de ejemplo)",
              metaInfo: "Después de la plantilla, la IA espera la respuesta del cliente: Meta solo permite texto libre después de la respuesta. Termine la plantilla con una pregunta o un botón.",
              wahaInfo: "En WAHA no hay plantillas: la conversación abre con el mensaje de apertura (pestaña Mensajes), y la IA sigue directo al primer pedido.",
              wahaWarning: "Atención: enviar el primer mensaje a quien nunca habló con este número, por un canal no oficial, aumenta el riesgo de que WhatsApp bloquee el número.",
            },
          },
          sessions: {
            status: "Situación",
            statuses: {
              active: "En curso",
              COMPLETED: "Concluidos",
              CANCELLED: "Cancelados",
              FAILED: "Con falla",
              all: "Todos",
            },
            allDefinitions: "Todos los triajes",
            columns: {
              customer: "Cliente",
              definition: "Triaje",
              status: "Situación",
              started: "Inicio",
              ended: "Fin",
            },
            open: "Abrir conversación",
            noContact: "Contacto eliminado",
            empty: "No se encontró ningún triaje.",
            loadMore: "Cargar más",
            total: "{{count}} en total",
          },
        },
      },
      smartApproaches: {
        title: "Abordajes inteligentes",
        subtitle: "Mensajes que se envían solos cuando el cliente no responde a una plantilla de la API oficial. Si el cliente responde, los próximos envíos se cancelan.",
        newFlow: "Nuevo flujo",
        noConnection: "Para usarlo, conecta un número de la API oficial en Conexiones.",
        onlyAdmins: "Solo los administradores configuran los abordajes inteligentes.",
        loadError: "No se pudieron cargar los flujos.",
        conflict: "La plantilla inicial ya inicia el flujo activo \"{{name}}\" en esta conexión. Desactívalo antes de activar este.",
        filtersLabel: "Filtrar flujos",
        filters: {
          all: "Todos",
          active: "Activos",
          inactive: "Inactivos",
        },
        empty: {
          title: "Todavía no hay flujos",
          text: "Crea un flujo para elegir una plantilla y los mensajes que se envían solos cuando el cliente no responde.",
          filtered: "No hay flujos en este filtro.",
        },
        active: "Activo",
        inactive: "Inactivo",
        messagesOne: "1 mensaje",
        messagesMany: "{{count}} mensajes",
        openRunsOne: "1 abordaje en curso",
        openRunsMany: "{{count}} abordajes en curso",
        activate: "Activar",
        deactivate: "Desactivar",
        edit: "Editar",
        delete: "Eliminar",
        activated: "Flujo activado.",
        deactivated: "Flujo desactivado.",
        deleted: "Flujo eliminado.",
        confirmDeactivateTitle: "¿Desactivar el flujo?",
        confirmDeactivateText: "Los abordajes en curso ({{count}}) se detienen ahora: sus mensajes automáticos no se enviarán. Las conversaciones siguen abiertas.",
        confirmDeleteTitle: "¿Eliminar el flujo?",
        confirmDeleteText: "El flujo sale de la lista y la plantilla vuelve a ser común. Los abordajes en curso se detienen. Los números siguen en el Dashboard.",
        issues: {
          unchecked: "No se pudieron verificar las plantillas en Meta ahora.",
          line: "{{step}}: la plantilla \"{{name}}\" está {{status}} en Meta.",
          initial: "Plantilla inicial",
          step: "Mensaje {{n}}",
          status: {
            PAUSED: "pausada",
            DISABLED: "desactivada",
            REJECTED: "rechazada",
            PENDING: "en revisión",
            IN_APPEAL: "en apelación",
            MISSING: "eliminada",
            other: "no disponible",
          },
        },
        sequence: {
          now: "ahora",
          after: "+{{hours}} h",
        },
        days: {
          d0: "dom.",
          d1: "lun.",
          d2: "mar.",
          d3: "mié.",
          d4: "jue.",
          d5: "vie.",
          d6: "sáb.",
          range: "{{from}} a {{to}}",
        },
        ordinals: {
          n1: "1.er",
          n2: "2.º",
          n3: "3.er",
        },
        duration: {
          minutes: "{{minutes}} min",
          hours: "{{hours}} h",
          hoursMinutes: "{{hours}} h {{minutes}} min",
        },
        when: {
          soon: "en instantes",
          in: "en {{duration}}",
          at: "el {{date}} a las {{time}}",
          late: "con retraso",
        },
        bar: {
          title: "Abordaje inteligente",
          active: "Abordaje inteligente activo",
          awaiting: "esperando respuesta",
          sent: "{{step}} mensaje enviado",
          next: "{{step}} mensaje {{when}}",
          allSent: "todos los mensajes enviados, esperando respuesta",
          interrupted: "Abordaje inteligente interrumpido",
          completed: "Abordaje inteligente concluido",
          cancelledTitle: "Abordaje inteligente cancelado",
          replied: "el cliente respondió (después del {{step}} mensaje)",
          noReply: "sin respuesta",
          void: "el 1.er mensaje no fue entregado",
          hint: "Enviar un mensaje en la conversación cancela los próximos envíos automáticos.",
          details: "Detalles",
          cancel: "Cancelar flujo inteligente",
          dismiss: "Ocultar",
          cancelled: {
            manual: "por el agente",
            manualBy: "por {{name}}",
            agent_message: "se envió un mensaje en la conversación",
            agent_messageBy: "{{name}} envió un mensaje",
            ticket_closed: "atención finalizada",
            flow_disabled: "flujo desactivado",
            opt_out: "el cliente pidió no recibir mensajes",
            expired: "el {{step}} mensaje se retrasó demasiado y no se envió",
            other: "los envíos automáticos se detuvieron",
          },
          failed: {
            template_unavailable: "la plantilla del {{step}} mensaje no está aprobada en Meta",
            invalid_variables: "faltó el valor de una variable del {{step}} mensaje",
            no_phone: "el contacto no tiene número de teléfono",
            send_failed: "Meta rechazó el {{step}} mensaje",
            send_uncertain: "no se pudo confirmar el envío del {{step}} mensaje",
            delivery_failed: "el {{step}} mensaje no fue entregado",
            start_interrupted: "no se pudo confirmar el envío del 1.er mensaje",
            other: "error al enviar el {{step}} mensaje",
          },
        },
        details: {
          title: "Abordaje inteligente",
          close: "Cerrar",
          step: "{{step}} mensaje",
          planned: "Previsto: {{hours}} h después del anterior, si el cliente no responde",
          scheduled: "Programado: sale {{when}}",
          reply: "El cliente respondió",
          startedBy: "Iniciado por {{name}} · {{date}}",
          startedAt: "Iniciado · {{date}}",
          status: {
            sent: "Enviado",
            delivered: "Entregado",
            read: "Leído",
            failed: "Falló",
            sending: "Enviando",
            cancelled: "No enviado",
            uncertain: "Envío no confirmado",
            expired: "No enviado: se retrasó demasiado",
          },
        },
        cancel: {
          title: "¿Cancelar el flujo inteligente?",
          text: "Los próximos mensajes automáticos de esta conversación no se enviarán. La atención sigue abierta.",
          confirm: "Cancelar flujo",
          done: "Flujo inteligente cancelado.",
        },
        messageMark: "Envío automático · Abordaje inteligente ({{step}} de {{total}})",
        messageMarkTitle: "Enviado por el sistema porque el cliente no respondió",
        modal: {
          filter: "Inteligentes",
          tooltip: "Abordaje inteligente – Seguimiento automático",
          sectionTitle: "Abordaje inteligente",
          first: "Ahora: esta plantilla",
          afterFirst: "Tras {{hours}} h sin respuesta",
          afterNext: "Tras {{hours}} h más sin respuesta",
          stop: "Si el cliente responde, los próximos envíos se cancelan.",
          window: "Horario de los envíos automáticos: {{window}}.",
          onlyFirst: "Flujo de 1 mensaje: nada se envía solo; la respuesta del cliente cuenta en el Dashboard.",
          notice: {
            blocked: "Esta conversación ya tiene un abordaje inteligente en curso ({{name}}). Para enviar otra plantilla inteligente, cancela el actual.",
            cancels: "Esta conversación tiene un abordaje inteligente en curso ({{name}}). Enviar esta plantilla cancela los próximos envíos automáticos.",
            unknown: "Esta conversación tiene un abordaje inteligente en curso ({{name}}). Una plantilla común cancela los próximos envíos automáticos; una plantilla inteligente solo sale después de cancelar el actual.",
          },
          cancelRun: "Cancelar abordaje actual",
          started: "Abordaje inteligente iniciado: el {{step}} mensaje sale {{when}} si el cliente no responde.",
          startedSingle: "Plantilla enviada. Abordaje inteligente iniciado.",
          notStarted: "Plantilla enviada, pero el abordaje inteligente no comenzó: los próximos mensajes no se enviarán solos.",
        },
        dashboard: {
          title: "Abordajes inteligentes",
          help: "Abordajes que comenzaron en el período: cuántos clientes respondieron y después de qué mensaje.",
          flowFilter: "Filtrar por flujo",
          templateFilter: "Filtrar por plantilla inicial",
          allFlows: "Todos los flujos",
          allTemplates: "Todas las plantillas",
          deleted: "{{name}} (eliminado)",
          started: "Iniciados",
          replied: "Respondieron",
          noReply: "Sin respuesta",
          inProgress: "Esperando respuesta",
          rate: "Tasa de respuesta",
          rateHelp: "De los abordajes que ya terminaron, cuántos tuvieron respuesta. Los que esperan respuesta cuentan cuando termine el plazo del flujo.",
          chartTitle: "Respuestas por mensaje",
          chartHelp: "Después de qué mensaje respondió el cliente.",
          stepLabel: "{{step}} mensaje",
          repliedAfter: "respondieron después del {{step}} mensaje",
          tableLabel: "Ver la tabla por",
          byFlow: "Por flujo",
          byTemplate: "Por plantilla",
          columns: {
            flow: "Flujo",
            template: "Plantilla inicial",
            started: "Iniciados",
            replied: "Respondieron",
            noReply: "Sin respuesta",
            rate: "Tasa",
          },
          empty: "Ningún abordaje inteligente comenzó en este período.",
          loadError: "No se pudieron cargar los números.",
          refreshError: "No se pudieron actualizar los números: los anteriores están atenuados.",
          retry: "Intentar de nuevo",
        },
        editor: {
          titleNew: "Nuevo flujo",
          titleEdit: "Editar flujo",
          close: "Cerrar",
          name: "Nombre del flujo",
          namePlaceholder: "Ej.: Recuperación de clientes – Asistencia técnica",
          connection: "Conexión de la API oficial",
          chooseConnection: "Elige la conexión",
          connectionFirst: "Elige la conexión para ver las plantillas aprobadas.",
          count: "Cantidad de mensajes",
          countHint: "Contando el primero, enviado por el agente.",
          initial: "Plantilla inicial",
          initialHint: "El agente envía esta plantilla desde el chat; el flujo empieza cuando Meta acepta el envío.",
          chooseTemplate: "Elige la plantilla",
          loadingTemplates: "Cargando las plantillas aprobadas...",
          templatesError: "No se pudieron cargar las plantillas de esta conexión.",
          missingTemplate: "La plantilla \"{{name}}\" ya no está aprobada en esta conexión. Elige otra.",
          stepTitle: "Mensaje {{n}}",
          stepSubFirst: "Se envía si el cliente no responde al 1.er mensaje.",
          stepSubNext: "Se envía si el cliente sigue sin responder.",
          hours: "Horas sin respuesta",
          hoursHint: "Contadas desde el envío del mensaje anterior ({{min}} a {{max}}).",
          template: "Plantilla",
          templateHint: "Solo pueden enviarse solas las plantillas sin imagen, video o documento en el encabezado, sin variables en el encabezado o en el enlace y que no sean de autenticación.",
          sources: {
            contactFirstName: "Nombre de pila del contacto",
            contactName: "Nombre del contacto",
            companyName: "Nombre de la empresa",
            companyExample: "Asistencia",
            initial: "Valor del 1.er mensaje: {{var}}",
            initialExample: "[{{var}} del 1.er mensaje]",
            fixed: "Texto fijo",
          },
          window: "Horario de los envíos automáticos",
          windowHint: "Hora de Brasilia. El mensaje que venza fuera de este horario sale en la próxima apertura.",
          attribution: "Ventana de atribución (horas)",
          attributionHint: "Hasta cuántas horas después del último mensaje la respuesta del cliente cuenta para el flujo en el Dashboard ({{min}} a {{max}}).",
          activeLabel: "Flujo activo",
          preview: "Vista previa de la secuencia",
          previewFirst: "1.º · ahora, enviado por el agente",
          previewAfterFirst: "2.º · tras {{hours}} h sin respuesta",
          previewAfterNext: "3.º · tras {{hours}} h más sin respuesta",
          previewNoTemplate: "Elige la plantilla para ver el mensaje.",
          previewStop: "Si el cliente responde en cualquier momento, los próximos envíos se cancelan.",
          costNote: "Cada mensaje automático es una plantilla cobrada por Meta.",
          editNote: "Los cambios valen para los próximos abordajes. Los que están en curso siguen como empezaron; para detenerlos, desactiva el flujo.",
          cancel: "Cancelar",
          save: "Guardar",
          saving: "Guardando...",
          created: "Flujo creado.",
          saved: "Flujo guardado.",
          discardTitle: "¿Descartar los cambios?",
          discardText: "Los cambios hechos en este flujo no se guardaron.",
          discard: "Descartar",
          templateProblems: {
            authTemplate: "es de autenticación",
            namedVariable: "usa una variable con nombre",
            mediaHeader: "tiene imagen, video o documento en el encabezado",
            headerVariable: "tiene una variable en el encabezado",
            codeButton: "tiene un botón de código o de flujo",
            urlVariable: "tiene una variable en el enlace del botón",
          },
          problems: {
            name: "Ponle un nombre al flujo.",
            connection: "Elige la conexión.",
            initial: "Elige la plantilla inicial.",
            hours: "Mensaje {{n}}: las horas van de {{min}} a {{max}}.",
            template: "Mensaje {{n}}: elige la plantilla.",
            variable: "Mensaje {{n}}: elige el valor de la variable {{variable}}.",
            fixed: "Mensaje {{n}}: escribe el texto fijo de la variable {{variable}}.",
            days: "Marca al menos un día para los envíos automáticos.",
            window: "El horario de envío debe empezar antes de terminar.",
            attribution: "La ventana de atribución va de {{min}} a {{max}} horas.",
          },
        },
      },
      backendErrors: {
        ERR_AI_UNAVAILABLE: "La IA aún no está disponible en esta cuenta. Intenta de nuevo en unos minutos.",
        ERR_AI_KEY_REQUIRED: "Para usar la IA en esta Empresa, registra la clave de OpenAI en Integraciones o habla con Sttelar.",
        ERR_AI_TEXT_TOO_LONG: "El texto es demasiado largo para la IA. Acórtalo e inténtalo de nuevo.",
        ERR_AI_SETUP_INVALID_URL: "Revisa la dirección del sitio, como tuempresa.com.",
        ERR_AI_SETUP_DESCRIPTION_SHORT: "Cuenta un poco más sobre el negocio (al menos 40 caracteres).",
        ERR_AI_SETUP_TOO_MANY: "Demasiados intentos en esta hora. Intenta más tarde.",
        ERR_AI_SETUP_EMPTY: "No encontramos información en el sitio. Puedes describir el negocio.",
        ERR_AI_SETUP_BUSY: "La IA está ocupada ahora. Intenta de nuevo en un momento.",
        ERR_AI_SETUP_FAILED: "No se pudo armar la base ahora. Intenta de nuevo.",
        ERR_AI_SETUP_NOT_FOUND: "Esta preparación expiró. Empieza de nuevo.",
        ERR_AI_SETUP_INVALID_NAME: "El nombre de la IA debe tener de 2 a 60 caracteres.",
        ERR_AI_SETUP_KNOWLEDGE_SHORT: "La base quedó muy corta. Escribe un poco más.",
        ERR_AI_SETUP_KNOWLEDGE_LONG: "La base superó el tamaño máximo. Resúmela un poco.",
        ERR_AI_SETUP_AGENT_NOT_FOUND: "No encontramos este agente. Empieza de nuevo.",
        ERR_AI_SETUP_INVALID_SOURCE: "Elige el sitio o la descripción.",
        ERR_AI_SETUP_RUNNING: "Ya se está preparando una base en esta cuenta. Espera a que termine.",
        ERR_AI_SETUP_OTHER_FLOW: "Otro flujo activo ya atiende todas las conexiones de esta cuenta. Desactívalo en Flujos antes de activar la IA.",
        ERR_AI_SETUP_VERSION_NOT_FOUND: "No encontramos esta versión de la IA. Guarda de nuevo y pruébala antes de activarla.",
        ERR_TRIAGE_DISABLED: "El triaje con IA no está habilitado para esta empresa.",
        ERR_TRIAGE_ALREADY_ACTIVE: "Esta conversación ya tiene un triaje en curso.",
        ERR_TRIAGE_SESSION_NOT_FOUND: "Triaje no encontrado.",
        ERR_TRIAGE_DEFINITION_NOT_FOUND: "Triaje no encontrado.",
        ERR_TRIAGE_REQUIREMENT_NOT_FOUND: "Ítem del triaje no encontrado.",
        ERR_TRIAGE_VERSION_NOT_FOUND: "Versión del triaje no encontrada.",
        ERR_INVALID_ACTION: "Acción inválida.",
        ERR_INVALID_ID: "Identificador inválido.",
        ERR_SMART_APPROACH_CONNECTION: "Elige una conexión de la API oficial de esta empresa.",
        ERR_SMART_APPROACH_TEMPLATES_UNAVAILABLE: "No se pudieron leer las plantillas en Meta ahora. Inténtalo de nuevo en unos instantes.",
        ERR_SMART_APPROACH_NOT_FOUND: "Flujo no encontrado.",
        ERR_SMART_APPROACH_ACTIVE: "Esta conversación ya tiene un abordaje inteligente en curso. Cancélalo antes de enviar otra plantilla inteligente.",
        ERR_SMART_APPROACH_RUN_NOT_FOUND: "Abordaje no encontrado.",
        ERR_SMART_APPROACH_NOT_ACTIVE: "Este abordaje ya no tiene envíos pendientes.",
        ERR_SMART_APPROACH_TEMPLATE_IN_USE: "La plantilla inicial ya inicia otro flujo activo en esta conexión. Desactiva el otro primero.",
        ERR_INVALID_PARAMS: "Parámetros inválidos.",
        ERR_INVALID_SETTING_VALUE: "Valor inválido para esta configuración.",
        ERR_WORK_ORDER_NOT_FOUND: "Orden de servicio no encontrada.",
        ERR_TICKETNOTE_TOO_LONG: "La nota puede tener como máximo 255 caracteres.",
        ERR_TICKETNOTE_READ_ONLY: "La nota-resumen del triaje la escribe el sistema: no se puede editar ni eliminar.",
        ERR_TICKETNOTE_CONTACT_REQUIRED: "Indique el contacto de la nota.",
        ERR_SUPER_ONLY: "Solo los superadministradores pueden usar esta herramienta.",
        ERR_TICKET_CLOSE_DISABLED: "En esta empresa, solo los administradores pueden resolver conversaciones.",
        ERR_INVALID_TICKET_STATUS: "Estado de la conversación no válido.",
        ERR_INVALID_FILTERS: "Filtros inválidos. Revisa los estados y el período.",
        ERR_NOTHING_TO_DELETE: "No queda nada que eliminar con estos filtros — los datos cambiaron desde la vista previa.",
        ERR_NOTHING_TO_RESOLVE: "No queda nada que resolver con estos filtros — las conversaciones cambiaron desde la vista previa.",
        ERR_INVALID_PASSWORD: "Contraseña incorrecta.",
        ERR_INVALID_CONFIRMATION_PHRASE: "La frase de confirmación no coincide.",
        ERR_TOO_MANY_ATTEMPTS: "Demasiados intentos. Espera 15 minutos e inténtalo de nuevo.",
        ERR_TOO_MANY_AUTH_ATTEMPTS: "Demasiados intentos. Espera unos minutos e inténtalo de nuevo.",
        ERR_ACCOUNT_SETUP_PENDING: "Tu registro está listo, pero la configuración de la empresa todavía no fue liberada.",
        ERR_AUTH_LINK_INVALID: "Este enlace ya no es válido. Pide uno nuevo.",
        ERR_PASSWORD_TOO_SHORT: "La contraseña debe tener al menos 8 caracteres.",
        ERR_PASSWORD_TOO_LONG: "La contraseña es demasiado larga. Usa hasta 72 caracteres.",
        ERR_SIGNUP_DISABLED: "El registro de nuevas cuentas está cerrado por ahora.",
        ERR_SIGNUP_INVALID_NAME: "Escribe tu nombre completo.",
        ERR_INVALID_EMAIL: "Escribe un correo válido.",
        ERR_EMAIL_DOMAIN_NOT_FOUND: "Ese dominio de correo no existe. Revisa si lo escribiste bien.",
        ERR_EMAIL_DISPOSABLE: "Usa un correo que revises siempre, no uno temporal.",
        ERR_TERMS_NOT_ACCEPTED: "Para crear la cuenta, acepta los Términos de uso y la Política de privacidad.",
        ERR_META_NUMBER_IN_USE: "Ese número ya está vinculado a otra empresa. Habla con Sttelar.",
        ERR_AI_DAILY_LIMIT: "Llegaste al límite de uso de la IA por hoy en este recurso. Mañana se libera de nuevo.",
        ERR_EMAIL_ALREADY_EXISTS: "Ya existe una persona con este correo.",
        ERR_EMAIL_NOT_VERIFIED: "Confirma tu correo para hacer esto. Puedes reenviar el enlace desde el aviso en la parte superior.",
        ERR_MESSAGE_NOT_FOUND: "Mensaje no encontrado.",
        ERR_BOARD_NOT_FOUND: "Tablero no encontrado.",
        ERR_SHARE_NOT_FOUND: "Enlace no encontrado.",
        ERR_SHARE_EXPIRED: "Este enlace ya venció. Crea uno nuevo.",
        ERR_SHARE_REVOKED: "Este enlace fue revocado. Crea uno nuevo.",
        ERR_SHARE_NAME_REQUIRED: "Ponle un nombre al enlace.",
        ERR_SHARE_NAME_TOO_LONG: "El nombre del enlace puede tener hasta 80 caracteres.",
        ERR_SHARE_INVALID_EXPIRATION: "Fecha de validez inválida.",
        ERR_SHARE_EXPIRATION_TOO_SOON: "La validez debe ser de al menos 5 minutos a partir de ahora.",
        ERR_SHARE_EXPIRATION_TOO_LATE: "La validez puede ser de hasta 1 año. Para más, usa un enlace permanente.",
        ERR_SHARE_PASSWORD_REQUIRED: "Escribe la contraseña.",
        ERR_SHARE_PASSWORD_TOO_SHORT: "La contraseña debe tener al menos 8 caracteres.",
        ERR_SHARE_PASSWORD_TOO_LONG: "La contraseña es demasiado larga.",
        ERR_SHARE_INVALID_OPTION: "Opción inválida.",
        ERR_SHARE_LIMIT_REACHED: "Este tablero ya tiene 50 enlaces activos. Revoca alguno antes de crear otro.",
        ERR_SHARE_LINK_UNAVAILABLE: "Este enlace no se puede mostrar de nuevo. Genera un nuevo enlace.",
        ERR_SHARE_URL_UNAVAILABLE: "La dirección de la plataforma no está configurada. Habla con soporte.",
        ERR_LEAD_NOT_FOUND: "Tarjeta no encontrada.",
        ERR_LEAD_STATUS_NOT_FOUND: "Columna no encontrada.",
        ERR_STATUS_HAS_LEADS: "Esta columna todavía tiene tarjetas. Muévelas a otra columna antes de eliminarla.",
        ERR_ENTRY_COLUMN_CANNOT_BE_COMPLETED: "La columna de entrada de las tarjetas nuevas no puede ser de conclusión.",
        ERR_MFA_INVALID_OTP: "Código de verificación inválido.",
        ERR_ADMIN_OPERATION_IN_PROGRESS: "Ya hay una operación en curso en esta conexión.",
        ERR_ADMIN_OPERATION_NOT_FOUND: "Operación no encontrada.",
        ERR_ADMIN_OPERATION_NOT_ACTIVE: "Esta operación ya terminó.",
        ERR_ADMIN_OPERATION_NOT_RESUMABLE: "Solo se puede reanudar una operación que falló.",
        ERR_ADMIN_OPERATION_PREVIEW_EXPIRED: "La vista previa es demasiado antigua (más de 30 minutos).",
        ERR_QUEUE_UNAVAILABLE: "La cola de procesamiento no está disponible. Inténtalo de nuevo en unos instantes.",
        ERR_NO_ATTENDANCE_ACCESS: "Tu perfil no tiene acceso al módulo de Atención.",
        ERR_ACADEMY_DISABLED: "El Área de Capacitación está desactivada para esta empresa.",
        ERR_ACADEMY_INVALID_VIDEO_URL: "URL de video inválida. Usa un enlace de YouTube o Vimeo.",
        ERR_ACADEMY_COURSE_NOT_FOUND: "Curso no encontrado.",
        ERR_ACADEMY_MODULE_NOT_FOUND: "Módulo no encontrado.",
        ERR_ACADEMY_LESSON_NOT_FOUND: "Lección no encontrada.",
        ERR_INTERNAL_SERVER_ERROR: "Ocurrió un error inesperado. Por favor, intente nuevamente más tarde",
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
        ERR_NO_DEF_WAPP_FOUND: "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED: "Esta sesión de WhatsApp no fue inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT: "No fue posible verificar el contacto de WhatsApp. Verifique la página de conexiones",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de WhatsApp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA: "No fue posible descargar el archivo multimedia de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Usuario o contraseña incorrectos",
        ERR_COMPANY_DISABLED: "La empresa está desactivada, contacte al soporte de Sttelar para más detalles.",
        ERR_CANNOT_DISABLE_SYSTEM_COMPANY: "La empresa del sistema no puede ser desactivada.",
        ERR_USER_DONT_EXISTS: "Usuario no encontrado. Verifique el email proporcionado.",
        ERR_SENDING_WAPP_MSG: "Error al enviar mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No fue posible eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya existe un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor inicie sesión.",
        ERR_USER_CREATION_DISABLED: "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_WORKFLOW_NOT_FOUND: "Este flujo ya no existe.",
        ERR_AI_AGENT_NOT_FOUND: "Este agente ya no existe.",
        ERR_AI_AGENT_IN_USE: "Este agente atiende en algún flujo. Cambia el agente en esos flujos antes de eliminarlo.",
        ERR_AI_AGENT_INVALID_AI_USER: "Elige un usuario IA de esta empresa como agente de atención.",
        ERR_AI_AGENT_INVALID_REASONING: "Elige un nivel de razonamiento de la lista.",
        ERR_AI_AGENT_INVALID_STYLE: "Elige un estilo de respuesta de la lista.",
        ERR_WORKFLOW_NODE_NOT_AI_AGENT: "Este bloque no es de IA. Abre el flujo de nuevo e inténtalo otra vez.",
        ERR_WORKFLOW_NODE_HAS_AGENT: "Este bloque ya usa un agente.",
        ERR_AI_AGENT_CONVERT_INCOMPLETE: "Algún caso o archivo de este bloque no cabe completo en el agente. Revisa los casos y los archivos e inténtalo de nuevo.",
        ERR_WORKFLOW_AGENT_REQUIRED: "Para activar el flujo, elige el agente del bloque \"Agente IA\" o, en \"Personalizado\", escribe el texto.",
        ERR_WORKFLOW_AGENT_NOT_FOUND: "El agente elegido en el bloque \"Agente IA\" ya no existe. Elige otro.",
        ERR_SETUP_ALREADY_DONE: "Tu empresa ya fue creada. Entra de nuevo para continuar.",
        ERR_SETUP_INVALID_COMPANY_NAME: "Usa un nombre de empresa de 2 a 80 caracteres.",
        ERR_SETUP_INVALID_ACCOUNT_NAME: "Usa un nombre de cuenta de 2 a 80 caracteres.",
        ERR_SETUP_COMPANY_REQUIRED: "Primero dinos el nombre de la empresa.",
        ERR_SETUP_NOT_FOUND: "No hay una configuración en curso para esta cuenta.",
        ERR_SETUP_INVALID_STEP: "Ese paso de la configuración no existe.",
        ERR_INVITE_NO_COMPANY: "Tu cuenta no está en una Empresa. Habla con soporte.",
        ERR_INVITE_INVALID_ACCOUNTS: "Elige una cuenta de tu Empresa para la invitación.",
        ERR_INVITE_ALREADY_MEMBER: "Esta persona ya forma parte de la Empresa.",
        ERR_INVITE_ALREADY_PENDING: "Ya hay una invitación abierta para este correo. Reenvía la que está en la lista.",
        ERR_INVITE_NOT_FOUND: "Esta invitación ya no está en la lista. Actualiza la página.",
        ERR_INVITE_RESEND_TOO_SOON: "La invitación acaba de enviarse. Espera un minuto para reenviarla.",
        ERR_INVITE_INVALID: "Esta invitación ya no es válida. Pide una nueva a quien te invitó.",
        ERR_INVITE_OTHER_EMAIL: "Esta invitación es para otro correo. Entra con el correo de la invitación.",
        ERR_INVITE_PROFILE_MISMATCH: "Ya estás en esta Empresa con otro perfil. Pide a quien te invitó que revise tu acceso.",
        ERR_INVITE_LOGIN_REQUIRED: "Este correo ya tiene cuenta. Entra con él para aceptar la invitación.",
        ERR_INVALID_PROFILE: "Elige un perfil válido.",
        ERR_INVALID_ACCESS_SCOPE: "Elige una licencia válida.",
        ERR_BILLING_PERSON_TYPE: "Elige persona física o jurídica.",
        ERR_BILLING_NAME: "Escribe el nombre completo o la razón social.",
        ERR_BILLING_CPF: "CPF inválido.",
        ERR_BILLING_CNPJ: "CNPJ inválido.",
        ERR_BILLING_EMAIL: "Correo de facturación inválido.",
        ERR_BILLING_EMAIL_IN_USE: "Este correo de facturación ya lo usa otra empresa. Usa otro.",
        ERR_BILLING_PHONE: "Teléfono inválido: usa el código de área y el número.",
        ERR_BILLING_ZIP: "Código postal inválido.",
        ERR_BILLING_ADDRESS: "Completa la dirección, el número, el barrio y la ciudad.",
        ERR_BILLING_STATE: "Elige el estado.",
        ERR_BILLING_NO_COMPANY: "Esta cuenta no está en una Empresa.",
        ERR_BILLING_REDUCTION_LATER: "Para reducir el plan o las licencias, usa Reducir en la renovación.",
        ERR_BILLING_NOTHING_TO_CHANGE: "Elige qué aumentar.",
        ERR_BILLING_NO_SUBSCRIPTION: "La Empresa no tiene suscripción para cambiar.",
        ERR_BILLING_NO_SAVED_CARD: "La suscripción no tiene tarjeta guardada: paga con Pix o boleto.",
        ERR_BILLING_STARTER_CHANGE_LATER: "Para pasar del Starter con Chat Interno a Basic o Pro, habla con el soporte.",
        ERR_BILLING_TOO_MANY_ATTEMPTS: "Demasiados intentos de contratación hoy. Intenta de nuevo mañana o habla con el soporte.",
        ERR_BILLING_DISABLED: "La facturación no está disponible en este momento. Intenta más tarde.",
        ERR_BILLING_INVALID_PAYMENT_METHOD: "Elige una forma de pago válida.",
        ERR_BILLING_CARD_TOKEN: "Revisa los datos de la tarjeta.",
        ERR_BILLING_NOT_ON_PLANS: "La facturación de esta Empresa la hace el soporte de Sttelar.",
        ERR_BILLING_COURTESY: "La Empresa está en cortesía y no se le cobra.",
        ERR_BILLING_ALREADY_SUBSCRIBED: "La Empresa ya tiene un plan contratado. Para cambiarlo, habla con el soporte.",
        ERR_BILLING_NOTHING_TO_CHARGE: "Elige qué contratar.",
        ERR_BILLING_BOLETO_MINIMUM: "Boleto solo desde R$ 50,00. Elige otra forma de pago.",
        ERR_BILLING_REDUCTION_BOLETO_MINIMUM: "Con boleto, la mensualidad no baja de R$ 50,00: quedarse solo con el Chat Interno es con tarjeta. Habla con el soporte de Sttelar, o cancela el plan.",
        ERR_BILLING_PROFILE_REQUIRED: "Completa los datos de facturación antes de contratar.",
        ERR_BILLING_GATEWAY: "Pagar.me no respondió. Intenta de nuevo en un momento.",
        ERR_BILLING_REQUEST_OPEN: "Ya hay un pedido esperando el pago.",
        ERR_BILLING_RESUME_PENDING: "Estamos revisando el pedido para deshacer la cancelación. Inténtalo de nuevo en unos minutos.",
        ERR_BILLING_CARD_REJECTED: "La tarjeta no fue aceptada. Revisa los datos o usa otra tarjeta.",
        ERR_BILLING_REQUEST_NOT_FOUND: "Pedido no encontrado.",
        ERR_BILLING_ALREADY_PAID: "Este pedido ya se pagó y el plan ya cambió.",
        ERR_BILLING_RENEWING: "La renovación del plan está cerca. Intenta de nuevo después de ella.",
        ERR_BILLING_BOLETO_TOO_LATE: "Faltan menos de 10 días para la renovación: paga con tarjeta o Pix.",
        ERR_BILLING_QUOTE_CHANGED: "El valor cambió desde el cálculo. Revísalo y paga de nuevo.",
        ERR_BILLING_PAYMENT_PENDING: "Hay una mensualidad pendiente. Regulariza el pago antes de cambiar o cancelar el plan.",
        ERR_BILLING_REQUEST_CREATING: "Todavía estamos verificando este pedido. Espera unos minutos antes de desistir.",
        ERR_BILLING_CONTRACT_MISMATCH: "El contrato de la empresa fue ajustado por el soporte. Para cambiar el plan, habla con el soporte de Sttelar.",
        ERR_BILLING_REDUCTION_SCHEDULED: "Hay una reducción programada para la renovación. Deshazla para cambiar el plan ahora.",
        ERR_BILLING_INCREASE_IS_CHANGE: "Para aumentar, usa Cambiar plan.",
        ERR_BILLING_REDUCTION_NOT_CHEAPER: "Esta reducción no baja la mensualidad (el precio del plan cambió). Habla con el soporte de Sttelar.",
        ERR_BILLING_UNKNOWN_ITEM: "La suscripción fue ajustada en Pagar.me fuera de Sttelar Talk. Habla con el soporte de Sttelar.",
        ERR_BILLING_DUPLICATE_ITEM: "La suscripción tiene un ítem repetido en Pagar.me. Habla con el soporte de Sttelar.",
        ERR_BILLING_REQUEST_CLOSED: "Este pedido ya está cerrado.",
        ERR_BILLING_INVALID_PLAN: "Elige Basic o Pro.",
        ERR_BILLING_INVALID_SEATS: "Número de licencias inválido.",
        ERR_BILLING_INVALID_INTERNAL_CHAT: "Número de licencias de Chat Interno inválido.",
        ERR_BILLING_INVALID_AI_PACK: "Elige uno de los paquetes de IA.",
        ERR_BILLING_AI_PACK_NOT_ALLOWED: "El paquete de IA es de Basic y Pro.",
        ERR_COMPANY_REQUIRED: "Elige la cuenta.",
        ERR_NO_COMPANY_ACCESS: "Ya no tienes acceso a esta cuenta. Recarga la página.",
        ERR_USER_NOT_FOUND: "Usuario no encontrado.",
        ERR_WORKFLOW_EXECUTION_NOT_FOUND: "Esta ejecución ya no existe.",
        ERR_WORKFLOW_DESCRIPTION_TOO_LONG: "La descripción supera las 500 letras.",
        ERR_TRACK_LINK_HOSTS_REQUIRED: "Indica al menos un sitio para rastrear los enlaces.",
        ERR_INVALID_TRACK_LINK_HOSTS: "Uno de los sitios no es válido. Usa el formato mitienda.com.",
        ERR_TOO_MANY_TRACK_LINK_HOSTS: "Son como máximo 20 sitios rastreados por flujo.",
        ERR_INVALID_CONVERSION_SOURCE: "Esta tienda no está disponible para el flujo.",
        ERR_CONVERSION_SOURCE_EXISTS: "Esta tienda ya tiene una dirección de webhook.",
        ERR_CONVERSION_SOURCE_NOT_FOUND: "Tienda no encontrada.",
        ERR_INTEGRATION_NOT_FOUND: "Integración no encontrada.",
        ERR_INTEGRATION_REQUIRED: "Elige la tienda.",
        ERR_INVALID_LANGUAGE: "Idioma no válido: elija portugués, inglés o español.",
        ERR_NO_PERMISSION: "No tiene permiso para acceder a este recurso.",
        ERR_USER_IN_OTHER_COMPANIES: "Esta persona también está en otra empresa que usted no administra.",
        ERR_ACCESS_UNAVAILABLE: "No fue posible verificar su acceso ahora. Inténtelo de nuevo en unos instantes.",
        ERR_ACCESS_OWN: "Nadie puede cambiar su propio acceso. Pídaselo a otro Administrador.",
        ERR_ACCESS_IMPERSONATING: "No se pueden cambiar accesos mientras usa \"Acceder como\" un usuario.",
        ERR_ACCESS_TARGET_ABOVE: "Esta persona tiene más acceso que usted, por eso no puede cambiarla.",
        ERR_ACCESS_GRANT_ABOVE: "Solo puede dar los permisos que usted también tiene.",
        ERR_ACCESS_NO_HOME: "La persona necesita mantener las conversaciones o el chat interno.",
        ERR_ACCESS_LAST_ADMIN: "La empresa necesita al menos un Administrador. Defina otro antes.",
        ERR_NO_EMPRESA: "Esta cuenta no forma parte de una empresa con otras cuentas.",
        ERR_INVALID_DEPARTMENT: "Complete el nombre y elija al menos una cuenta.",
        ERR_DEPARTMENT_NOT_FOUND: "Departamento no encontrado.",
        ERR_DEPARTMENT_NAME_TAKEN: "Ya existe un departamento con ese nombre.",
        ERR_COMPANY_NAME_ALREADY_EXISTS: "Ya existe una cuenta con ese nombre.",
        ERR_COMPANY_GROUP_INVALID_NAME: "El nombre de la empresa debe tener de 2 a 255 caracteres.",
        ERR_COMPANY_GROUP_NOT_FOUND: "Empresa no encontrada.",
        ERR_COMPANY_GROUP_NAME_TAKEN: "Ya existe otra empresa con ese nombre.",
        ERR_COMPANY_GROUP_STANDALONE: "Cuenta sin empresa con nombre: su nombre es el de la cuenta. Edite la cuenta.",
        ERR_PLAN_LIMIT_USERS: "El plan de la empresa llegó al límite de usuarios.",
        ERR_PLAN_LIMIT_INTERNAL_CHAT: "El plan de la empresa llegó al límite de usuarios con Chat Interno.",
        ERR_PLAN_LIMIT_ACCOUNTS: "El plan de la empresa llegó al límite de cuentas.",
        ERR_PLAN_LIMIT_WHATSAPPS: "El plan de la empresa llegó al límite de números de WhatsApp.",
        ERR_PLAN_LIMIT_CRM_BOARDS: "El plan de la empresa llegó al límite de tableros del CRM.",
        ERR_MESSAGE_SEND_IN_PROGRESS: "Este mensaje ya se está enviando.",
        ERR_MESSAGE_QUOTA_COMMON: "Los mensajes del mes se acabaron. El envío vuelve cuando el ciclo se renueve o el plan aumente; habla con el administrador.",
        ERR_MESSAGE_QUOTA_AI: "Los mensajes de la IA del mes se acabaron. La IA vuelve cuando el ciclo se renueve o el paquete aumente.",
        ERR_COMMERCIAL_REASON_REQUIRED: "Escriba el motivo (al menos 3 letras).",
        ERR_COMMERCIAL_INVALID_PLAN: "Plan inválido.",
        ERR_COMMERCIAL_INVALID_MODE: "Elija cómo funcionan los límites.",
        ERR_COMMERCIAL_MODE_WITHOUT_PLAN: "Elija un plan para activar los límites.",
        ERR_COMMERCIAL_INVALID_SEATS: "Licencias contratadas por debajo del mínimo del plan.",
        ERR_COMMERCIAL_INVALID_INTERNAL_CHAT: "Número de licencias de Chat Interno inválido.",
        ERR_COMMERCIAL_INVALID_AI_PACK: "Paquete de IA inválido.",
        ERR_COMMERCIAL_AI_PACK_NOT_ALLOWED: "Este plan no tiene paquete de IA. Para dar más IA, conceda una excepción.",
        ERR_COMMERCIAL_INVALID_DATES: "Fechas inválidas: el fin debe ser después del inicio y de hoy.",
        ERR_COMMERCIAL_INVALID_ITEM: "Elija qué cambia la excepción.",
        ERR_COMMERCIAL_INVALID_VALUE: "Valor no válido.",
        ERR_COMMERCIAL_INVALID_USER: "Elija una persona de esta empresa.",
        ERR_COMMERCIAL_KIND_NOT_AVAILABLE: "Este tipo de excepción aún no está disponible.",
        ERR_COMMERCIAL_EXCEPTION_NOT_FOUND: "Excepción no encontrada.",
        ERR_COMMERCIAL_EXCEPTION_REVOKED: "Esta excepción ya fue revocada.",
        ERR_DEPARTMENT_ACCOUNT_TAKEN: "Una de las cuentas ya está en otro departamento.",
        ERR_DEPARTMENT_INVALID_ACCOUNT: "Elija solo cuentas de esta empresa.",
        ERR_DEPARTMENT_INVALID_VIEWER: "Elija solo personas de esta cuenta.",
        ERR_DEPARTMENT_WITHOUT_ACCOUNTS: "Este departamento no tiene cuentas activas.",
        ERR_ACCESS_CHANGED: "Otra persona acaba de cambiar este acceso. Recargue e inténtelo de nuevo.",
        ERR_ACCESS_INVALID: "Los datos del acceso no son válidos. Recargue la página e inténtelo de nuevo.",
        ERR_ACCESS_ADMIN_ONLY: "Este permiso es solo del perfil Administrador.",
        ERR_CANNOT_REMOVE_ACTIVE_COMPANY: "No se puede eliminar la Cuenta activa del usuario. Defina otra Cuenta como principal primero.",
        ERR_COMPANY_NOT_ASSIGNED: "Esta Cuenta no está vinculada al usuario.",
        ERR_COMPANY_ALREADY_ASSIGNED: "Esta Cuenta ya está vinculada al usuario.",
        ERR_COMPANY_NOT_IN_GROUP: "La Cuenta debe pertenecer a la misma Empresa que el usuario.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_CONTACT_NOT_SHAREABLE: "Este contacto no tiene un número de teléfono que se pueda enviar.",
        ERR_CONTACT_SEND_UNSUPPORTED: "Esta conexión no envía tarjetas de contacto.",
        ERR_SEND_CONTACT: "No se pudo enviar el contacto. Inténtalo de nuevo.",
        ERR_NO_SETTING_FOUND: "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró ningún WhatsApp con este ID.",
        ERR_TICKET_NO_CONNECTION: "Este ticket no tiene una conexión WhatsApp definida. Seleccione una conexión antes de resolver.",
        ERR_CREATING_MESSAGE: "Error al crear mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG: "Error al buscar el mensaje en WhatsApp, tal vez sea muy antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED: "El mensaje de saludo es obligatorio cuando hay más de una cola.",
        ERR_BILLING_CANCELLATION_SCHEDULED: "Hay una cancelación programada. Deshazla para cambiar el plan.",
        ERR_BILLING_SUBSCRIPTION_NOT_STARTED: "La suscripción reanudada aún no empezó. Cuando empiece, se puede cambiar el plan.",
        ERR_BILLING_CARD_UNAVAILABLE: "La tarjeta registrada no está disponible. Habla con el soporte de Sttelar para seguir en el plan.",
        ERR_BILLING_RESUME_CANCELED: "La suscripción nueva se canceló en Pagar.me. Habla con el soporte de Sttelar para seguir en el plan.",
        ERR_SENDING_SUSPENDED: "El envío de mensajes está suspendido por un pago pendiente. El pago se hace en Facturación, por quien administra la empresa.",
        ERR_BILLING_PAYMENT_PROCESSING: "El pago con tarjeta está en análisis. Espera unos minutos y actualiza.",
        ERR_BILLING_OVERDUE_CARD_REFUSED: "La tarjeta fue rechazada de nuevo. Paga con Pix.",
        ERR_BILLING_DISPUTE_OUTCOME: "Elige el resultado: ganada o perdida.",
        ERR_BILLING_DISPUTE_NOT_FOUND: "Contestación no encontrada en esta empresa.",
        ERR_BILLING_DISPUTE_RESOLVED: "Esta contestación ya tiene resultado.",
        ERR_INTERNAL_CHAT_SUSPENDED: "El Chat Interno está suspendido por un pago pendiente. Habla con el administrador de la empresa.",
        ERR_BILLING_OVERDUE_IN_PROGRESS: "El pago de la factura vencida ya se está preparando. Espera un momento.",
        ERR_BILLING_NOT_OVERDUE: "No hay factura vencida para pagar.",
        ERR_BILLING_OVERDUE_BOLETO_SETTLING: "El boleto aún puede estar en confirmación (hasta 3 días hábiles). Si no lo pagaste, usa su línea digitable.",
        ERR_BILLING_OVERDUE_CANCEL_FAILED: "No se pudo preparar el Pix ahora. Intenta de nuevo en unos minutos.",
        ERR_BILLING_NOTHING_TO_RETRY: "No hay factura rechazada en la tarjeta para intentar de nuevo.",
        ERR_BILLING_NOT_SUSPENDED: "La empresa no está suspendida.",
        ERR_BILLING_REFUND_REASON: "Cuente el motivo del reembolso (al menos 10 caracteres).",
        ERR_BILLING_REFUND_CHARGE: "Cobro no encontrado en esta empresa.",
        ERR_BILLING_REFUND_NOT_PAID: "Solo un cobro pagado, sin disputa en la tarjeta, puede reembolsarse.",
        ERR_BILLING_REFUND_AMOUNT: "El valor supera lo que aún puede reembolsarse de este cobro.",
        ERR_BILLING_REFUND_OPEN: "Ya hay un pedido de reembolso en curso para este cobro.",
        ERR_BILLING_REFUND_DECISION: "Elija: rechazar, aprobar como corrección o como anulación.",
        ERR_BILLING_REFUND_NOT_FOUND: "Pedido de reembolso no encontrado en esta empresa.",
        ERR_BILLING_REFUND_DECIDED: "Este pedido de reembolso ya fue decidido.",
        ERR_BILLING_REFUND_FAILED: "Pagar.me no hizo el reembolso ahora. El pedido sigue aprobado: intente de nuevo.",
        ERR_BILLING_REFUND_NOT_APPROVED: "Este reembolso no está aprobado esperando la devolución.",
        ERR_COMMERCIAL_INVALID_KIND: "Tipo de excepción no válido.",
        ERR_BILLING_REFUND_MISMATCH: "El valor reembolsado en Pagar.me no coincide con el pedido. Revíselo allí; luego, márquelo como hecho o deshaga la aprobación.",
        ERR_BILLING_REFUND_ALREADY_SENT: "Pagar.me ya reembolsó (o está reembolsando) este cobro: use \"Intentar de nuevo\" para verificar.",
        ERR_ADEQUACY_INVALID: "La elección llegó incompleta. Ábrela de nuevo e inténtalo otra vez.",
        ERR_ADEQUACY_UNKNOWN_ITEM: "Algo cambió desde que se abrió la pantalla. Abre la elección de nuevo.",
        ERR_ADEQUACY_SELF: "No puedes quitarte a ti mismo.",
        ERR_ADEQUACY_NO_ACCOUNT: "Al menos una cuenta debe quedar.",
        ERR_ADEQUACY_USER_WITHOUT_ACCOUNT: "Quien queda necesita acceso a una cuenta que queda.",
        ERR_ADEQUACY_NO_ADMIN: "Al menos un administrador debe quedar.",
        ERR_ADEQUACY_INTERNAL_ONLY: "Quien solo usa el Chat Interno no puede quedarse sin él: quita a la persona o mantén el Chat Interno.",
        ERR_ADEQUACY_SHARED_PERSON: "Esta persona también está en otra empresa: su Chat Interno no cambia aquí.",
        ERR_ADEQUACY_OVER_LIMIT: "La elección aún supera los límites del plan.",
        ERR_ADEQUACY_CHANGED: "La situación cambió desde que se abrió la elección. Ábrala de nuevo para ver lo que vale ahora.",
        ERR_HISTORY_INVALID_TOPIC: "Tema del historial no válido.",
        ERR_HISTORY_INVALID_PAGE: "Página del historial no válida.",
        ERR_ADEQUACY_NOT_NEEDED: "No hay qué elegir ahora.",
        ERR_ARCHIVE_NOT_FOUND: "Este elemento ya no está archivado.",
        ERR_ARCHIVE_ACCOUNT_INACTIVE: "La cuenta de este elemento está archivada: restaura la cuenta antes.",
        ERR_ARCHIVE_USER_WITHOUT_ACCOUNT: "Esta persona no tiene acceso a una cuenta en uso: restaura su cuenta antes.",
        ERR_PLAN_ADEQUACY_REQUIRED: "Acceso restringido: el administrador debe elegir, en Facturación, lo que queda en el plan.",
        ERR_WHATSAPP_ARCHIVED: "Este número se archivó al adecuarse al plan y no envía mensajes.",
        ERR_ACCOUNT_ARCHIVED: "Esta cuenta se archivó al adecuarse al plan. Habla con el administrador de tu empresa.",
        ERR_MEMBER_ARCHIVED: "Tu acceso a esta empresa se archivó al adecuarse al plan. Habla con el administrador.",
      },
      internalChat: {
        jobRoleRequired: {
          title: "Seleccione su cargo",
          intro: "Para usar el Chat Interno, elija el cargo que mejor representa su función en la empresa. Aparecerá junto a su nombre en las conversaciones.",
          empty: "Ningún cargo registrado. Pida al administrador que registre cargos en Configuración → Cargos.",
          confirm: "Confirmar",
          saving: "Guardando...",
          toastSaved: "Cargo definido",
        },
      },
    }
  }
};

export { messages };
